export default {
  translation: {

    // App
    'apartment_system': 'Apartment Management System',
    'apartment_management': 'Apartment Management',
    'building_management': 'Building Management',

    // Navigation - updated
    'dashboard': 'Dashboard',
    'user_management': 'User Management',
    'building_management': 'Building Management',
    'apartment_management': 'Apartment Management',
    'owner_management': 'Owner Management',
    'tenant_management': 'Tenant Management',
    'payment_management': 'Payment Management',
    'service_management': 'Service Management',
    'report_management': 'Reports & Analytics',
    'log_management': 'Activity Logs',

    // Buildings
    'buildings': 'Buildings',
    'building_list': 'Building List',
    'add_building': 'Add Building',
    'edit_building': 'Edit Building',
    'building_details': 'Building Details',
    'building_name': 'Building Name',
    'building_address': 'Address',
    'total_floors': 'Total Floors',
    'total_apartments': 'Total Apartments',
    'switch_building': 'Switch Building',

    // Apartments (renamed from Properties)
    'apartments': 'Apartments',
    'apartment_list': 'Apartment List',
    'add_apartment': 'Add Apartment',
    'add_your_first_apartment': 'Add your first apartment',
    'edit_apartment': 'Edit Apartment',
    'apartment_details': 'Apartment Details',
    'apartment_number': 'Apartment Number',
    'apartment_display': 'Room {{number}}',
    'apt': 'Apt',
    'floor_number': 'Floor Number',
    'floor_display': 'Floor {{number}}',
    'monthly_rent': 'Monthly Rent',
    'apartment_status': 'Status',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'under_maintenance': 'Under Maintenance',
    'key_status': 'Key Status',
    'at_office': 'At Office',
    'with_tenant': 'With Tenant',
    'with_maintenance': 'With Maintenance',
    'lost': 'Lost',
    'key_handover': 'Key Handover',
    'give_out_keys': 'Give Out Keys',
    'return_keys': 'Return Keys',
    'keys': 'Keys',
    'remotes': 'Remotes',
    'fobs': 'Fobs',
    'possession_date': 'Possession Date',
    'key_details': 'Key Details',
    'key_history': 'Key History',
    'record_handover': 'Record Handover',
    'confirm_and_record': 'Confirm Handover',
    'add_notes': 'Add any additional notes here...',
    'no_key_history': 'No key handover history found.',
    'loading_history': 'Loading history...',
    'by': 'by',
    'warning_handover_no_tenant': 'Recording handover without an associated tenant.',
    'key_handover_success': 'Key handover recorded successfully',
    'failed_to_record_handover': 'Failed to record key handover',
    'failed_to_load_history': 'Failed to load key history',
    'key_management': 'Key Management',
    'manage_keys': 'Manage Keys',
    'total_handovers': 'Total Events',
    'given_out': 'Given Out',
    'returned': 'Returned',
    'currently_out': 'Currently Out',

    // Services
    'services': 'Services',
    'service_payments': 'Service Payments',
    'generate_services': 'Generate Service Payments',
    'service_statistics': 'Service Statistics',
    'service_type': 'Service Type',
    'service_amount': 'Amount',
    'service_date': 'Service Date',
    'service_status': 'Payment Status',
    'service_paid': 'Paid',
    'service_unpaid': 'Unpaid',
    'total_service_fees': 'Total Service Fees',

    // Reports - updated
    'revenue_report': 'Revenue Report',
    'payment_logs': 'Payment Logs',
    'occupancy_report': 'Occupancy Report',
    'monthly_payments_report': 'Monthly Payments Report',
    'monthly_payments_subtitle': 'Consolidated view of tenant rent and service payments',
    'all_paid': 'All paid',
    'try_adjusting_filters': 'Try adjusting the month, year, or filters',
    'pending': 'pending',
    'total': 'Total',
    'print_receipt': 'Print Receipt',
    'monthly_revenue': 'Monthly Revenue',
    'building_revenue': 'Building Revenue',
    'owner_revenue': 'Owner Revenue',
    'paid_until': 'Paid Until',
    'tenant_payments': 'Tenant Payment Status',
    'next_billing_date': 'Next Billing Date',
    'current_tenant': 'Current Tenant',
    'future_tenant_upcoming': 'Future Tenant',

    // Logs
    'activity_logs': 'Activity Logs',
    'all_user_activities': 'All User Activities',
    'all_user_activities_desc': 'View all user activities and changes',
    'tenant_logs': 'Tenant History',
    'tenant_activity_desc': 'View all tenant-related activities',
    'revenue_by_user': 'Revenue By User',
    'monthly_revenue_by_user': 'Monthly Revenue by User',
    'revenue_breakdown_desc': 'View revenue breakdown by user for a specific month',


    // Common
    'loading': 'Loading...',
    'save': 'Save',
    'cancel': 'Cancel',
    'edit': 'Edit',
    'delete': 'Delete',
    'add': 'Add',
    'view': 'View',
    'search': 'Search',
    'filter': 'Filter',
    'actions': 'Actions',
    'status': 'Status',
    'time': 'Time',
    'entity': 'Entity',
    'details': 'Details',
    'amount': 'Amount',
    'search_logs': 'Search logs...',
    'filter_activities': 'Filter Activities',
    'action_type': 'Action Type',
    'entity_type': 'Entity Type',
    'apply_filter': 'Apply Filter',
    'entries': 'entries',
    'no_logs_matching_search': 'No logs matching your search criteria',
    'no_logs_available': 'No activity logs available',
    'showing_range': 'Showing {{start}} to {{end}} of {{total}} entries',
    'previous': 'Previous',
    'next': 'Next',
    'select_month': 'Select Month',
    'payment_count': 'Payment Count',
    'total_amount': 'Total Amount',
    'percentage': 'Percentage',
    'no_revenue_data': 'No revenue data available for this month',
    'january': 'January',
    'february': 'February',
    'march': 'March',
    'april': 'April',
    'may': 'May',
    'june': 'June',
    'july': 'July',
    'august': 'August',
    'september': 'September',
    'october': 'October',
    'november': 'November',
    'december': 'December',
    'notification_log': 'Notification Log',
    'all_notifications': 'All Notifications',
    'all_channels': 'All Channels',
    'all_statuses': 'All Statuses',
    'all_recipients': 'All Recipients',
    'sent_at': 'Sent At',
    'template_subject': 'Template / Subject',
    'email_templates': 'Email Templates',
    'active_templates_count_one': 'One active template',
    'active_templates_count_other': '{{count}} active templates',
    'new_template': 'New Template',
    'test_email_placeholder': 'Test email address (used for all send-test buttons)',
    'no_email_templates': 'No email templates yet',
    'create_first_template': 'Create First Template',
    'rent_due': 'Rent Due',
    'late_payment': 'Late Payment',
    'lease_renewal': 'Lease Renewal',
    'lease_expiry': 'Lease Expiry',
    'move_in': 'Move-In',
    'move_out': 'Move-Out',
    'violation': 'Violation',
    'maintenance': 'Maintenance',
    'inspection': 'Inspection',
    'owner_payout': 'Owner Payout',
    'email_template_form_desc': 'Design automated emails for your tenants and owners',
    'update_template': 'Update Template',
    'create_template': 'Create Template',
    'visual': 'Visual',
    'html': 'HTML',
    'live_preview': 'Live Preview',
    'subject_line': 'Subject Line',
    'email_content': 'Email Content',
    'event_trigger': 'Event Trigger',
    'internal_name': 'Internal Name',
    'dynamic_tags': 'Dynamic Tags',
    'starter_templates': 'Starter Templates',
    'starter_templates_desc': 'Pick a baseline to start designing faster',
    'apply_design': 'Apply Design',
    'payment_settings': 'Payment Settings',
    'accept_online_payments': 'Accept Online Payments',
    'stripe_connect_desc': 'Connect your Stripe account to enable tenants to pay rent directly through the portal. Funds are deposited directly into your bank account, and our system tracks everything automatically.',
    'why_stripe_connect': 'Why use Stripe Connect?',
    'stripe_benefit_1': 'Automated rent collection & tracking',
    'stripe_benefit_2': 'Direct deposits to your bank account',
    'stripe_benefit_3': 'Secure PCI-compliant processing',
    'stripe_benefit_4': 'Platform-fee splitting support',
    'start_stripe_onboarding': 'Start Stripe Onboarding',
    'stripe_account_status': 'Stripe Account Status',
    'active_verified': 'Active & Verified',
    'pending_onboarding': 'Action Required: Pending Onboarding',
    'complete_setup': 'Complete Setup',
    'payments_enabled': 'Payments Enabled',
    'payouts_enabled': 'Payouts Enabled',
    'account_id': 'Account ID',
    'payment_configuration': 'Payment Configuration',
    'platform_fee_type': 'Platform Fee Type',
    'no_fee_direct': 'No Fee (Direct Payment)',
    'percentage_soon': 'Percentage (Coming soon)',
    'fixed_soon': 'Fixed Amount (Coming soon)',
    'platform_fee_disabled': 'QuadCores platform fee is currently disabled for your organization.',
    'yes': 'Yes',
    'no': 'No',
    'general_settings': 'General Settings',
    'enable_whatsapp_notifications': 'Enable WhatsApp Notifications',
    'whatsapp_enable_desc': 'Turn all automated WhatsApp messages on or off',
    'default_country_code': 'Default Country Code',
    'default_message_language': 'Default Message Language',
    'rent_reminder': 'Rent Reminder',
    'enable_rent_reminders': 'Enable Rent Reminders',
    'rent_reminders_desc': 'Send to tenants with overdue or upcoming rent payments',
    'days_before_due': 'Days Before Due',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminders': 'Enable Service Fee Reminders',
    'service_fee_reminders_desc': 'Notify tenants and resident owners about unpaid service charges',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminders_desc': 'Alert property owners when tenants have overdue payments',
    'payment_confirmation': 'Payment Confirmation',
    'send_payment_confirmation': 'Send Payment Confirmation',
    'payment_confirmation_desc': 'Automatically notify tenant via WhatsApp when a payment is recorded',
    'sms_twilio': 'SMS (Twilio)',
    'enable_sms_notifications': 'Enable SMS Notifications (Twilio)',
    'sms_enable_desc': 'Turn all automated SMS messages on or off',
    'sender': 'Sender',
    'send_test_sms': 'Send Test SMS',
    'test_sms_desc': 'Verify your Twilio integration by sending a test message to any phone number.',
    'phone_number': 'Phone Number',
    'send_test': 'Send Test',
    'preview_reminders': 'Preview Reminders',
    'confirm_send_all': 'Confirm & Send All',
    'notification_settings': 'Notification Settings',
    'notification_settings_desc': 'Configure WhatsApp and SMS reminders for tenants and owners',
    'preview_send': 'Preview & Send',
    'save_settings': 'Save Settings',
    'failed_load_notification_settings': 'Failed to load notification settings',
    'settings_saved': 'Settings saved',
    'settings_save_failed': 'Save failed',
    'preview_failed': 'Preview failed',
    'reminders_sent': 'Reminders sent',
    'no_pending_reminders': 'No pending reminders at this time.',
    'recipient_pending': 'recipient(s) pending',
    'confirm_replace_content': 'This will replace your current content. Continue?',
    'applied_template': 'Applied {{name}} template',
    'whatsapp': 'WhatsApp',
    'on': 'ON',
    'off': 'OFF',
    'sms_twilio': 'SMS (Twilio)',
    'via_twilio': 'via Twilio',
    'sender': 'Sender',
    'no_recipients_match': 'No recipients match the current settings and active data.',
    'enable_whatsapp_notifications': 'Enable WhatsApp Notifications',
    'whatsapp_enable_desc': 'Turn all automated WhatsApp messages on or off',
    'enable_sms_notifications': 'Enable SMS Notifications (Twilio)',
    'sms_enable_desc': 'Turn all automated SMS messages on or off',
    'rent_reminder': 'Rent Reminder',
    'enable_rent_reminders': 'Enable Rent Reminders',
    'rent_reminders_desc': 'Send to tenants with overdue or upcoming rent payments',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminders': 'Enable Service Fee Reminders',
    'service_fee_reminders_desc': 'Notify tenants and resident owners about unpaid service charges',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminders_desc': 'Alert property owners when tenants have overdue payments',
    'payment_confirmation': 'Payment Confirmation',
    'send_payment_confirmation': 'Send Payment Confirmation',
    'payment_confirmation_desc': 'Automatically notify tenant via WhatsApp when a payment is recorded',
    'send_test_sms': 'Send Test SMS',
    'test_sms_desc': 'Verify your Twilio integration by sending a test message to any phone number.',
    'phone_number': 'Phone Number',
    'sms_sent_to': 'SMS sent to {{to}}',
    'sms_failed': 'SMS failed',
    'enter_phone_number': 'Enter a phone number first',
    'whatsapp_enable': 'Enable WhatsApp Notifications',
    'whatsapp_enable_sub': 'Turn all automated WhatsApp messages on or off',
    'default_message_language': 'Default Message Language',
    'english': 'English',
    'arabic': 'Arabic',
    'french': 'French',
    'german': 'German',
    'italian': 'Italian',
    'spanish': 'Spanish',
    'kurdish': 'Kurdish',
    'general_settings': 'General Settings',
    'days_before_due': 'Days Before Due',
    'webhooks': 'Webhooks',
    'webhooks_desc': 'Push events to your systems when things happen in APS',
    'add_endpoint': 'Add Endpoint',
    'failed_load_webhooks': 'Failed to load webhooks',
    'failed_load_deliveries': 'Failed to load deliveries',
    'failed_update': 'Failed to update',
    'failed_delete': 'Failed to delete',
    'deleted': 'Deleted',
    'rotate_secret_confirm': 'Rotate secret? Your client must update its verification logic.',
    'secret_rotated': 'Secret rotated — save it now, it won\'t be shown again',
    'failed_rotate': 'Failed to rotate',
    'copied_to_clipboard': 'Copied to clipboard',
    'no_webhooks_yet': 'No webhook endpoints yet',
    'no_webhooks_desc': 'Add one to start receiving events.',
    'failures': 'failures',
    'recent_deliveries': 'Recent Deliveries',
    'no_deliveries_yet': 'No deliveries yet.',
    'event': 'Event',
    'http': 'HTTP',
    'duration': 'Duration',
    'sent_at': 'Sent At',
    'delete_webhook_confirm': 'Delete webhook to {{url}}?',
    'rotate_secret': 'Rotate secret',
    'disable': 'Disable',
    'enable': 'Enable',
    'ok_200': '200 OK',
    'failed': 'Failed',
    'uploading': 'Uploading...',
    'save_changes': 'Save Changes',
    'contact_email': 'Contact Email',
    'contact_phone': 'Contact Phone',
    'office_address': 'Office Address',
    'organization_logo': 'Organization Logo',
    'failed_to_load_system_data': 'Failed to load system data',
    'logo_upload_success': 'Logo uploaded successfully',
    'error_uploading_logo': 'Error uploading logo',
    'error_updating_system_settings': 'Error updating system settings',
    'manage_your_subscription_and_billing': 'Manage your subscription and billing',
    'confirm': 'Confirm',
    'success': 'Success',
    'error': 'Error',
    'warning': 'Warning',
    'info': 'Information',
    'org_settings_desc': 'General organization configuration',
    'flat_amount': 'Flat Amount',
    'percent_of_rent': 'Percent of Rent',
    'late_fee_configuration': 'Late Fee Configuration',
    'enabled': 'Enabled',
    'disabled': 'Disabled',
    'legal_note_late_fees': 'US state laws vary. Grace periods: CA (3 days), NY (5 days), TX (2 days). Consult your local laws.',
    'grace_period_days': 'Grace Period (days)',
    'fee_type': 'Fee Type',
    'late_fee_summary': 'Late fee',
    'applied_after': 'applied after',
    'past_due': 'past due',
    'days': 'days',
    'amount': 'Amount',
    'active': 'Active',
    'trial': 'Trial',
    'past_due': 'Past Due',
    'canceled': 'Canceled',
    'expired': 'Expired',
    'unknown': 'Unknown',
    'completed': 'Completed',
    'pending': 'Pending',
    'failed': 'Failed',
    'all': 'All',
    'date': 'Date',
    'organization': 'Organization',
    'method': 'Method',
    'actions': 'Actions',
    'starter_plan': 'Starter',
    'pro_plan': 'Pro',
    'enterprise_plan': 'Enterprise',
    'starter_desc': 'For independent landlords managing internal records.',
    'pro_desc': 'For professional firms with automated admin workflows.',
    'enterprise_desc': 'Institutional-grade control with full self-service portals.',
    'starter_f1': 'Up to 100 units',
    'starter_f2': '2 Admin seats',
    'starter_f3': 'Buildings & Units mgmt',
    'starter_f4': 'Double-Entry Block Ledger',
    'starter_f5': 'Manual Rent Tracking',
    'starter_f6': 'Basic Financial Reports',
    'starter_f7': 'Email Notifications',
    'most_popular': 'Most Popular',
    'pro_f1': 'Up to 150 units',
    'pro_f2': '5 Admin seats',
    'pro_f3': 'Global Maintenance Hub',
    'pro_f4': 'Security Deposit Compliance',
    'pro_f5': 'Automated Monthly Statements',
    'pro_f6': 'WhatsApp Reminders',
    'pro_f7': 'Owner Mgmt & Work Orders',
    'pro_f8': 'Occupancy Analytics',
    'pro_f9': 'Booking, Waitlist & Transfers',
    'pro_f10': 'Standard Priority Support',
    'ent_f1': 'Unlimited Units & Admins',
    'ent_f2': 'Tenant & Owner Portals',
    'ent_f3': 'Two-Way Secure Messaging',
    'ent_f4': 'Stripe E2E Rent Payments',
    'ent_f5': 'Automated Email System',
    'ent_f6': 'Digital Contract Signing',
    'ent_f7': 'Multi-Organization Support',
    'ent_f8': 'Custom Report Templates',
    'ent_f9': 'Advanced Activity Logs',
    'ent_f10': 'API & Webhook Access',
    'ent_f11': '2FA via WhatsApp OTP',
    'choose_a_plan': 'Choose a Plan',
    'subscribe_now': 'Subscribe Now',
    'contact_sales': 'Contact Sales',
    'upgrade': 'Upgrade',
    'current': 'Current',
    'custom': 'Custom',
    'yr': 'yr',
    'mo': 'mo',
    'expires': 'Expires',
    'renews': 'Renews',
    'opening': 'Opening...',
    'subscription_plan': 'Subscription Plan',
    'manage_your_subscription_and_billing': 'Manage your subscription and billing history',
    'stripe_portal_title': 'Portal Management',
    'stripe_portal_desc': 'Manage your subscription securely via our Stripe portal.',
    'stripe_secure_notice': '🔒 Secure payments powered by Stripe',
    'no_payment_history': 'No payment history found',
    'payment_history': 'Payment History',
    'monthly': 'Monthly',
    'annual': 'Annual',
    'subscribe_with_stripe': 'Securely subscribe via Stripe',
    'save_20_annual': 'Save 20% · ${{amount}}/yr billed annually',

    // App
    'apartment_system': 'Apartment System',
    'apartment_management': 'Apartment Management',

    // Authentication
    'login': 'Login',
    'logout': 'Logout',
    'login_to_continue': 'Sign in to continue',
    'dont_have_account': "Don't have an account?",
    'register': 'Register',
    'username': 'Username',
    'password': 'Password',
    'email': 'Email',
    'remember_me': 'Remember Me',
    'forgot_password': 'Forgot Password?',
    'forgot_password_instructions': 'Enter your username or email to receive a verification code',
    'send_code': 'Send Verification Code',
    'reset_password': 'Reset Password',
    'password_reset_success': 'Your password has been reset successfully',
    'password_min_length': 'Password must be at least 8 characters',
    'login_failed': 'Login failed',
    'invalid_credentials': 'Invalid credentials',
    'security_verification': 'Security Verification',
    'verification_code_sent': 'Verification code sent to your registered device.',
    'enter_valid_otp': 'Please enter a valid verification code',
    'verification_failed': 'Verification failed',
    'code_resent_success': 'Verification code resent successfully.',
    'too_many_attempts': 'Too many attempts. Please try again later.',
    'check_device_for_code': 'Check your device for the code',
    'verifying': 'Verifying...',

    // Navigation
    'dashboard': 'Dashboard',
    'core': 'Core',
    "accounting": "Accounting",
    'user_management': 'User Management',
    'property_management': 'Property Management',
    'maintenance_operations': 'Maintenance & Operations',
    'financial_management': 'Financial Management',
    'financial_payments': 'Payments',
    'financial_accounting': 'Accounting',
    'financial_portfolio': 'Portfolio & KPIs',
    'portfolio_kpis': 'Portfolio & KPIs',
    'reports_analytics': 'Reports & Analytics',
    'system': 'System',

    // Users
    'system_users': 'System Users',
    'user_list': 'User List',
    'add_user': 'Add User',
    'edit_user': 'Edit User',
    'user_profile': 'User Profile',
    'first_name': 'First Name',
    'last_name': 'Last Name',
    'phone_number': 'Phone Number',
    'role': 'Role',
    'administrator': 'Administrator',
    'front_desk': 'Front Desk',
    'created_at': 'Created At',
    'last_login': 'Last Login',
    'never': 'Never',

    // Properties
    'properties': 'Properties',
    'property_list': 'Property List',
    'add_property': 'Add Property',
    'property_owners': 'Property Owners',
    'owner_list': 'Owner List',
    'add_owner': 'Add Owner',
    'owners': 'Owners',
    'owner_contracts': 'Owner Contracts',
    'management_agreements': 'Management Agreements',
    'add_contract': 'Add Contract',
    'contract_details': 'Contract Details',
    'no_contracts_message': 'No management contracts found for this owner.',
    'contract_type': 'Contract Type',
    'total_contract_value': 'Total Contract Value',
    'contract_progress': 'Contract Progress',
    'installment_schedule': 'Installment Schedule',

    // Tenants
    'tenants': 'Tenants',
    'tenant_list': 'Tenant List',
    'add_tenant': 'Add Tenant',
    'owner_living': 'Owner Living',
    'future_tenant': 'Future Tenant',

    // Payments
    'payments': 'Payments',
    'all_payments': 'All Payments',
    'record_payment': 'Record Payment',
    'manage_services': 'Manage Services',
    'generate_payments': 'Generate Payments',
    'overdue_payments': 'Overdue Payments',
    'receipts': 'Receipts',

    // Reports
    'reports': 'Reports',
    'all_reports': 'All Reports',
    'reports_dashboard': 'Reports Dashboard',
    'financial_reports': 'Financial Reports',
    'payment_reports': 'Payment Reports',
    'property_reports': 'Property Reports',
    'reports_1099_desc': 'IRS 1099-MISC report for property distributions to owners',
    'vendor_1099_nec': 'Vendor 1099-NEC',
    'vendor_1099_desc': 'IRS annual reporting — vendors paid ≥ $600 in nonemployee compensation',
    'rent_roll_desc': 'Snapshot of all units, occupancy status, rent, and lease details',
    'ar_aging_desc': 'Outstanding tenant balances bucketed by age (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'Total Vendors',
    'require_1099': 'Require 1099',
    'total_reportable': 'Total Reportable',
    '1099_required': '1099 Required',
    'below_threshold': 'Below threshold',
    'occupancy_rate': 'Occupancy Rate',
    'scheduled_rent': 'Scheduled Rent',
    'aging_breakdown': 'Aging Breakdown',

    // Report Templates
    'report_templates': 'Report Templates',
    'report_templates_subtitle': 'Create and manage reusable report configurations',
    'create_template': 'New Template',
    'create_first_template': 'Create First Template',
    'template_name': 'Template Name',
    'template_description': 'Description',
    'template_config': 'Configuration (JSON)',
    'no_templates': 'No Report Templates',
    'no_templates_message': 'Save your frequently-used report configurations as reusable templates.',
    'template_created': 'Template created successfully',
    'template_updated': 'Template updated successfully',
    'template_deleted': 'Template deleted',
    'delete_template_title': 'Delete Template',
    'delete_template_message': 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',

    // Settings
    'settings': 'Settings',
    'profile_settings': 'Profile Settings',
    'system_settings': 'System Settings',
    'profile': 'Profile',
    'personal_details': 'Personal Details',
    'security_settings': 'Security Settings',
    'change_password': 'Change Password',
    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',
    'organization_settings': 'Organization Settings',
    'organization_name': 'Organization Name',
    'timezone': 'Timezone',
    'subscription_plan': 'Subscription Plan',
    'trial_period': 'Trial Period',
    'days_left': '{{days}} days left',
    'subscription_required': 'Subscription Required',
    'subscription_expired_message': 'Access to your workspace is currently locked. Renew your subscription to continue managing your properties.',
    'premium_experience_notice': 'Premium Workspace Required',
    'feature_locked_message': 'This feature is not available in your current plan. Please upgrade to access.',
    'renew_subscription': 'Renew Subscription',
    'update_profile_success': 'Profile updated successfully',
    'update_password_success': 'Password changed successfully',
    'update_system_success': 'System settings updated successfully',
    'settings_subtitle': 'Manage your account and system preferences',
    'manage_your_account_and_system_preferences': 'Manage your account and system preferences',
    'standard_plan': 'Standard Plan',
    'enterprise_plan': 'Enterprise Plan',

    // Notifications
    'whatsapp_settings': 'WhatsApp Settings',
    'whatsapp_settings_description': 'Configure WhatsApp and SMS reminders for tenants and owners',
    'notification_settings': 'Notification Settings',
    'notification_settings_desc': 'Configure WhatsApp and SMS reminders for tenants and owners',
    'whatsapp_enable': 'Enable WhatsApp Notifications',
    'whatsapp_enable_sub': 'Turn all automated WhatsApp messages on or off',
    'whatsapp_enable_desc': 'Turn all automated WhatsApp messages on or off',
    'general_settings': 'General Settings',
    'default_country_code': 'Default Country Code',
    'default_message_language': 'Default Message Language',
    'tenant_rent_reminder': 'Tenant Rent Reminder',
    'enable_rent_reminders': 'Enable Rent Reminders',
    'rent_reminder': 'Rent Reminder',
    'rent_reminders_desc': 'Send to tenants with overdue or upcoming rent payments',
    'tenant_rent_reminder_sub': 'Send reminder to tenants before or after payment due date',
    'days_before_due': 'Days Before Due',
    'reminder_message_template': 'Message Template',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminders': 'Enable Service Fee Reminders',
    'service_fee_reminders_desc': 'Notify tenants and resident owners about unpaid service charges',
    'service_fee_reminder_sub': 'Notify tenants about upcoming service fee payments',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminders_desc': 'Alert property owners when tenants have overdue payments',
    'owner_message_template': 'Owner Message Template',
    'payment_confirmation': 'Payment Confirmation',
    'send_payment_confirmation': 'Send Payment Confirmation',
    'payment_confirmation_desc': 'Automatically notify tenant via WhatsApp when a payment is recorded',
    'payment_confirmation_sub': 'Automatically sent to tenant when a payment is logged',
    'payment_confirmation_template': 'Confirmation Message Template',
    'whatsapp_test_send': 'Send Test Message',
    'test_message': 'Message',
    'send_test_message': 'Send Test Message',
    'whatsapp_test_sent': 'Test message sent!',
    'whatsapp_test_default_message': 'Test message from property management system',
    'send_reminders_now': 'Send Reminders Now',
    'send_reminders_now_description': 'Immediately send reminders to all tenants and owners who need one right now.',
    'whatsapp_must_be_enabled': 'WhatsApp must be enabled first',
    'on': 'ON',
    'off': 'OFF',
    'sms_twilio': 'SMS (Twilio)',
    'enable_sms_notifications': 'Enable SMS Notifications (Twilio)',
    'sms_enable_desc': 'Turn all automated SMS messages on or off',
    'sender': 'Sender',
    'via_twilio': 'via Twilio',
    'send_test_sms': 'Send Test SMS',
    'test_sms_desc': 'Verify your Twilio integration by sending a test message to any phone number.',
    'phone_number': 'Phone Number',
    'send_test': 'Send Test',
    'save_settings': 'Save Settings',
    'preview_send': 'Preview & Send',
    'confirm_send_all': 'Confirm & Send All',
    'recipient_pending': 'recipient(s) pending',
    'no_pending_reminders': 'No pending reminders at this time.',
    'no_recipients_match': 'No recipients match current settings and active data.',
    'sms_sent_to': 'SMS sent to {{to}}',
    'sms_failed': 'SMS failed',
    'enter_phone_number': 'Enter a phone number first',
    'preview_reminders': 'Preview Automated Reminders',
    'notification_log_desc': 'Audit trail of all outbound notifications',
    'total_sent': 'Total Sent',
    'failed_bounced': 'Failed / Bounced',
    'email_templates_desc': 'Design automated emails for your tenants and owners',
    'test_email_address': 'Test email address',
    'payment_settings': 'Payment Settings',
    'accept_online_payments': 'Accept Online Payments',
    'connect_stripe_desc': 'Connect your Stripe account to enable tenants to pay rent directly through the portal.',
    'start_stripe_onboarding': 'Start Stripe Onboarding',
    'active_verified': 'Active & Verified',
    'action_required_onboarding': 'Action Required: Pending Onboarding',
    'webhooks_desc': 'Push events to your systems when things happen in APS',
    'recent_deliveries': 'Recent Deliveries',
    'failed_to_load_settings': 'Failed to load settings',
    'settings_saved': 'Settings saved successfully',
    'failed_to_save': 'Failed to save',
    'server_error': 'Server error',

    // Forms
    'personal_information': 'Personal Information',
    'account_information': 'Account Information',
    'security': 'Security',
    'enter_first_name': 'Enter first name',
    'enter_last_name': 'Enter last name',
    'enter_email': 'Enter email',
    'enter_username': 'Enter username',
    'enter_password': 'Enter password',
    'enter_phone_number': 'Enter phone number',
    'confirm_password': 'Confirm Password',
    'leave_blank_to_keep_current': 'Leave blank to keep current password',

    // Leasing Office
    'leasing_office': 'Leasing Office',
    'lease_applications': 'Lease Applications',
    'marketing_links': 'Marketing Links',
    'convert_to_tenant': 'Approve & Convert to Tenant',
    'view_application': 'View Application',
    'marketing_links_desc': 'Public portal links for prospective tenants to apply',

    // Validation
    'first_name_required': 'First name is required',
    'last_name_required': 'Last name is required',
    'email_required': 'Email is required',
    'invalid_email': 'Please enter a valid email address',
    'username_required': 'Username is required',
    'username_too_short': 'Username must be at least 3 characters',
    'password_required': 'Password is required',
    'password_too_short': 'Password must be at least 6 characters',
    'passwords_do_not_match': 'Passwords do not match',
    'phone_invalid_format': 'Please enter a valid phone number',

    // Actions
    'saving': 'Saving...',
    'deleting': 'Deleting...',
    'loading_users': 'Loading users...',
    'loading_user_data': 'Loading user data...',
    'update': 'Update',
    'activate': 'Activate',
    'deactivate': 'Deactivate',
    'show_all': 'Show All',
    'hide_inactive': 'Hide Inactive',
    'all_roles': 'All Roles',
    'retry': 'Retry',

    // Messages
    'no_users_found': 'No users found',
    'user_created_successfully': 'User created successfully',
    'user_updated_successfully': 'User updated successfully',
    'user_deleted_successfully': 'User deleted successfully',
    'confirm_deletion': 'Confirm Deletion',
    'delete_user_confirmation': 'Are you sure you want to delete {{name}}? This action cannot be undone.',

    // Dashboard
    'welcome_back': 'Welcome back',
    'dashboard_subtitle': 'Here\'s what\'s happening with your properties today.',
    'total_properties': 'Total Properties',
    'active_tenants': 'Active Tenants',
    'monthly_revenue': 'Monthly Revenue',
    'pending_payments': 'Pending Payments',
    'recent_activity': 'Recent Activity',
    'recent_transactions': 'Recent Transactions',
    'quick_actions': 'Quick Actions',
    'alerts_notifications': 'Alerts & Notifications',
    'showing': 'Showing',
    'of': 'of',
    'users': 'users',
    'contact': 'Contact',
    'user': 'User',
    'active_properties': 'Active Properties',
    'occupancy_rate_desc': '{{rate}}% occupancy rate',
    'vs_last_month': 'vs last month',
    'overdue_amount': '{{amount}} overdue',
    'payment_desc': '{{type}} payment - Apt {{number}}',
    'overdue_payments': 'Overdue Payments',
    'overdue_payments_msg': '{{count}} tenants have pending payments totaling {{amount}}',
    'view_details': 'View Details',
    'lease_expiring_soon': 'Lease Expiring Soon',
    'lease_expiring_msg': '{{count}} lease agreements expire within 30 days',
    'review_leases': 'Review Leases',
    'trial_ending_soon': 'Trial Ending Soon',
    'trial_ending_msg': 'Your trial ends in {{days}} days. Please subscribe to avoid service interruption.',
    'upgrade_plan': 'Upgrade Plan',
    'last_7_days': 'Last 7 days',
    'last_30_days': 'Last 30 days',
    'last_3_months': 'Last 3 months',
    'last_year': 'Last year',
    'error_loading_dashboard': 'Error loading dashboard',
    'reports_dashboard': 'Reports Dashboard',
    'overview_of_financial_performance': 'Overview of financial performance and property statistics',
    'view_all_reports': 'View All Reports',
    'total_revenue': 'Total Revenue',
    'total_payments_count': '{{count}} payments',
    'total_tenants': 'Total Tenants',
    'new_tenants_this_year': '{{count}} new this year',
    'total_buildings_count': '{{count}} buildings',
    'total_owners': 'Total Owners Living',
    'ended_contracts_count': '{{count}} ended contracts',
    'urgent_action': 'Urgent Action',
    'monthly_revenue_year': 'Monthly Revenue - {{year}}',
    'occupancy_rate': 'Occupancy Rate',
    'quick_reports': 'Quick Reports',
    'annual_revenue': 'Annual Revenue',
    'yearly_breakdown': 'Yearly breakdown of all revenue',
    'building_revenue': 'Building Revenue',
    'revenue_by_building': 'Revenue breakdown by building',
    'owner_revenue': 'Owner Revenue',
    'revenue_by_owner': 'Revenue breakdown by property owner',
    'detailed_payment_history': 'Detailed payment history and logs',
    'occupied': 'Occupied',
    'vacant': 'Vacant',
    'maintenance': 'Maintenance',
    'excellent': 'Excellent',
    'good': 'Good',
    'needs_improvement': 'Needs Improvement',
    'rent': 'Rent',
    'service': 'Service',
    'deposit': 'Deposit',
    'commission': 'Commission',
    'insurance': 'Insurance',
    'total': 'Total',
    'no_recent_payments': 'No recent payments found',
    'no_overdue_payments': 'No overdue payments found',
    'overdue': 'Overdue',
    'partial': 'Partial',
    'expired': 'Expired',
    'pending': 'Pending',
    'paid': 'Paid',
    'apt': 'Apt',
    'days_overdue': 'days overdue',
    'more_overdue_tenants': 'more overdue tenants',
    'error_fetching_occupancy': 'Error fetching occupancy data',
    'failed_load_occupancy': 'Failed to load occupancy stats',
    'error_fetching_payments': 'Error fetching recent payments',
    'failed_load_payments': 'Failed to load recent payments',
    'error_fetching_tenant_status': 'Error fetching tenant payment status',
    'failed_load_tenant_status': 'Failed to load tenant payment status',
    'failed_to_load_report_data': 'Failed to load report data',
    'mgmt_fee_collected': 'Mgmt Fee Collected (YTD)',
    'mgmt_fee_outstanding': 'Mgmt Fee Outstanding',
    'active_tenant_arrears': 'Active tenant arrears',
    'all_accounts_settled': 'All accounts settled',
    'owner_payments': 'Owner Payments',
    'all_months': 'All Months',

    "floor_number": "Floor {{number}}",
    "apartment_number": "Room {{number}}",

    // Sidebar specific translations
    'core': 'Core',
    'user_management': 'User Management',
    'property_management': 'Property Management',
    'maintenance_operations': 'Maintenance & Operations',
    'leasing_office': 'Leasing Office',
    'financial_management': 'Financial Management',
    'financial_payments': 'Payments',
    'financial_accounting': 'Accounting',
    'financial_portfolio': 'Portfolio & KPIs',
    'reports_analytics': 'Reports & Analytics',
    'logs_audit': 'Logs & Audit',
    'all_activities': 'All Activities',
    'tenant_activities': 'Tenant Activities',
    'system': 'System',
    'bookings': 'Bookings',
    'booking_list': 'Booking List',
    'new_booking': 'New Booking',
    'booking_calendar': 'Booking Calendar',
    'waitlist': 'Waitlist',
    'analytics': 'Analytics',

    'system_users': 'System Users',
    'user_list': 'User List',
    'add_user': 'Add User',

    'buildings': 'Buildings',
    'building_list': 'Building List',
    'add_building': 'Add Building',

    'apartments': 'Apartments',
    'apartment_list': 'Apartment List',
    'add_apartment': 'Add Apartment',

    'owners': 'Owners',
    'owner_list': 'Owner List',
    'add_owner': 'Add Owner',

    'tenants': 'Tenants',
    'tenant_list': 'Tenant List',
    'add_tenant': 'Add Tenant',
    'overdue_rent': 'Overdue Rent',

    'payments': 'Payments',
    'all_payments': 'All Payments',
    'record_payment': 'Record Payment',
    'payment_stats': 'Payment Statistics',

    'service_payments': 'Service Payments',
    'manage_services': 'Manage Services',
    'generate_payments': 'Generate Payments',
    'service_statistics': 'Service Statistics',

    'reports': 'Reports',
    'reports_dashboard': 'Reports Dashboard',
    'revenue_report': 'Revenue Report',
    'payment_logs': 'Payment Logs',
    'occupancy_report': 'Occupancy Report',
    'tenant_payments': 'Tenant Payments',
    'building_revenue': 'Building Revenue',
    'owner_revenue': 'Owner Revenue',

    'activity_logs': 'Activity Logs',
    'all_activities': 'All Activities',
    'tenant_activities': 'Tenant Activities',
    'monthly_revenue': 'Monthly Revenue',

    'settings': 'Settings',
    'profile_settings': 'Profile Settings',
    'system_settings': 'System Settings',

    'logout': 'Logout',
    'sales': 'Sales',
    'inspections': 'Inspections',
    'maintenance_hub': 'Maintenance Hub',
    'vendors': 'Vendors',
    'finance': 'Finance',
    'transactions': 'Transactions',
    'service_charges': 'Service Charges',
    'owner_installments': 'Owner Installments',
    'financial_matrix': 'Financial Matrix',
    'cash_flow_forecast': '7-Day Forecast',
    'receivables': 'Receivables',
    'receivables_sub': 'Money owed to you, by how overdue it is.',
    'accounting_statement': 'Statement →',
    'no_receivables': 'Nobody owes anything.',
    'books_need_attention': 'Books need attention',
    'books_tie_out': 'A/R ties to the general ledger',
    'ar_gl_drift': 'A/R does not tie to the general ledger',
    'unmirrored_charges': 'charges',
    'unmirrored_payments': 'payments',
    'not_in_receivables': 'not yet in Receivables',
    'closed_periods': 'closed period(s)',
    'fix_now': 'Fix now',
    'fixing': 'Fixing…',
    'statement': 'statement',
    'open_full_record': 'Open full record →',
    'credit_on_account': 'credit on account',
    'opening_balance': 'Opening balance',
    'closing_balance': 'Closing balance',
    'no_activity': 'No activity in this period.',
    'charge': 'Charge',
    'kind_rent': 'Rent',
    'kind_service': 'Service fee',
    'kind_late_fee': 'Late fee',
    'kind_utility': 'Utility',
    'kind_parking': 'Parking',
    'kind_deposit': 'Deposit',
    'kind_sale_installment': 'Sale installment',
    'kind_management_fee': 'Management fee',
    'kind_maintenance_fee': 'Maintenance fee',
    'kind_payment': 'Payment',
    'outstanding': 'Outstanding',
    'ledger_activity_report': 'Ledger Activity',
    'management_fee_report': 'Management Fees',
    'messages': 'Messages',
    'announcements_manager': 'Announcements Manager',
    'all_announcements': 'All Announcements',
    'subscription': 'Subscription',
    'contract_templates': 'Contract Templates',
    'whatsapp_and_sms': 'WhatsApp & SMS',
    'late_fees_org_config': 'Late Fees & Org Config',
    'building_amenities': 'Building Amenities',
    'parking_spaces': 'Parking Spaces',
    'amenity_bookings': 'Amenity Bookings',
    'pm_schedules': 'PM Schedules',
    'work_orders': 'Work Orders',
    'security_deposits': 'Security Deposits',
    'expenses': 'Expenses',
    'late_fees': 'Late Fees',
    'bulk_owner_payout': 'Bulk Owner Payout',
    'utilities': 'Utilities',
    'kpi_dashboard': 'KPI Dashboard',
    'portfolio': 'Portfolio',
    'general_ledger': 'General Ledger',
    'reports_1099': '1099 Reports',
    'notification_log': 'Notification Log',
    'all_messages': 'All Messages',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'AI Intelligence',
    'rent_pricing_ai': 'Rent Pricing AI',
    'churn_prediction': 'Churn Prediction',
    'showings': 'Showings',
    'tenant_surveys': 'Tenant Surveys',
    'insurance': 'Insurance',
    'vendor_1099': 'Vendor 1099',
    'rent_roll': 'Rent Roll',
    'ar_aging': 'AR Aging',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'AI Rent Pricing',
    'ai_rent_pricing_desc': 'Get AI-powered market rent suggestions based on your portfolio comparables, occupancy, and renewal trends',
    'select_unit_to_analyze': 'Select Unit to Analyze',
    'choose_an_apartment': 'Choose an apartment...',
    'analyze': 'Analyze',
    'analyzing': 'Analyzing...',
    'ai_recommended_rent': 'AI Recommended Rent',
    'range': 'Range',
    'high_confidence': 'High',
    'medium_confidence': 'Medium',
    'low_confidence': 'Low',
    'confidence_suffix': 'confidence',
    'comparable_units_found': 'Comparable Units ({{count}} found)',
    'avg_comparable_rent': 'Avg: {{amount}}/mo',
    'vs_suggestion': 'vs suggestion',
    'select_unit_analyze_desc': 'Select a unit and click Analyze',
    'claude_analyze_desc': 'Claude will analyze comparables, occupancy, and renewal trends to suggest the optimal rent',

    // Churn Prediction Page
    'churn_prediction_desc': 'AI renewal likelihood for all active tenants',
    'run_ai_scoring': 'Run AI Scoring',
    'running': 'Running...',
    'high_churn_risk': 'High Churn Risk',
    'medium_risk': 'Medium Risk',
    'likely_to_renew': 'Likely to Renew',
    'no_churn_scores': 'No churn scores yet',
    'run_scoring_desc': 'Click "Run AI Scoring" to analyze all active tenants',
    'run_scoring_now': 'Run Scoring Now',
    'renewal_score': 'Renewal Score',
    'risk_level': 'Risk Level',
    'lease_ends': 'Lease Ends',
    'key_factors': 'Key Factors',
    'send_offer': 'Send Offer',
    'late_payments_6m': '{{count}} late pymts',
    'current_balance_factor': '${{amount}} balance',
    'prior_renewals_factor': '{{count}} renewals',

    // Showings Page
    'showings_desc': 'Schedule and track property showings for prospects',
    'schedule_showing': 'Schedule Showing',
    'upcoming': 'Upcoming',
    'today': 'Today',
    'no_shows': 'No Shows',
    'all': 'All',
    'no_showings_found': 'No showings found',
    'schedule_first_showing': 'Schedule First Showing',
    'prospect': 'Prospect',
    'unit': 'Unit',
    'date_and_time': 'Date & Time',
    'scheduled': 'Scheduled',
    'completed': 'Completed',
    'cancelled': 'Cancelled',
    'no_show': 'No Show',
    'edit_showing': 'Edit Showing',
    'prospect_name': 'Prospect Name',
    'prospect_phone': 'Phone',
    'prospect_email': 'Email',
    'start_time': 'Start Time',
    'end_time': 'End Time',
    'assigned_to': 'Assigned To',
    'notes': 'Notes',

    // Insurance Page
    'insurance_tracking': 'Insurance Tracking',
    'insurance_desc': 'Manage tenant, owner, and building insurance policies',
    'add_policy': 'Add Policy',
    'expiring_30d': 'Expiring 30d',
    'total_coverage': 'Total Coverage',
    'all_status': 'All Status',
    'all_types': 'All Types',
    'no_policies_found': 'No policies found',
    'add_first_policy': 'Add First Policy',
    'entity': 'Entity',
    'insurer': 'Insurer',
    'policy_type': 'Policy Type',
    'coverage': 'Coverage',
    'expiry': 'Expiry',
    'expired_days_ago': 'Expired {{days}}d ago',
    'days_left': '{{days}}d left',
    'edit_policy': 'Edit Policy',
    'entity_type': 'Entity Type',
    'policy_number': 'Policy Number',
    'coverage_amount': 'Coverage Amount',
    'annual_premium': 'Annual Premium',
    'start_date': 'Start Date',
    'expiry_date': 'Expiry Date',
    'document_url': 'Document URL (COI link)',

    // Survey Results Page
    'tenant_surveys_desc': 'CSAT ratings and feedback from tenants',
    'overall_rating': 'Overall Rating',
    'distribution': 'Distribution',
    'by_category': 'By Category',
    'no_surveys_yet': 'No surveys yet',
    'tenants_submit_feedback_desc': 'Tenants can submit feedback from their portal',

    // Financial Matrix
    'financial_matrix_subtitle': 'Unified view of all financial activity across every unit',
    'total_charged': 'Total Charged',
    'total_collected': 'Total Collected',
    'overdue_balance': 'Overdue Balance',
    'partial_balance': 'Partial Balance',
    'all_floors': 'All Floors',
    'floor_label': 'Floor',
    'legend_paid': 'Paid',
    'legend_partial': 'Partial',
    'legend_overdue': 'Overdue',
    'legend_upcoming': 'Upcoming',
    'legend_no_charges': 'No charges',
    'table_unit': 'Unit',
    'table_now': 'now',
    'no_apartments_found_building': 'No apartments found for this building.',
    'view_all': 'All',
    'view_rent': 'Rent',
    'view_service': 'Service',
    'view_sales': 'Sales',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'Upcoming expected payments across tenants and owners',
    'expected_this_period': 'Expected This Period',
    'total_overdue_balance': 'Total Overdue Balance',
    'collected_today': 'Collected Today',
    'no_upcoming_payments': 'No upcoming payments in this period.',
    'today': 'Today',
    'overdue_label': 'OVERDUE',
    'expected_label': 'expected',

    // Quick Pay
    'quick_pay': 'Quick Pay',
    'recording': 'Recording...',
    'record_payment_btn': 'Record {{amount}} Payment',
    'no_active_tenant_error': 'No active tenant — payment can\'t be recorded here.',
    'view_full_ledger': 'View full ledger for {{name}}',
    'full_payment_form': 'Full payment form',
    'enter_valid_amount': 'Enter a valid amount',
    'no_active_tenant_found': 'No active tenant found for this unit',
    'payment_recorded_success': 'Payment recorded successfully',
    'treasury_quick_pay': 'Treasury Quick Pay',
    'payment_amount': 'Payment Amount',
    'memo': 'Memo / Reference',
    'add_a_note_about_this_treasury_event': 'Add a note about this treasury event...',
    'confirm_and_record': 'Confirm & Record',
    'view_owner_file_and_distribution': 'View Owner File & Distribution',
    'view_resident_ledger': 'View Resident Ledger',
    'processing': 'Processing...',
    'no_entity_found': 'No tenant or owner found for this unit',
    'owner_view': 'Owner',
    'tenant_view': 'Tenant',
    'search_owner_unit_building': 'Search owner, unit, building...',
    'showing_all_installments': 'Showing all {{count}} installments',
    'showing_overdue_within_days': 'Showing overdue + due within {{days}} days · {{hidden}} future installments hidden',
    'hide_future_count': 'Hide future ({{count}})',
    'show_all_future_count': 'Show all future ({{count}})',
    'no_overdue_upcoming_all_clear': 'No overdue or upcoming payments — all clear!',
    'no_records_match_search': 'No records match your search.',

    // Months Short
    'jan_short': 'Jan', 'feb_short': 'Feb', 'mar_short': 'Mar', 'apr_short': 'Apr', 'may_short': 'May', 'jun_short': 'Jun',
    'jul_short': 'Jul', 'aug_short': 'Aug', 'sep_short': 'Sep', 'oct_short': 'Oct', 'nov_short': 'Nov', 'dec_short': 'Dec',

    // Months Full
    'january': 'January', 'february': 'February', 'march': 'March', 'april': 'April', 'may': 'May', 'june': 'June',
    'july': 'July', 'august': 'August', 'september': 'September', 'october': 'October', 'november': 'November', 'december': 'December',

    // AI Assistant
    'ai_assistant': 'AI Assistant',
    'ask_ai': 'Ask AI',
    'ai_greeting': "Hi! I'm your AI financial analyst. How can I help you today?",
    'ai_error': "Sorry, I couldn't process that. Please try again.",
    'analyzing_data': 'Analyzing data...',
    'ai_placeholder': 'What would you like to know?',
    'overdue_tenants_q': 'Which tenants are overdue?',
    'revenue_30d_q': 'Last 30 days revenue?',
    'expenses_month_q': 'Expenses this month?',
    'utility_pending_q': 'Utility bills pending?',
    'kpi_noi_summary_q': 'KPI & NOI summary?',
    'security_deposits_q': 'Security deposits held?',
    'late_fees_q': 'Late fees charged?',
    'owner_payouts_q': 'Owner payouts this month?',


    // Apartment Detail View
    'loading_apartment_details': 'Loading apartment details...',
    'error_loading_apartment': 'Error Loading Apartment Details',
    'try_again': 'Try Again',
    'back_to_apartments': 'Back to Apartments',
    'apartment_not_found': 'Apartment Not Found',
    'apartment_not_found_message': 'The apartment you are looking for does not exist or has been removed.',

    'building_and_location': 'Building & Location',
    'building': 'Building',
    'floor': 'Floor',
    'address': 'Address',

    'apartment_details': 'Apartment Details',
    'apartment_type': 'Type',
    'size': 'Size',
    'furnished': 'Furnished',

    'owner_information': 'Owner Information',
    'owner_name': 'Name',
    'owner_contact': 'Contact',

    'additional_information': 'Additional Information',
    'created_at': 'Created At',
    'updated_at': 'Last Updated',

    'status_management': 'Status Management',
    'status_vacant': 'Vacant',
    'status_occupied': 'Occupied',
    'status_maintenance': 'Under Maintenance',
    'status_vacant_description': 'Available for rent or lease',
    'status_occupied_description': 'Currently rented to a tenant',
    'status_maintenance_description': 'Under maintenance or renovation',
    'status_sold_description': 'This unit has been sold',
    'change_status': 'Change Status To',

    'quick_actions': 'Quick Actions',
    'create_lease': 'Create Lease',
    'view_tenant_info': 'View Tenant Info',
    'mark_maintenance_complete': 'Mark Maintenance Complete',
    'view_building': 'View Building',
    'edit_apartment': 'Edit Apartment',

    'same_building_apartments': 'Same Building',
    'view_all_apartments_in_building': 'View All Apartments in Building',
    'view_vacant_apartments': 'View Vacant Apartments',

    // Delete confirmation
    'delete_apartment_confirmation': 'Are you sure you want to delete apartment "{{name}}"? This action cannot be undone.',

    // Apartment Form
    'loading_apartment_data': 'Loading apartment data...',
    'edit_apartment': 'Edit Apartment',
    'add_new_apartment': 'Add New Apartment',

    'basic_information': 'Basic Information',
    'apartment_number': 'Apartment Number',
    'enter_apartment_number': 'Enter apartment number',
    'floor_number': 'Floor Number',
    'enter_floor_number': 'Enter floor number',
    'size_sqm': 'Size (m²)',
    'enter_size': 'Enter size in square meters',
    'apartment_type': 'Apartment Type',
    'select_apartment_type': 'Select apartment type',
    'select_building': 'Select building',
    'furnished': 'Furnished',

    // Validation messages
    'floor_required': 'Floor is required',
    'apartment_number_required': 'Apartment number is required',
    'size_required': 'Size is required',
    'type_required': 'Type is required',
    'building_required': 'Building is required',
    'invalid_size': 'Size must be greater than 0',

    // Form actions
    'update': 'Update',
    'save': 'Save',
    'saving': 'Saving...',


    // Apartment List
    'apartments': 'Apartments',
    'search_apartments': 'Search apartments...',
    'filter': 'Filter',
    'grid_view': 'Grid',
    'list_view': 'List',
    'add_apartment': 'Add Apartment',
    'all_buildings': 'All Buildings',
    'all_types': 'All Types',
    'all_statuses': 'All Statuses',
    'all': 'All',
    'vacant_apartments': 'Vacant Apartments',
    'occupied_apartments': 'Occupied Apartments',
    'maintenance_apartments': 'Under Maintenance',
    'loading_apartments': 'Loading apartments...',
    'error_loading_apartments': 'Error Loading Apartments',
    'no_apartments_found': 'No Apartments Found',
    'no_apartments_message': 'There are no apartments in the system yet.',
    'create_first_apartment': 'Create First Apartment',
    'showing_filtered_results': 'Showing {{showing}} of {{total}} apartments',

    // Statuses
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'maintenance': 'Under Maintenance',

    // Apartment card
    'furnished': 'Furnished',

    // Delete confirmation
    'delete_apartment_confirmation': 'Are you sure you want to delete apartment "{{name}}"? This action cannot be undone.',
    'deleting': 'Deleting...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Bulk Apartment Creation',
    'preview': 'Preview',
    'apartment_number_format': 'Apartment Number Format',
    'format_pattern': 'Format Pattern',
    'format_pattern_help': 'Use {floor} for floor number and {unit} for unit number. Example: {floor}{unit} = 0201',
    'preview_example': 'Preview Example',
    'floor_plans': 'Floor Plans',
    'add_floor_plan': 'Add Floor Plan',
    'floor_plan_number': 'Floor Plan {number}',
    'floors_comma_separated': 'Floors (comma-separated)',
    'unit_types': 'Unit Types',
    'add_unit_type': 'Add Unit Type',
    'unit_type_number': 'Unit Type {number}',
    'name': 'Name',
    'quantity': 'Quantity',
    'type': 'Type',
    'area_sqm': 'Area (m²)',
    'furnished': 'Furnished',
    'apartment_preview_count': 'Apartment Preview ({count} units)',
    'floor_unit_type': 'Floor {floor} • {type}',
    'close': 'Close',
    'create_apartments': 'Create Apartments',
    'create_apartments_count': 'Create {count} Apartments',
    'creating_apartments': 'Creating Apartments...',
    'add_at_least_one_floor_plan': 'Please add at least one floor plan',
    'no_apartments_to_create': 'No apartments to create',


    'building_name_required': 'Building name is required',
    'building_address_required': 'Building address is required',
    'invalid_floors': 'Total floors must be at least 1',
    'invalid_apartments': 'Total apartments must be at least 0',
    'loading_building_data': 'Loading building data...',
    'edit_building': 'Edit Building',
    'add_new_building': 'Add New Building',
    'basic_information': 'Basic Information',
    'building_name': 'Building Name',
    'enter_building_name': 'Enter building name',
    'total_floors': 'Total Floors',
    'number_of_floors': 'Number of floors',
    'total_apartments': 'Total Apartments',
    'number_of_apartments': 'Number of apartments',
    'address': 'Address',
    'enter_complete_building_address': 'Enter complete building address',
    'cancel': 'Cancel',
    'saving': 'Saving...',
    'update': 'Update',
    'save': 'Save',


    'buildings': 'Buildings',
    'search_buildings': 'Search buildings...',
    'bulk_add_apartments': 'Bulk Add Apartments',
    'add_building': 'Add Building',
    'loading_buildings': 'Loading buildings...',
    'error_loading_buildings': 'Error Loading Buildings',
    'try_again': 'Try Again',
    'no_buildings_found': 'No Buildings Found',
    'no_buildings_yet': 'No Buildings Yet',
    'no_buildings_match_search': 'No buildings match "{{search}}"',
    'no_buildings_message': 'There are no buildings in the system yet. Add your first building to get started.',
    'create_first_building': 'Create First Building',
    'showing_filtered_results': 'Showing {{showing}} of {{total}} buildings',
    'floors': 'Floors',
    'apartments': 'Apartments',
    'occupancy': 'Occupancy',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'no_apartments_yet': 'No apartments yet',
    'add_apartments': '+ Add Apartments',
    'confirm_deletion': 'Confirm Deletion',
    'delete_building_confirmation': 'Are you sure you want to delete building "{{name}}"? This action cannot be undone.',
    'cancel': 'Cancel',
    'deleting': 'Deleting...',
    'delete': 'Delete',
    'create_building_first': 'Please create a building first',
    'create': 'Create Apartments',
    'unnamed_building': 'Unnamed Building',
    'no_address_provided': 'No address provided',

    'select_building_for_bulk_creation': 'Select Building for Bulk Apartment Creation',

    'loading_building_details': 'Loading building details...',
    'error_loading_building': 'Error Loading Building',
    'try_again': 'Try Again',
    'back_to_buildings': 'Back to Buildings',
    'building_not_found': 'Building Not Found',
    'building_not_found_message': 'The building you are looking for does not exist or has been removed.',
    'add_apartment': 'Add Apartment',
    'edit_building': 'Edit Building',
    'generate_reports': 'Generate Reports',
    'total_apartments': 'Total Apartments',
    'units': 'units',
    'across_floors': 'Across {{floors}} floors',
    'vacant_apartments': 'Vacant',
    'available_for_rent': 'Available for rent',
    'no_vacancies': 'No vacancies',
    'occupancy_rate': 'Occupancy Rate',
    'occupied_units': 'occupied units',
    'maintenance_apartments': 'Maintenance',
    'needs_attention': 'Needs attention',
    'average_apartment_size': 'Average Size',
    'furnished_apartments': 'Furnished',
    'utility_status': 'Utilities Status',
    'water': 'Water',
    'electricity': 'Electricity',
    'internet': 'Internet',
    'hide_details': 'Hide Details',
    'show_details': 'Show Details',
    'search_apartments': 'Search apartments, owners, tenants...',
    'all_statuses': 'All Statuses',
    'vacant': 'Vacant',
    'occupied': 'Occupied',
    'maintenance': 'Maintenance',
    'top_floor_first': 'Top Floor First',
    'ground_floor_first': 'Ground Floor First',
    'showing_results': 'Showing {{count}} of {{total}} apartments',
    'matching': 'matching',
    'with_status': 'with status',
    'no_apartments_found': 'No Apartments Found',
    'no_apartments_match_filters': 'No apartments match your current filters.',
    'clear_filters': 'Clear Filters',
    'floor_number': 'Floor {{number}}',
    'apartments': 'apartments',
    'owner': 'Owner',
    'status': 'Status',
    'vacant_status': 'Available',
    'maintenance_status': 'Under Maintenance',
    'furnished': 'Furnished',
    'unfurnished': 'Unfurnished',
    'no_matching_apartments_on_floor': 'No apartments on floor {{floor}} match your current filters.',
    'construction_year': 'Construction Year: {{year}}',

    'activity_logs': 'Activity Logs',
    'track_all_system_activities': 'Track all system activities and changes',
    'filter': 'Filter',
    'export_to_excel': 'Export to Excel',
    'exporting': 'Exporting...',
    'filter_logs': 'Filter Logs',
    'action_type': 'Action Type',
    'all_actions': 'All Actions',
    'entity_type': 'Entity Type',
    'all_entities': 'All Entities',
    'entries_per_page': 'Entries Per Page',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'reset': 'Reset',
    'apply_filter': 'Apply Filter',
    'previous': 'Previous',
    'next': 'Next',
    'tenant_activity_logs': 'Tenant Activity Logs',
    'payment_activity_logs': 'Payment Activity Logs',
    'building_activity_logs': 'Building Activity Logs',
    'apartment_activity_logs': 'Apartment Activity Logs',
    'owner_activity_logs': 'Owner Activity Logs',
    'user_activity_logs': 'User Activity Logs',
    'system_activity_logs': 'System Activity Logs',

    'monthly_revenue_by_user': 'Monthly Revenue by User',
    'export_to_excel': 'Export to Excel',
    'exporting': 'Exporting...',
    'total_revenue': 'Total Revenue',
    'total_payments': 'Total Payments',
    'recorded_by': 'Recorded by',
    'average_payment': 'Average Payment',
    'per_transaction': 'Per transaction',
    'revenue_by_user': 'Revenue by User',
    'no_revenue_data': 'No Revenue Data',
    'no_revenue_data_message': 'No payment records found for {{month}} {{year}}. Try selecting a different month or year.',


    'loading_owner_data': 'Loading owner data...',
    'error_loading_owner': 'Error Loading Owner',
    'back_to_owners': 'Back to Owners',
    'send_reminder': 'Send Reminder',
    'edit': 'Edit',
    'overview': 'Overview',
    'properties': 'Apartments',
    'payments': 'Payments',
    'contracts': 'Contracts',
    'outstanding': 'Outstanding',
    'financial_overview': 'Financial Overview',
    'portfolio_summary': 'Portfolio Summary',
    'financial_ledger': 'Financial Ledger',
    'no_installments': 'No installments found in your ledger.',
    'total_outstanding': 'Total Outstanding',
    'management_agreement': 'Management Agreement',
    'my_agreements': 'My Agreements',
    'active_agreements': 'Active Agreements',
    'no_active_agreements': 'No Active Agreements',
    'remaining': 'Remaining',
    'total_value': 'Total Value',
    'contact_information': 'Contact Information',
    'property_overview': 'Property Overview',
    'add_apartment': 'Add Apartment',
    'no_properties': 'No Apartments',
    'no_properties_message': 'This owner has no apartments yet.',
    'add_first_property': 'Add First Apartment',
    'view_details': 'View Details',
    'payment_history': 'Payment History',
    'no_payments': 'No Payments',
    'no_payments_message': 'No payments have been recorded yet.',
    'outstanding_fees': 'Outstanding Fees',
    'no_outstanding_fees': 'No Outstanding Fees',
    'all_fees_paid': 'All fees are up to date.',
    'total_outstanding': 'Total Outstanding',
    'add_payment': 'Add Payment',
    'property': 'Apartment',
    'select_property': 'Select Apartment',
    'amount': 'Amount',
    'payment_date': 'Payment Date',
    'payment_method': 'Payment Method',
    'cash': 'Cash',
    'bank_transfer': 'Bank Transfer',
    'check': 'Check',
    'credit_card': 'Credit Card',
    'online_payment': 'Online Payment',
    'reference_number': 'Reference Number',
    'notes': 'Notes',
    'cancel': 'Cancel',

    'owner_information': 'Owner Information',
    'name': 'Name',
    'phone': 'Phone',
    'owner_lives_property': 'Owner lives on the property',
    'select_apartments': 'Select Apartments',
    'available_apartments': 'available apartments',
    'no_apartments_available': 'No apartments available. All apartments already have owners.',
    'apartment_number': 'Apartment {{number}}',
    'floor': 'Floor',
    'size': 'Size',
    'type': 'Type',
    'status': 'Status',
    'cancel': 'Cancel',
    'saving': 'Saving...',
    'update_owner': 'Update Owner',
    'create_owner': 'Create Owner',
    'edit_property_owner': 'Edit Property Owner',
    'add_property_owner': 'Add Property Owner',

    'property_owners': 'Property Owners',
    'add_owner': 'Add Owner',
    'search_owners': 'Search owners...',
    'filter': 'Filter',
    'list_view': 'List',
    'grid_view': 'Grid',
    'export': 'Export',
    'exporting': 'Exporting...',

    // Owner Contracts & Installments - NEW
    'owner_contracts': 'Owner Contracts',
    'contracts': 'Contracts',
    'add_contract': 'Add Contract',
    'contract_details': 'Contract Details',
    'installments': 'Installments',
    'installment_details': 'Installment Details',
    'pay_now': 'Pay Now',
    'contract_type': 'Contract Type',
    'purchase_agreement': 'Purchase Agreement',
    'service_agreement': 'Service Agreement',
    'next_installment': 'Next Installment',
    'outstanding_balance': 'Outstanding Balance',
    'total_contract_value': 'Total Contract Value',
    'installment_plan': 'Installment Plan',
    'payment_successful': 'Payment successful! Your records will be updated shortly.',
    'payment_canceled': 'Payment was canceled.',
    'redirecting_to_payment': 'Redirecting to secure payment...',
    'no_contracts_found': 'No contracts found.',
    'no_installments_found': 'No installments found.',

    'living_status': 'Living Status',
    'all': 'All',
    'living_on_property': 'Living on Property',
    'not_living_on_property': 'Not Living on Property',
    'country': 'Country',
    'all_countries': 'All Countries',
    'apartment_status': 'Apartment Status',
    'all_statuses': 'All Statuses',
    'with_vacant': 'With Vacant Apartments',
    'fully_occupied': 'Fully Occupied',
    'with_maintenance': 'With Maintenance',
    'min_apartments': 'Min. Apartments',
    'max_apartments': 'Max. Apartments',
    'min_occupancy_rate': 'Min. Occupancy Rate (%)',
    'clear_filters': 'Clear Filters',
    'apply_filters': 'Apply Filters',
    'total_owners': 'Total Owners',
    'resident_owners': 'Resident Owners',
    'with_apartments': 'With Apartments',
    'without_apartments': 'Without Apartments',
    'loading_owners': 'Loading owners...',
    'error_loading_owners': 'Error Loading Owners',
    'try_again': 'Try Again',
    'no_owners_found': 'No Property Owners Found',
    'no_owners_message': 'There are no property owners in the system yet. Click the \'Add Owner\' button to create your first owner.',
    'create_first_owner': 'Create First Owner',
    'showing_filtered_results': 'Showing {showing} of {total} owners',
    'confirm_deletion': 'Confirm Deletion',
    'delete_owner_confirmation': 'Are you sure you want to delete owner "{name}"? This action cannot be undone.',
    'cancel': 'Cancel',
    'delete': 'Delete',
    'deleting': 'Deleting...',

    'resident_owner': 'Resident Owner',
    'apartments_count': 'Apartemnts Count',
    'show_apartments': 'Show Apartments',
    'hide_apartments': 'Hide Apartments',
    'size_unit_sqm': 'Unit size square meter',

    "loading": "Loading...",
    "edit_property_owner": "Edit Property Owner",
    "add_property_owner": "Add Property Owner",
    "owner_information": "Owner Information",
    "name": "Name",
    "phone": "Phone",
    "owner_lives_on_property": "Owner lives on the property",
    "select_apartments": "Select Apartments ({{count}})",
    "available_apartments": "{{count}} available apartments",
    "no_apartments_available": "No apartments available. All apartments already have owners.",
    "floor": "Floor",
    "size": "Size",
    "size_unit_sqm": "m²",
    "type": "Type",
    "status": "Status",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_owner": "Update Owner",
    "create_owner": "Create Owner",
    "failed_to_load_data": "Failed to load data",
    "failed_to_save_owner": "Failed to save owner",


    "activity_logs": "Activity Logs",
    "tenant_activity_logs": "Tenant Activity Logs",
    "payment_activity_logs": "Payment Activity Logs",
    "building_activity_logs": "Building Activity Logs",
    "apartment_activity_logs": "Apartment Activity Logs",
    "owner_activity_logs": "Owner Activity Logs",
    "user_activity_logs": "User Activity Logs",
    "system_activity_logs": "System Activity Logs",
    "track_all_system_activities": "Track all system activities and changes",
    "filter": "Filter",
    "export_to_excel": "Export to Excel",
    "exporting": "Exporting...",
    "search_logs_placeholder": "Search logs by name, user, or details...",
    "showing_entries": "Showing {{showing}} of {{total}} entries",
    "filter_logs": "Filter Logs",
    "action_type": "Action Type",
    "all_actions": "All Actions",
    "entity_type": "Entity Type",
    "all_entities": "All Entities",
    "entries_per_page": "Entries Per Page",
    "start_date": "Start Date",
    "end_date": "End Date",
    "reset": "Reset",
    "apply_filter": "Apply Filter",
    "time": "Time",
    "user": "User",
    "action": "Action",
    "entity": "Entity",
    "details": "Details",
    "view": "View",
    "system": "System",
    "view_entity_details": "View {{type}} details",
    "no_logs_matching_search": "No activity logs matching your search criteria",
    "no_logs_for_filters": "No activity logs found for the selected filters",
    "showing_range": "Showing {{start}} to {{end}} of {{total}} entries",
    "previous": "Previous",
    "next": "Next",
    "failed_to_load_logs": "Failed to load activity logs",
    "failed_to_export_logs": "Failed to export logs to Excel",

    "tenant": "Tenant",
    "payment": "Payment",
    "building": "Building",
    "apartment": "Apartment",
    "owner": "Owner",
    "user": "User",
    "system": "System",

    "created": "Created",
    "updated": "Updated",
    "deleted": "Deleted",
    "viewed": "Viewed",
    "login": "Login",
    "logout": "Logout",
    "payment_made": "Payment Made",
    "payment_received": "Payment Received",
    "status_changed": "Status Changed",
    "approved": "Approved",
    "rejected": "Rejected",
    "maintenance_request": "Maintenance Request",
    "maintenance_completed": "Maintenance Completed",

    "loading_payment_data": "Loading payment data...",
    "error_loading_payment": "Error Loading Payment",
    "payment_not_found": "Payment not found",
    "back_to_payments": "Back to Payments",
    "confirm_deletion": "Confirm Deletion",
    "delete_payment_confirmation": "Are you sure you want to delete this {{amount}} payment? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "print_receipt": "Print Receipt",
    "edit": "Edit",
    "tenant": "Tenant",
    "unknown_tenant": "Unknown Tenant",
    "apartment": "Apartment",
    "apt": "Apt",
    "none": "None",
    "payment_period": "Payment Period",
    "payment_details": "Payment Details",
    "tenant_information": "Tenant Information",
    "payment_information": "Payment Information",
    "amount": "Amount",
    "payment_date": "Payment Date",
    "payment_type": "Payment Type",
    "created": "Created",
    "last_updated": "Last Updated",
    "notes": "Notes",
    "view_tenant": "View Tenant",
    "unknown_period": "Unknown period",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "unknown_type": "Unknown Type",
    "unknown": "Unknown",
    "failed_to_load_payment_data": "Failed to load payment data",
    "failed_to_delete_payment": "Failed to delete payment",

    "rent": "Rent",
    "service": "Service Fee",
    "deposit": "Deposit",
    "maintenance": "Maintenance",
    "other": "Other",


    "generate": "Generate",
    "generated": "Generated",
    "generate_payment_for": "Generate Payment for",
    "payment_amount": "Payment Amount",
    "enter_amount": "Enter amount",
    "mark_as_paid_immediately": "Mark as paid immediately",
    "notes": "Notes",
    "payment_notes": "Payment notes",
    "required_fields": "Required fields",
    "cancel": "Cancel",
    "generate_payment": "Generate Payment",

    "loading": "Loading...",
    "edit_payment": "Edit Payment",
    "record_payment": "Record Payment",
    "payment_information": "Payment Information",
    "tenant": "Tenant",
    "select_tenant": "Select Tenant",
    "apt": "Apt",
    "no_apartment": "No Apartment",
    "amount": "Amount",
    "payment_date": "Payment Date",
    "payment_type": "Payment Type",
    "payment_period": "Payment Period",
    "period_start": "Period Start",
    "period_end": "Period End",
    "additional_information": "Additional Information",
    "notes": "Notes",
    "notes_placeholder": "Any additional notes about this payment...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_payment": "Update Payment",
    "failed_to_load_tenants_format": "Failed to load tenants: unexpected data format",
    "failed_to_load_tenants": "Failed to load tenants. Please try again.",
    "failed_to_load_payment_data": "Failed to load payment data",
    "failed_to_save_payment": "Failed to save payment",

    "rent": "Rent",
    "service": "Service Fee",
    "deposit": "Deposit",
    "maintenance": "Maintenance",
    "other": "Other",

    "payments": "Payments",
    "refresh": "Refresh",
    "refresh_payments": "Refresh payments",
    "stats": "Stats",
    "toggle_statistics": "Toggle statistics view",
    "search_payments": "Search payments...",
    "filter": "Filter",
    "record_payment": "Record Payment",
    "confirm_deletion": "Confirm Deletion",
    "confirm_delete_payment": "Are you sure you want to delete the {amount} payment for {tenantName}? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "filter_payments": "Filter Payments",
    "reset_all": "Reset All",
    "payment_type": "Payment Type",
    "all_types": "All Types",
    "payment_type_rent": "Rent",
    "payment_type_service": "Service",
    "payment_type_deposit": "Deposit",
    "payment_type_other": "Other",
    "payment_type_commission": "Commission",
    "payment_type_security_deposit": "Security Deposit",
    "building": "Building",
    "all_buildings": "All Buildings",
    "from_date": "From Date",
    "to_date": "To Date",
    "total_payments": "Total Payments",
    "payment": "payment",
    "payments": "payments",
    "recorded": "recorded",
    "rent_payments": "Rent Payments",
    "service_payments": "Service Payments",
    "payment_statistics": "Payment Statistics",
    "payments_by_month": "Payments by Month",
    "payment_types_distribution": "Payment Types Distribution",
    "recent_activity": "Recent Activity",
    "close_statistics": "Close Statistics",
    "loading_payments": "Loading payments...",
    "this_may_take_moment": "This may take a moment",
    "error_loading_payments": "Error Loading Payments",
    "try_again": "Try Again",
    "no_payments_found": "No Payments Found",
    "no_payments_match_filters": "No payments match your current filters. Try adjusting your filter criteria to see more results.",
    "no_payments_in_system": "There are no payments in the system yet. Get started by recording your first payment.",
    "reset_filters": "Reset Filters",
    "record_first_payment": "Record First Payment",
    "unknown_period": "Unknown period",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "unknown_type": "Unknown Type",
    "apt": "Apt",
    "print_receipt": "Print receipt",
    "view_details": "View details",
    "edit_payment": "Edit payment",
    "delete_payment": "Delete payment",
    "showing_payments": "Showing {{start}}-{{end}} of {{total}} payments",
    "showing_filtered_payments": "Showing {{filtered}} of {{total}} payments based on your search",
    "authentication_required": "Authentication required",
    "failed_load_payments": "Failed to load payments data",
    "auth_failed_login_again": "Authentication failed. Please log in again.",
    "access_denied_admin_required": "Access denied. Admin role required.",
    "server_error_check_backend": "Server error. Please check if the backend is running.",
    "cannot_connect_server": "Cannot connect to server. Please check if backend is running.",
    "error_fetching_payments": "Error fetching payments",
    "error_deleting_payment": "Error deleting payment",
    "failed_delete_payment": "Failed to delete payment",

    "occupancy_report": "Occupancy Report",
    "loading": "Loading...",
    "refresh": "Refresh",
    "back": "Back",
    "error_fetching_occupancy": "Error fetching occupancy data",
    "failed_load_occupancy": "Failed to load occupancy data",
    "occupied": "Occupied",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "apartments",
    "occupancy_rate": "Occupancy Rate",
    "of": "of",
    "vacant_apartments": "Vacant Apartments",
    "of_total": "of total",
    "maintenance_apartments": "In Maintenance",
    "potential_income": "Potential Monthly Income",
    "buildings": "buildings",
    "occupancy_distribution": "Occupancy Distribution",
    "occupancy_by_building": "Occupancy by Building",
    "building": "Building",
    "total_apartments": "Total Apartments",
    "print_report": "Print Report",
    "export_report": "Export Report",

    "rent": "Rent",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "total": "Total",
    "occupied": "Occupied",
    "vacant": "Vacant",
    "maintenance": "Maintenance",
    "apartments": "apartments",
    "of": "of",
    "excellent": "Excellent",
    "good": "Good",
    "needs_improvement": "Needs Improvement",
    "error_fetching_occupancy": "Error fetching occupancy data",
    "failed_load_occupancy": "Failed to load occupancy data",

    "overdue": "Overdue",
    "pending": "Pending",
    "paid": "Paid",
    "no_overdue_payments": "No overdue payments found",
    "apt": "Apt",
    "days_overdue": "days overdue",
    "more_overdue_tenants": "more overdue tenants...",
    "error_fetching_tenant_status": "Error fetching tenant payment status",
    "failed_load_tenant_status": "Failed to load tenant payment status",

    "rent": "Rent",
    "service": "Service",
    "deposit": "Deposit",
    "no_recent_payments": "No recent payments found",
    "error_fetching_payments": "Error fetching recent payments",
    "failed_load_payments": "Failed to load recent payments",

    "payment_logs": "Payment Logs",
    "filter": "Filter",
    "back": "Back",
    "search_payment_logs_placeholder": "Search payment logs...",
    "showing_entries": "Showing {{showing}} of {{total}} entries",
    "filter_payments": "Filter Payments",
    "time_period": "Time Period",
    "start_date": "Start Date",
    "end_date": "End Date",
    "payment_type": "Payment Type",
    "all_types": "All Types",
    "entries_per_page": "Entries Per Page",
    "reset": "Reset",
    "apply_filter": "Apply Filter",
    "payment_id": "Payment ID",
    "date": "Date",
    "tenant": "Tenant",
    "building": "Building",
    "type": "Type",
    "amount": "Amount",
    "actions": "Actions",
    "print_receipt": "Print Receipt",
    "view_details": "View Details",
    "no_logs_matching_search": "No payment logs matching your search criteria",
    "no_logs_for_period": "No payment logs available for the selected time period",
    "showing_range": "Showing {{start}} to {{end}} of {{total}} entries",
    "previous": "Previous",
    "next": "Next",
    "print_report": "Print Report",
    "export_to_excel": "Export to Excel",
    "failed_to_load_payment_logs": "Failed to load payment logs",

    "current_month": "Current Month",
    "last_month": "Last Month",
    "current_quarter": "Current Quarter",
    "current_year": "Current Year",
    "custom": "Custom Range",

    "rent": "Rent",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "other": "Other",

    "reports_dashboard": "Reports Dashboard",
    "overview_of_financial_performance": "Overview of financial performance and property statistics",
    "view_all_reports": "View All Reports",
    "failed_to_load_report_data": "Failed to load report data",
    "total_revenue": "Total Revenue",
    "total_payments_count": "{{count}} payments",
    "total_tenants": "Total Tenants",
    "new_tenants_this_year": "{{count}} new this year",
    "total_properties": "Total Properties",
    "total_buildings_count": "{{count}} buildings",
    "total_owners": "Total Owners",
    "ended_contracts_count": "{{count}} ended contracts",
    "monthly_revenue_year": "Monthly Revenue - {{year}}",
    "view_details": "View Details",
    "occupancy_rate": "Occupancy Rate",
    "recent_payments": "Recent Payments",
    "view_all": "View All",
    "overdue_payments": "Overdue Payments",
    "quick_reports": "Quick Reports",
    "annual_revenue": "Annual Revenue",
    "yearly_breakdown": "Yearly breakdown of all revenue",
    "building_revenue": "Building Revenue",
    "revenue_by_building": "Revenue breakdown by building",
    "owner_revenue": "Owner Revenue",
    "revenue_by_owner": "Revenue breakdown by property owner",
    "payment_logs": "Payment Logs",
    "detailed_payment_history": "Detailed payment history and logs",

    "revenue_report": "Revenue Report",
    "filter": "Filter",
    "loading": "Loading...",
    "refresh": "Refresh",
    "back": "Back",
    "filter_report": "Filter Report",
    "time_period": "Time Period",
    "start_date": "Start Date",
    "end_date": "End Date",
    "cancel": "Cancel",
    "apply_filter": "Apply Filter",
    "failed_to_load_revenue_data": "Failed to load revenue data",
    "total_revenue": "Total Revenue",
    "total_payments_count": "{{count}} payments",
    "rent_revenue": "Rent Revenue",
    "percent_of_total": "{{percent}}% of total",
    "service_revenue": "Service Revenue",
    "unique_tenants": "Unique Tenants",
    "avg_per_tenant": "Avg. {{amount}} per tenant",
    "revenue_by_building": "Revenue by Building",
    "view_details": "View Details",
    "building": "Building",
    "tenants": "Tenants",
    "no_building_revenue_data": "No building revenue data available",
    "revenue_by_owner": "Revenue by Owner",
    "owner": "Owner",
    "apartments": "Apartments",
    "no_owner_revenue_data": "No owner revenue data available",
    "print_report": "Print Report",
    "export_report": "Export Report",

    "current_month": "Current Month",
    "last_month": "Last Month",
    "current_quarter": "Current Quarter",
    "current_year": "Current Year",
    "custom": "Custom Range",

    "service_payments_management": "Service Payments Management",
    "refresh": "Refresh",
    "back_to_dashboard": "Back to Dashboard",
    "building": "Building",
    "select_building": "Select Building",
    "year": "Year",
    "search": "Search",
    "search_apartments_tenants": "Search apartments, tenants...",
    "generate_payments": "Generate Payments",
    "view_statistics": "View Statistics",
    "filter_by_status": "Filter by status",
    "all": "All",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "clear_filters": "Clear Filters",
    "loading_service_data": "Loading service payment data...",
    "no_building_selected": "No Building Selected",
    "please_select_building": "Please select a building to view service payments.",
    "no_search_results": "No Search Results",
    "no_matching_apartments": "No apartments or tenants match your search criteria.",
    "service_payments_for_building_year": "Service Payments for {{building}} - {{year}}",
    "floor_number": "Floor {{number}}",
    "apartments": "Apartments",
    "rate": "Rate",
    "tenant_owner": "Tenant/Owner",
    "vacant": "Vacant",
    "mark_as_paid": "Mark as Paid",
    "mark_as_unpaid": "Mark as Unpaid",
    "view_details": "View Details",
    "summary": "Summary",
    "floor_apartment_count": "{{floors}} floors, {{apartments}} apartments",
    "no_floors_available": "No Floors Available",
    "no_floors_message": "There are no floors with apartments in this building, or no service payments have been generated yet.",
    "failed_to_load_buildings": "Failed to load buildings. Please try again.",
    "failed_to_load_floors": "Failed to load floors",
    "failed_to_load_building_floors": "Failed to load building floors",
    "failed_to_load_floor_data": "Failed to load floor data",
    "data_refreshed_successfully": "Data refreshed successfully.",
    "failed_to_refresh_data": "Failed to refresh data",
    "marked_as_paid_via_service_management": "Marked as paid via service management",
    "marked_as_unpaid_via_service_management": "Marked as unpaid via service management",
    "payment_marked_as_paid": "Payment marked as paid successfully.",
    "payment_marked_as_unpaid": "Payment marked as unpaid successfully.",
    "failed_to_update_payment": "Failed to update payment",
    "payment_details": "Payment Details",
    "payment_due": "Payment Due",
    "amount": "Amount",
    "status": "Status",
    "paid_on": "Paid on",
    "no_apartments_on_floor": "No apartments found on this floor.",

    "month_1": "January",
    "month_2": "February",
    "month_3": "March",
    "month_4": "April",
    "month_5": "May",
    "month_6": "June",
    "month_7": "July",
    "month_8": "August",
    "month_9": "September",
    "month_10": "October",
    "month_11": "November",
    "month_12": "December",


    "service_payment_details": "Service Payment Details",
    "print_receipt": "Print Receipt",
    "loading": "Loading...",
    "failed_to_load_payment_details": "Failed to load payment details",
    "api_endpoint_missing_message": "This error indicates a missing API endpoint on your backend server. To fix this, add a route for GET /api/services/:id in your serviceRoutes.js file.",
    "payment_information": "Payment Information",
    "apartment": "Apartment",
    "period": "Period",
    "amount": "Amount",
    "status": "Status",
    "tenant": "Tenant",
    "owner": "Owner",
    "payment_date": "Payment Date",
    "paid_by": "Paid By",
    "notes": "Notes",
    "update_payment": "Update Payment",
    "mark_as_paid": "Mark as Paid",
    "currency": "Currency",
    "select_payer": "Select Payer",
    "management": "Management",
    "other": "Other",
    "payment_notes_placeholder": "Enter any additional notes about this payment...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "payment_history": "Payment History",
    "date": "Date",
    "action": "Action",
    "by": "By",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "payment_marked_as_paid": "Payment successfully marked as paid.",
    "payment_marked_as_unpaid": "Payment successfully marked as unpaid.",
    "failed_to_update_payment": "Failed to update payment",
    "service_payment_receipt": "Service Payment Receipt",
    "property_management": "Property Management",
    "receipt_generated": "This receipt was generated on {{date}} at {{time}}",
    "automated_receipt_notice": "This is an automatically generated receipt and does not require a signature.",
    "us_dollar": "US Dollar",
    "iraqi_dinar": "Iraqi Dinar",
    "euro": "Euro",

    "month_1": "January",
    "month_2": "February",
    "month_3": "March",
    "month_4": "April",
    "month_5": "May",
    "month_6": "June",
    "month_7": "July",
    "month_8": "August",
    "month_9": "September",
    "month_10": "October",
    "month_11": "November",
    "month_12": "December",

    "tenant": "tenant",
    "owner": "owner",
    "management": "management",
    "other": "other",

    "generate_service_payments": "Generate Service Payments",
    "recipients": "Recipients",
    "entire_building": "Entire Building",
    "generate_for_all_apartments": "Generate for all apartments in a building",
    "specific_tenants": "Specific Tenants",
    "generate_for_selected_tenants": "Generate for selected tenants only",
    "specific_owners": "Specific Owners",
    "generate_for_selected_owners": "Generate for selected owners only",
    "select_building": "Select Building",
    "include_vacant_apartments": "Include vacant apartments",
    "selected_tenants": "Selected Tenants",
    "selected_owners": "Selected Owners",
    "select_tenants": "Select Tenants",
    "select_owners": "Select Owners",
    "no_tenants_selected": "No tenants selected",
    "no_owners_selected": "No owners selected",
    "payment_details": "Payment Details",
    "amount": "Amount",
    "currency": "Currency",
    "us_dollar": "US Dollar",
    "iraqi_dinar": "Iraqi Dinar",
    "euro": "Euro",
    "initial_status": "Initial Status",
    "unpaid": "Unpaid",
    "paid": "Paid",
    "notes": "Notes",
    "payment_notes_placeholder": "Enter any additional notes about these payments...",
    "time_period": "Time Period",
    "generation_type": "Generation Type",
    "single_month": "Single Month",
    "multiple_months": "Multiple Months",
    "month_range": "Month Range",
    "year": "Year",
    "month": "Month",
    "select_months": "Select Months",
    "from": "From",
    "to": "To",
    "selected_months": "Selected Months",
    "payment_generation_summary": "Payment Generation Summary",
    "all_apartments_in": "All apartments in",
    "selected_building": "selected building",
    "tenants": "tenants",
    "owners": "owners",
    "cancel": "Cancel",
    "generating": "Generating...",
    "generate_payments": "Generate Payments",
    "search": "Search",
    "search_by_tenant_name_or_phone": "Search by tenant name, phone or apartment number...",
    "search_by_owner_name_or_phone": "Search by owner name or phone...",
    "no_results_found": "No results found",
    "selected": "selected",
    "done": "Done",
    "no_tenants_available": "No tenants available. Please add tenants first.",
    "no_owners_available": "No owners available. Please add owners first.",
    "apt": "Apt",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "failed_to_load_buildings": "Failed to load buildings. Please try again.",
    "failed_to_load_tenants": "Failed to load tenants. Please try again.",
    "failed_to_load_owners": "Failed to load owners. Please try again.",
    "please_select_building": "Please select a building",
    "please_select_at_least_one_recipient": "Please select at least one {{recipient}}",
    "please_enter_valid_amount": "Please enter a valid amount",
    "please_select_month": "Please select a month",
    "please_select_at_least_one_month": "Please select at least one month",
    "end_month_must_be_after_start_month": "End month must be after start month",
    "successfully_generated_payments": "Successfully generated {{count}} service payments across {{months}} month(s). {{skipped}} payments were already generated.",
    "failed_to_generate_service_payments": "Failed to generate service payments",
    "tenant": "tenant",
    "owner": "owner",

    "service_payment_statistics": "Service Payment Statistics",
    "back_to_services": "Back to Services",
    "building": "Building",
    "year": "Year",
    "loading_statistics": "Loading statistics...",
    "no_building_selected": "No Building Selected",
    "please_select_building_statistics": "Please select a building to view service payment statistics.",
    "overall_statistics": "Overall Statistics",
    "total_collection": "Total Collection",
    "of": "of",
    "payment_rate": "Payment Rate",
    "payments": "payments",
    "outstanding_amount": "Outstanding Amount",
    "unpaid_payments": "unpaid payments",
    "monthly_statistics": "Monthly Statistics",
    "no_monthly_data": "No monthly data available for the selected year.",
    "month": "Month",
    "total_amount": "Total Amount",
    "collected": "Collected",
    "outstanding": "Outstanding",
    "progress": "Progress",
    "failed_to_load_service_statistics": "Failed to load service statistics",

    "loading_tenant_data": "Loading tenant data...",
    "error_loading_tenant": "Error Loading Tenant",
    "tenant_not_found": "Tenant not found",
    "back_to_tenants": "Back to Tenants",
    "record_payment": "Record Payment",
    "edit": "Edit",
    "status_unknown": "Status Unknown",
    "apartment": "Apartment",
    "apt": "Apt",
    "none": "None",
    "monthly_rent": "Monthly Rent",
    "payment_date": "Payment Date",
    "overview": "Overview",
    "leases": "Leases",
    "payments": "Payments",
    "contact_information": "Contact Information",
    "lease_information": "Lease Information",
    "contract_period": "Contract Period",
    "rent": "Rent",
    "discount": "Discount",
    "rent_after_discount": "Rent After Discount",
    "additional_fees": "Additional Fees",
    "service_fee": "Service Fee",
    "office_commission": "Office Commission",
    "insurance": "Insurance",
    "notes": "Notes",
    "no_leases": "No Leases",
    "no_leases_message": "This tenant has no apartment assigned yet.",
    "active_leases": "Active Leases",
    "inactive_leases": "Inactive Leases",
    "active": "Active",
    "ended": "Ended",
    "expiring_soon": "Expiring soon",
    "end_lease": "End lease",
    "start_date": "Start Date",
    "end_date": "End Date",
    "duration": "Duration",
    "remaining": "Remaining",
    "months": "months",
    "security_deposit": "Security Deposit",
    "total_value": "Total Value",
    "no_payments": "No Payments",
    "no_payments_message": "This tenant has no recorded payments yet.",
    "record_first_payment": "Record First Payment",
    "payment_period": "Payment Period",
    "reference": "Reference",
    "payment_type": "Payment Type",
    "rent_payment": "Rent Payment",
    "additional_fee": "Additional Fee",
    "utility_payment": "Utility Payment",
    "other_payment": "Other Payment",
    "start": "Start",
    "end": "End",
    "reference_number": "Reference Number",
    "cancel": "Cancel",
    "unknown_period": "Unknown period",
    "invalid_period_format": "Invalid period format",
    "to": "to",
    "invalid_period_data": "Invalid period data",
    "please_enter_valid_payment_amount": "Please enter a valid payment amount",
    "end_date_must_be_after_start_date": "End date must be after start date",
    "failed_to_add_payment": "Failed to add payment",
    "maintenance_requests_not_supported": "Maintenance requests are not supported in the current database structure",
    "failed_to_create_maintenance_request": "Failed to create maintenance request",
    "confirm_end_lease": "Are you sure you want to end this lease? This action cannot be undone.",
    "lease_ended_by_administrator": "Lease ended by administrator",
    "failed_to_end_lease": "Failed to end lease",
    "failed_to_load_tenant_data": "Failed to load tenant data",
    "actual_end_date": "Actual End Date",

    "edit_tenant": "Edit Tenant",
    "add_tenant": "Add Tenant",
    "basic_information": "Basic Information",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email": "Email",
    "phone": "Phone",
    "apartment": "Apartment",
    "select_apartment": "Select Apartment",
    "floor": "Floor",
    "rent_amount": "Rent Amount",
    "discount": "Discount",
    "service_fee": "Service Fee",
    "office_commission": "Office Commission",
    "insurance": "Insurance",
    "contract_start_date": "Contract Start Date",
    "contract_end_date": "Contract End Date",
    "payment_date": "Payment Date",
    "payment_end_date": "Payment End Date",
    "rent_status": "Rent Status",
    "additional_information": "Additional Information",
    "notes": "Notes",
    "tenant_notes_placeholder": "Any additional notes about this tenant...",
    "cancel": "Cancel",
    "saving": "Saving...",
    "update_tenant": "Update Tenant",
    "create_tenant": "Create Tenant",
    "loading": "Loading...",
    "failed_to_load_tenant_data": "Failed to load tenant data",
    "failed_to_save_tenant": "Failed to save tenant",
    "pending": "Pending",
    "paid": "Paid",
    "late": "Late",
    "overdue": "Overdue",
    "unpaid": "Unpaid",

    "tenants": "Tenants",
    "refresh_tenants": "Refresh tenants",
    "selected": "selected",
    "delete_selected_tenants": "Delete selected tenants",
    "search_tenants": "Search tenants...",
    "filter": "Filter",
    "switch_to_list_view": "Switch to List View",
    "switch_to_grid_view": "Switch to Grid View",
    "list_view": "List",
    "grid_view": "Grid",
    "hide_inactive_tenants": "Hide inactive tenants",
    "show_inactive_tenants": "Show inactive tenants",
    "hide_inactive": "Hide Inactive",
    "show_inactive": "Show Inactive",
    "add_tenant": "Add Tenant",
    "rent_status": "Rent Status",
    "all_statuses": "All Statuses",
    "all_buildings": "All Buildings",
    "all_apartments": "All Apartments",
    "min_rent": "Min Rent",
    "max_rent": "Max Rent",
    "unlimited": "Unlimited",
    "contracts_ending_before": "Contracts Ending Before",
    "clear_filters": "Clear Filters",
    "apply_filters": "Apply Filters",
    "active_tenants": "Active Tenants",
    "inactive_tenants": "Inactive Tenants",
    "with_apartments": "With Apartments",
    "without_apartments": "Without Apartments",
    "loading_tenants": "Loading tenants...",
    "error_loading_tenants": "Error Loading Tenants",
    "try_again": "Try Again",
    "no_tenants_found": "No Tenants Found",
    "no_tenants_message": "There are no tenants in the system yet. Click the 'Add Tenant' button to create your first tenant.",
    "create_first_tenant": "Create First Tenant",
    "page": "page",
    "showing_items": "Showing {start}-{end} of {total}",
    "first_page": "First Page",
    "previous_page": "Previous Page",
    "next_page": "Next Page",
    "last_page": "Last Page",
    "showing_filtered_results": "Showing {showing} of {total} tenants",
    "confirm_deletion": "Confirm Deletion",
    "delete_tenant_confirmation": "Are you sure you want to delete tenant \"{name}\"? This action cannot be undone.",
    "cancel": "Cancel",
    "deleting": "Deleting...",
    "delete": "Delete",
    "tenant": "Tenant",
    "apartment": "Apartment",
    "rent": "Rent",
    "contract": "Contract",
    "status": "Status",
    "actions": "Actions",
    "apt": "Apt",
    "unknown_building": "Unknown Building",
    "no_apartment_assigned": "No apartment assigned",
    "status_unknown": "Status Unknown",
    "monthly_rent": "Monthly Rent",
    "after_discount": "After Discount",
    "payment_date": "Payment Date",
    "not_set": "Not set",
    "contract_start": "Contract Start",
    "contract_end": "Contract End",
    "service": "Service",
    "commission": "Commission",
    "insurance": "Insurance",
    "hide_owner_details": "Hide Owner Details",
    "show_owner_details": "Show Owner Details",
    "apartment_owner": "Apartment Owner",
    "loading_owner_details": "Loading owner details...",
    "no_owner_information": "No owner information available",
    "lives_on_property": "Lives on Property",
    "yes": "Yes",
    "no": "No",
    "total_apartments": "Total Apartments",
    "apartment_details": "Apartment Details",
    "apartment_number": "Apartment #",
    "unknown": "Unknown",
    "floor": "Floor",
    "apartment_type": "Apartment Type",
    "standard": "Standard",
    "furnished": "Furnished",
    "view_owner_profile": "View Owner Profile",
    "mark_as_inactive": "Mark as inactive",
    "mark_as_active": "Mark as active",
    "record_payment": "Record payment",
    "view_details": "View details",
    "edit_tenant": "Edit tenant",
    "delete_tenant": "Delete tenant",
    "to": "To",
    "payment": "Payment",
    "apartment_financial_details": "Apartment & Financial Details",
    "not_authenticated": "Not authenticated. Please log in.",
    "authentication_required": "Authentication required",
    "authentication_failed": "Authentication failed. Please log in again.",
    "access_denied": "Access denied. Admin role required.",
    "server_error": "Server error. Please check if the backend is running.",
    "cannot_connect_to_server": "Cannot connect to server. Please check if backend is running on port 3000.",
    "failed_to_load_tenants_data": "Failed to load tenants data",
    "unknown_error": "Unknown error",
    "failed_to_delete_tenant": "Failed to delete tenant",
    "confirm_bulk_delete": "Are you sure you want to delete {count} tenants? This action cannot be undone.",
    "failed_to_delete_tenants": "Failed to delete tenants",
    "failed_to_update_tenant_status": "Failed to update tenant status",
    "pending": "Pending",
    "paid": "Paid",
    "late": "Late",
    "overdue": "Overdue",

    'add_new_user': 'Add New User',
    'search_users': 'Search Users',
    'total_users': 'Total Users',
    'active_users': 'Active Users',
    'inactive_users': 'Inactive Users',
    'financial_summary': 'Financial Summary',
    'filters': 'Filters',
    'search_tenants_by_name_phone_or_apartment': 'Search Tenant by Name, Phone, or Apartment',
    'view_profile': 'View Profile',

    // WhatsApp Settings
    'whatsapp_settings': 'WhatsApp Settings',
    'whatsapp_settings_description': 'Automated WhatsApp notifications for tenants and owners',
    'whatsapp_enable': 'Enable WhatsApp Notifications',
    'whatsapp_enable_sub': 'Turn all automated WhatsApp messages on or off',
    'general_settings': 'General Settings',
    'default_country_code': 'Default Country Code',
    'tenant_rent_reminder': 'Tenant Rent Reminder',
    'tenant_rent_reminder_sub': 'Send reminder to tenants before or after payment due date',
    'days_before_due': 'Days Before Due',
    'reminder_message_template': 'Message Template',
    'service_fee_reminder': 'Service Fee Reminder',
    'enable_service_fee_reminder': 'Enable Service Fee Reminder',
    'service_fee_reminder_sub': 'Notify tenants about upcoming service fee payments',
    'owner_reminder': 'Owner Reminder',
    'enable_owner_reminders': 'Enable Owner Reminders',
    'owner_reminder_sub': 'Notify owners when their tenants have overdue payments',
    'owner_message_template': 'Owner Message Template',
    'payment_confirmation': 'Payment Confirmation',
    'send_on_payment': 'Send confirmation when payment is recorded',
    'payment_confirmation_sub': 'Automatically sent to tenant when a payment is logged',
    'payment_confirmation_template': 'Confirmation Message Template',
    'whatsapp_test_send': 'Send Test Message',
    'test_message': 'Message',
    'send_test_message': 'Send Test Message',
    'whatsapp_test_sent': 'Test message sent!',
    'whatsapp_test_default_message': 'Test message from property management system',
    'send_reminders_now': 'Send Reminders Now',
    'send_reminders_now_description': 'Immediately send reminders to all tenants and owners who need one right now.',
    'whatsapp_must_be_enabled': 'WhatsApp must be enabled first',
    'failed_to_load_settings': 'Failed to load settings',
    'settings_saved': 'Settings saved successfully',
    'failed_to_save': 'Failed to save',
    'failed_to_send': 'Failed to send',
    'server_error': 'Server connection error',
    'sent': 'Sent',
    'errors': 'Errors',
    'skipped': 'Skipped',

    // Bookings
    'bookings': 'Bookings',
    'booking_management': 'Booking Management',
    'new_booking': 'New Booking',
    'create_booking': 'Create Booking',
    'edit_booking': 'Edit Booking',
    'booking_details': 'Booking Details',
    'prospect': 'Prospect',
    'prospect_name': 'Prospect Name',
    'prospect_name_placeholder': 'e.g. John Doe',
    'prospect_phone': 'Phone Number',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_email': 'Email Address',
    'move_in_date': 'Move-in Date',
    'move_out_date': 'Move-out Date',
    'hold_duration': 'Hold Duration',
    'hold_hours': 'Hold Hours',
    'hold_expiration': 'Hold Expiration',
    'internal_notes': 'Internal Notes',
    'check_availability': 'Check Availability',
    'checking_availability': 'Checking availability...',
    'no_bookings_found': 'No bookings found',
    'calendar_view': 'Calendar View',
    'waitlist': 'Waitlist',
    'new_booking_hold': 'New Booking Hold',
    'property_information': 'Property Information',
    'prospect_details': 'Prospect Details',
    'requested_dates': 'Requested Dates',
    'conflict_detected': 'Conflict Detected',
    'booking_timeline': 'Booking Timeline',
    'monthly_view_holds': 'Monthly view of active apartment holds',
    'confirmed_hold': 'Confirmed Hold',
    'pending_payment': 'Pending Payment',
    'move_in': 'Move-In',
    'move_out': 'Move-Out',
    'convert_to_tenant': 'Convert to Tenant',
    'confirm_booking': 'Confirm Booking',
    'cancel_booking': 'Cancel Booking',
    'at_12_pm': 'at 12:00 PM',
    'extending': 'Extending...',
    'renewing': 'Renewing...',
    'cancel_booking_question': 'Are you sure you want to cancel this booking?',
    'yes_cancel': 'Yes, Cancel',
    'keep_it': 'Keep It',
    'cancellation_reason': 'Cancellation Reason',
    'booking_confirmed': 'Booking confirmed',
    'booking_cancelled': 'Booking cancelled',
    'booking_converted': 'Successfully converted booking to tenant!',
    'process_to_booking': 'Process to Booking',
    'waitlist_management': 'Waitlist Management',
    'waitlist_empty': 'Waitlist is empty',
    'search_waitlist': 'Search waitlist...',
    'priority': 'Priority',
    'desired_unit': 'Desired Unit',
    'move_in_preference': 'Move-in Preference',
    'added': 'Added',
    'rank': 'Rank',
    'process_waitlist_success': 'Successfully converted to a pending booking!',
    'remove_from_waitlist': 'Are you sure you want to remove this entry from the waitlist?',
    'entry_removed': 'Entry removed',
    'hold_expires': 'Hold Expires',
    'hours': 'Hours',
    'optional': 'Optional',
    'apartment_element': 'Apartment Element',
    'select_unit': 'Select Unit',
    'error_loading_data': 'Failed to load data',
    'error_saving_booking': 'Error saving booking',
    'save_changes': 'Save Changes',
    'select_apartment_move_in_date_error': 'Please select an apartment and move-in date to check availability',
    'apartment_available': 'Apartment is available for these dates!',
    'error_checking_availability': 'Error checking availability',
    'confirm_conflict_booking': 'There are date conflicts. Are you sure you want to proceed?',
    'booking_updated': 'Booking updated successfully',
    'booking_number': 'Booking #{{id}}',
    'created_at': 'Created {{date}}',
    'created_by': 'by {{name}}',
    'system': 'System',
    'confirm': 'Confirm',
    'target_property': 'Target Property',
    'furnished': 'Furnished',
    'unfurnished': 'Unfurnished',
    'booking_window': 'Booking Window',
    'indefinite': 'Indefinite',
    'created_source': 'Created ({{source}})',
    'view_tenant_profile': 'View Tenant Profile',
    'convert_to_active_tenant': 'Convert to Active Tenant',
    'lease_details_move_in_instruction': 'Complete the following lease details to move {{name}} into Unit {{unit}}.',
    'monthly_rent': 'Monthly Rent',
    'first_payment_date': 'First Payment Date',
    'contract_start': 'Contract Start',
    'contract_end': 'Contract End',
    'confirm_convert': 'Confirm & Convert',
    'confirm_booking_question': 'Finalize Booking: Are you sure you want to confirm this reservation and block the unit for this prospect?',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'reason_optional': 'Please provide a reason (optional):',
    'amount': 'Amount',
    'today': 'Today',
    'sun': 'Sun',
    'mon': 'Mon',
    'tue': 'Tue',
    'wed': 'Wed',
    'thu': 'Thu',
    'fri': 'Fri',
    'sat': 'Sat',
    'more': 'More',
    'close': 'Close',
    'hold_expiration': 'Hold Expiration',
    'view_details': 'View Details',
    'waitlist_management': 'Waitlist Management',
    'search_waitlist': 'Search waitlist...',
    'waitlist_empty': 'Waitlist is empty',
    'no_prospective_tenants_waiting': 'No prospective tenants are currently waiting for apartment availability.',
    'priority': 'Priority',
    'rank': 'Rank: {{priority}}',
    'desired_unit': 'Desired Unit',
    'move_in_preference': 'Move-in Preference',
    'process_to_booking': 'Process to Booking',
    'remove': 'Remove',
    'remove_waitlist_confirm': 'Are you sure you want to remove this entry from the waitlist?',
    'waitlist_processed': 'Successfully converted to a pending booking!',
    'entry_removed': 'Entry removed',
    'failed_process_waitlist': 'Failed to process waitlist entry',
    'failed_remove_entry': 'Failed to remove entry',
    'booking_analytics': 'Booking Analytics',
    'track_conversion_and_holds': 'Track conversion rates and hold durations',
    'last_7_days': 'Last 7 Days',
    'last_30_days': 'Last 30 Days',
    'last_90_days': 'Last 90 Days',
    'last_year': 'Last Year',
    'total_bookings': 'Total Bookings',
    'in_selected_period': 'In selected period',
    'conversion_rate': 'Conversion Rate',
    'converted_to_tenants': '{{count}} converted to tenants',
    'cancellation_rate': 'Cancellation Rate',
    'cancelled_holds': '{{count}} cancelled holds',
    'avg_hold_time': 'Avg Hold Time',
    'before_conversion_cancel': 'Before conversion/cancel',
    'volume_trends': 'Volume Trends',
    'no_trend_data': 'No trend data available',
    'total_holds': 'Total Holds',
    'status_breakdown': 'Status Breakdown',
    'no_status_data': 'No status data available',
    'active_holds': 'Active Holds',
    'overdue_rent': 'Overdue Rent',
    'subscription': 'Subscription',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Apartment {{number}} - Floor {{floor}}',
    'building_view': 'Building View',
    'showing_all_apartments': 'Showing all apartments',
    'expand_all_floors': 'Expand all floors',
    'collapse_all_floors': 'Collapse all floors',
    'pending_move_in': 'Pending Move-in',
    'tenant_name': 'Name',
    'tenant_phone': 'Phone',
    'tenant_email': 'Email',
    'lease_details': 'Lease Details',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'monthly_pay_date': 'Monthly Pay Date',
    'day_number': 'Day {{number}}',
    'duration': 'Duration',
    'months': 'Months',
    'remaining_time': 'Remaining Time',
    'financial_summary': 'Financial Summary',
    'monthly_rent': 'Monthly Rent',
    'effective_rent': 'Effective Rent',
    'rent_status': 'Rent Status',
    'future_tenant_upcoming_move_in': 'Future Tenant (Upcoming Move-In)',
    'move_in_date': 'Move-In Date',
    'contract_end': 'Contract End',
    'recent_bookings': 'Recent Bookings & Holds',
    'new_hold': 'New Hold',
    'available_now': 'Available Now',
    'lease_ending_soon': 'Lease Ending Soon',
    'no_apartments_found': 'No suitable apartments found',
    'ready': 'Ready',
    'ends_in_days': 'Ends in {{count}}d',
    'search_unit': 'Search apartment...',
    'currently_occupied': 'Currently Occupied',
    'occupied': 'Occupied',
    'all_service_payments': 'All Service Payments',
    'manage_all_service_payments_across_buildings': 'Manage all service payments across buildings',
    'tenants_management': 'Tenants Management',
    'manage_tenants_and_leases': 'Manage tenants and leases',
    'past_tenants': 'Past Tenants',
    'lease_ended': 'Lease Ended',
    'end_lease_confirm_title': 'Confirm End of Lease',
    'end_lease_confirm_body': 'Are you sure you want to end this lease?',
    'no_past_tenants': 'No past tenants',
    'sign_up_to_get_started': 'Sign up to get started',
    'company_name': 'Company Name',
    'already_have_account': 'Already have an account?',
    'status_expired_description': 'This lease has expired. No further payments can be applied.',
    'lease_expired_warning': 'This lease has expired.',
    'tenant_lease_expired_message': 'No further payments can be applied.',
    'expired_on': 'Expired on',
    'manage_tenant': 'Manage Tenant',
    'move_in_pending': 'Move-in Pending',
    'lease_expired': 'Lease Expired',
    'create_hold': 'Create Hold',
    'billing_subscription': 'Billing & Subscription',
    'current_plan': 'Current Plan',
    'subscribe_now': 'Subscribe Now',
    'manage_your_subscription_and_billing': 'Manage your subscription and billing',
    'view_payment_logs': 'View Payment Logs',
    'view_activity_logs': 'View Activity Logs',
    'view_revenue_report': 'View Revenue Report',
    'view_occupancy_report': 'View Occupancy Report',
    'view_tenant_logs': 'View Tenant Logs',
    'login_success': 'Login Success',
    'logout_success': 'Logout Success',
    'record_payment': 'Record Payment',
    'occupied_status': 'Occupied',
    'financial_status': 'Financial Status',
    'occupancy_physical': 'Physical Occupancy',
    'unit_indicators': 'Unit Indicators',
    'furnished_unit': 'Furnished Unit',
    'lease_expired_short': 'Lease Expired',
    'lease_ended_short': 'Lease Ended',
    'expired_label': 'Expired',
    'scheduled_tenants': 'Scheduled Tenants',
    'multiple_leases': 'Multiple Leases',

    // Portal Common
    'owner_portal': 'Owner Portal',
    'tenant_portal': 'Tenant Portal',
    'sign_out': 'Sign Out',
    'indefinite': 'Indefinite',
    'total_value': 'Total Value',
    'remaining_balance': 'Remaining Balance',

    // Portal Navigation
    'lease_details': 'Lease Details',
    'installments': 'Installments',
    'documents': 'Documents',
    'announcements': 'Announcements',

    // Owner Portal / Admin
    'management_fees': 'Management Fees',
    'management_fees_subtitle': 'Overview of all landlord management revenue and schedules.',
    'ledger_subtitle': 'Detailed breakdown of your management fee installments and pending balances.',
    'agreements_subtitle': 'View all your management contracts and ownership records.',

    // Tenant Portal
    'welcome_back_user': 'Welcome back, {{name}}!',
    'tenancy_overview': "Here's what's happening with your tenancy today.",
    'current_balance': 'Current Balance',
    'action_required': 'Action required',
    'account_good_standing': 'Account in good standing',
    'view_lease_short': 'View lease details',
    'need_repairs': 'Need Repairs?',
    'repairs_subtitle': 'Submit a online maintenance ticket quickly.',
    'create_request': 'Create Request',
    'building_news': 'Building News & Notices',
    'payments_billing': 'Payments & Billing',
    'payments_subtitle': 'Manage your rent payments and view your transaction history.',
    'download_statement': 'Download PDF Statement',
    'amount_due': 'Current Amount Due',
    'due_on': 'Due on {{date}}',
    'pay_now': 'Pay Now',
    'transaction_history': 'Transaction History',
    'no_transactions': 'No transactions yet',
    'first_payment_message': 'Your payment history will appear here once you make your first payment.',
    'unit_display': 'Unit {{number}}',

    // Tenant Lease
    'lease_details_subtitle': 'Review your active rental agreement and property information.',
    'lease_signed': 'Lease Signed',
    'sign_lease_now': 'Sign Lease Now',
    'contract_term': 'Contract Term',
    'property_info': 'Property Information',
    'landlord_owner': 'Landlord / Owner',
    'electronic_signature_recorded': 'Electronic Signature Recorded',
    'signed_on': 'Signed on: {{date}}',
    'digital_trace': 'Digital Trace',
    'legal_disclosure': 'Legal Disclosure',
    'legal_disclosure_text': 'By signing this document electronically, you agree that your electronic signature is the legal equivalent of your manual signature on this Agreement.',
    'electronic_lease_signing': 'Electronic Lease Signing',
    'confirmation_statement': '"I {{name}}, hereby confirm that I have read and agree to all terms of the lease agreement for {{building}}, Unit {{unit}}."',
    'type_full_name': 'Type Full Name to Sign',
    'digital_verification_required': 'Digital Signature Verification Required',
    'complete_signing': 'Complete Signing',
    'lease_not_found': 'Lease Not Found',
    'lease_not_found_subtitle': 'Contact management if you believe this is an error.',

    // Lease Management
    'renew_lease': 'Renew Lease',
    'extend_lease': 'Extend Lease',
    'current_end_date': 'Current End Date',
    'new_end_date': 'New End Date',
    'extend': 'Extend',
    'transfer': 'Transfer',
    'transfer_apartment': 'Transfer Apartment',
    'current_apartment': 'Current Apartment',
    'select_new_apartment': 'Select New Apartment',
    'new_monthly_rent': 'New Monthly Rent',
    'transferring': 'Transferring...',
    'failed_to_transfer_tenant': 'Failed to transfer tenant',
    'tenant_transferred_success': 'Tenant transferred successfully',
    'expired': 'Expired',
    'select_option': 'Select Option',
    'invite_portal': 'Invite to Portal',
    'tenant_documents': 'Tenant Documents',
    'maintenance_requests': 'Maintenance Requests',
    'add_request': 'Add Request',
    'reported_on': 'Reported on',
    'send_portal_invitation': 'Send Portal Invitation',
    'fully_signed': 'Fully Signed',
    'voided': 'Voided',
    'upgrade_for_analytics': 'Upgrade for Analytics',
    'upgrade_analytics_message': 'Upgrade to unlock advanced analytics features.',
    'view_plans': 'View Plans',
    'choose_a_plan': 'Choose a Plan',
    'subscribe_with_stripe': 'Subscribe with Stripe',
    'manage_subscription': 'Manage Subscription',
    'subscribe_with_stripe': 'Subscribe with Stripe',
    'upgrade': 'Upgrade',
    'contact_sales': 'Contact Sales',
    'no_payment_history': 'No Payment History',
    'no_subscription_history': 'No Subscription History',

    // ID Documents (Tenant & Owner)
    'id_documents': 'ID Documents',
    'id_document_front': 'Front',
    'id_document_back': 'Back',
    'id_document_type': 'Document Type',
    'id_document_number': 'Document Number',
    'id_document_uploaded_at': 'Uploaded At',
    'select_document_type': 'Select document type',
    'national_id': 'National ID',
    'passport': 'Passport',
    'driving_license': 'Driving License',
    'residence_permit': 'Residence Permit',
    'other_document': 'Other',
    'document_number_placeholder': 'Enter document number (optional)',
    'front_side': 'Front Side',
    'back_side': 'Back Side',
    'drag_drop_or_click': 'Drag & drop or click to upload',
    'supported_formats': 'Supported: JPG, PNG, WEBP (max 5MB)',
    'upload_id_documents': 'Upload ID Documents',
    'uploading': 'Uploading...',
    'id_documents_uploaded': 'ID documents uploaded successfully',
    'id_documents_upload_failed': 'Failed to upload ID documents',
    'delete_document_side': 'Delete {{side}} document',
    'confirm_delete_document': 'Are you sure you want to delete this document?',
    'document_deleted': 'Document deleted successfully',
    'document_delete_failed': 'Failed to delete document',
    'no_id_documents': 'No ID documents uploaded yet',
    'view_document': 'View Document',
    'close_preview': 'Close Preview',
    'save_changes': 'Save Changes',
    'pending_upload': 'Pending Upload',
    'id_documents_tab': 'ID Documents',
    'tenant_id_documents': 'Tenant ID Documents',
    'owner_id_documents': 'Owner ID Documents',
    'id_documents_description': 'Upload and manage identity document images',

    // ── Waitlist ────────────────────────────────────────────────
    'waitlist': 'Waitlist',
    'waitlist_management': 'Waitlist Management',
    'search_waitlist': 'Search by name, phone, or unit...',
    'waitlist_empty': 'Waitlist is Empty',
    'no_prospective_tenants_waiting': 'No prospective tenants are currently waiting for a unit.',

    // Waitlist table columns
    'priority': 'Priority',
    'prospect': 'Prospect',
    'desired_unit': 'Desired Unit',
    'move_in_preference': 'Move-In Preference',
    'added': 'Added',
    'rank': '#{{priority}}',
    'process_to_booking': 'Convert to Booking',
    'remove': 'Remove',
    'remove_from_waitlist': 'Remove from Waitlist',
    'remove_waitlist_confirm': 'Are you sure you want to remove this prospect from the waitlist? This action cannot be undone.',

    // Waitlist status messages
    'waitlist_processed': 'Prospect converted to a pending booking successfully',
    'failed_process_waitlist': 'Failed to convert this waitlist entry to a booking',
    'entry_removed': 'Entry removed from waitlist',
    'failed_remove_entry': 'Failed to remove entry from waitlist',

    // Add to Waitlist Modal
    'add_to_waitlist': 'Add to Waitlist',
    'waitlist_form_subtitle': 'Prospect will be promoted automatically when the unit becomes available',
    'desired_unit': 'Desired Unit',
    'prospect_details': 'Prospect Details',
    'prospect_name': 'Prospect Name',
    'prospect_phone': 'Prospect Phone',
    'prospect_email': 'Prospect Email',
    'scheduling_priority': 'Scheduling & Priority',
    'preferred_move_in_date': 'Preferred Move-In Date',
    'higher_is_first': 'higher = first in queue',
    'priority_hint': 'Higher priority prospects move up the queue. Default is 0 (FIFO).',
    'priority_range_error': 'Priority must be between 0 and 10',
    'loading_apartments': 'Loading apartments...',
    'field_required': 'This field is required',
    'adding': 'Adding...',
    'added_to_waitlist': 'Prospect added to waitlist successfully',
    'failed_add_waitlist': 'Failed to add prospect to waitlist',
    'waitlist_auto_promote_info': 'When the selected apartment becomes available, this prospect will automatically be converted to a pending booking based on their priority and position in the queue.',
    'waitlist_notes_placeholder': 'Special requirements, source of lead, agent notes...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'Maintenance Hub',
    'track_and_assign_maintenance': 'Track tenant requests and assign work orders to vendors',
    'search_requests': 'Search by issue, tenant, or apartment...',
    'loading_requests': 'Loading requests...',
    'no_maintenance_found': 'No maintenance requests found',
    'issue': 'Issue',
    'location': 'Location',
    'tenant': 'Tenant',
    'assign_vendor': 'Assign Vendor',
    'update_status': 'Update Status',
    'status_updated': 'Status updated successfully',
    'error_updating_status': 'Error updating status',
    'error_fetching_data': 'Error fetching data',

    // Work Orders
    'create_work_order': 'Create Work Order',
    'work_order_created': 'Work order created and assigned',
    'error_creating_work_order': 'Error creating work order',
    'select_vendor': 'Select Vendor',
    'select_a_vendor': 'Select a Vendor',
    'estimated_cost': 'Estimated Cost',
    'scheduled_date': 'Scheduled Date',
    'work_description': 'Work Description',

    // Maintenance statuses
    'open': 'Open',
    'in_progress': 'In Progress',
    'completed': 'Completed',
    'cancelled': 'Cancelled',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'Vendor Management',
    'manage_maintenance_vendors': 'Manage third-party maintenance contractors and service providers',
    'add_vendor': 'Add Vendor',
    'add_new_vendor': 'Add New Vendor',
    'edit_vendor': 'Edit Vendor',
    'search_vendors': 'Search vendors by name or category...',
    'no_vendors_found': 'No vendors found',
    'vendor_name': 'Vendor Name',
    'category': 'Category',
    'contact_person': 'Contact Person',
    'vendor_created': 'Vendor created successfully',
    'vendor_updated': 'Vendor updated successfully',
    'vendor_deleted': 'Vendor deleted successfully',
    'update_vendor': 'Update Vendor',
    'save_vendor': 'Save Vendor',
    'confirm_delete_vendor': 'Are you sure you want to delete this vendor? This action cannot be undone.',
    'error_fetching_vendors': 'Error fetching vendors',
    'error_saving_vendor': 'Error saving vendor',
    'error_deleting_vendor': 'Error deleting vendor',
    'confirm_delete_vendor_title': 'Delete Vendor',
    'vendor_no_email': 'Vendor has no email address',
    'vendor_invite_saved': 'Invitation saved!',
    'vendor_invite_link_copied': 'Setup link copied to clipboard',
    'vendor_invite_failed': 'Failed to send invite',
    'vendor_invite_portal': 'Invite to vendor portal',
    'vendor_category_placeholder': 'e.g. Plumbing, IT, Electric',
    'vendor_1099_nec': 'Vendor 1099-NEC',
    'vendor_1099_desc': 'IRS annual reporting — vendors paid ≥ $600 in nonemployee compensation',
    'vendor_1099_disclaimer': '1099-NEC forms are required for any vendor (non-employee) paid ≥ $600 in a calendar year. The IRS filing deadline is typically January 31st. Always verify with a tax professional before filing.',
    '1099_required': '1099 Required',
    'no_vendor_payments_recorded': 'No vendor payments recorded for',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'Contract Templates',
    'manage_legal_templates_desc': 'Manage legal frameworks and automated rules for contracts.',
    'create_template': 'Create Template',
    'search_templates': 'Search templates...',
    'no_templates_found': 'No templates found',
    'create_first_template_desc': 'Start by creating your first legal contract template.',
    'no_description_provided': 'No description provided.',
    'default_rules': 'Default Rules',
    'failed_to_load_templates': 'Failed to load templates',
    'template_deleted_successfully': 'Template deleted successfully',
    'failed_to_delete_template': 'Failed to delete template',
    'confirm_delete_template': 'Are you sure you want to delete this template? This action cannot be undone.',

    // Contract Template Form
    'edit_template': 'Edit Template',
    'create_new_template': 'Create New Template',
    'template_details': 'Template Details',
    'template_name': 'Template Name',
    'is_active': 'Active Template',
    'legal_text': 'Legal Text Content',
    'default_variable_rules': 'Default Variable Rules',
    'default_rules_desc': 'Define default variables (like commission_rate) that the builder will use.',
    'add_rule': 'Add Rule',
    'no_default_rules': 'No default rules defined.',
    'variable_name_placeholder': 'Variable Name (e.g. commission_rate)',
    'default_value_placeholder': 'Default Value (e.g. 8)',
    'archive_template': 'Archive Template',
    'archive_template_confirm': 'Are you sure you want to archive this template? It will no longer be available for new contracts.',
    'archive': 'Archive',
    'template_archived_successfully': 'Template archived successfully',
    'failed_to_archive_template': 'Failed to archive template',
    'template_updated_successfully': 'Template updated successfully',
    'template_created_successfully': 'Template created successfully',
    'failed_to_save_template': 'Failed to save template',
    'failed_to_load_template': 'Failed to load template',

    // Contract types
    'management': 'Management',
    'lease': 'Lease',
    'sale': 'Sale',
    'lease_progress': 'Lease Progress',
    // Maintenance status (for translated <select> options)
    'status_open': 'Open',
    'status_in_progress': 'In Progress',
    'status_completed': 'Completed',
    'status_cancelled': 'Cancelled',
    // Maintenance priority badges
    'priority_low': 'Low',
    'priority_medium': 'Medium',
    'priority_high': 'High',
    'priority_urgent': 'Urgent',
    'priority_emergency': 'Emergency',
    // Estimated cost label
    'estimated_cost': 'Est. Cost',
    // Portal submissions (overview + id docs tab)
    'tenant_portal_submissions': 'Tenant Portal Submissions',
    'portal_submission_note': 'Files submitted by the tenant through their self-service portal',
    'tenant_proof_document': 'ID / Proof Document',
    'tenant_insurance_document': 'Insurance / Certificate',
    'not_submitted': 'Not Submitted',
    'saved': 'Saved',
    'payment_method': 'Method',
    'tenant_ledger': 'Tenant Ledger',
    'ledger_description': 'Immutable record of all charges and payments. Add credits to correct mistakes.',
    'ledger_generate_monthly': 'Generate Monthly',
    'ledger_add_charge': 'Add Charge',
    'ledger_add_credit': 'Add Credit',
    'ledger_apply_late_fee': 'Apply Late Fee',
    'ledger_late_fee': 'Late Fee',
    'ledger_charge': 'Charge',
    'ledger_deposit': 'Deposit',
    'ledger_payment': 'Payment',
    'ledger_credit': 'Credit',
    'ledger_charge_rent_fee': 'Charge (Rent / Fee)',
    'ledger_description_placeholder': 'e.g. Maintenance fee',
    'outstanding_balance': 'Outstanding Balance',
    'ledger_balance_note': 'Derived from all ledger entries',
    'ledger_total_entries': 'Total Entries',
    'ledger_no_entries': 'No ledger entries yet',
    'ledger_no_entries_hint': 'Generate the first monthly charge or record a manual charge above.',
    'ledger_balance_after': 'Balance After',
    'ledger_charge_added': 'Charge added to ledger',
    'ledger_charge_failed': 'Failed to add charge',
    'ledger_credit_added': 'Credit added to ledger',
    'ledger_credit_failed': 'Failed to add credit',
    'ledger_late_fee_applied': 'Late fee applied to ledger',
    'ledger_late_fee_failed': 'Failed to apply late fee',
    'ledger_monthly_generated': 'Monthly charge generated',
    'ledger_monthly_failed': 'Failed to generate charge',
    'ledger_load_failed': 'Failed to load ledger',
    'created_by': 'Created By',
    'expired': 'Expired',
    'expiring_soon': 'Expiring Soon',
    'email': 'Email',

    // ── Tenant Portal ─────────────────────────────────────────────────────────

    // Dashboard
    'failed_to_load_dashboard_data': 'Failed to load dashboard data',
    'welcome_back_user': 'Welcome back, {{name}}',
    'tenancy_overview': 'Your tenancy at a glance',
    'unit_display': 'Unit {{number}}',
    'current_balance': 'Current Balance',
    'action_required': 'Action Required',
    'account_good_standing': 'Account in good standing',
    'lease_ends': 'Lease Ends',
    'view_lease_short': 'View lease',
    'need_repairs': 'Need Repairs?',
    'repairs_subtitle': 'Submit a maintenance request',
    'create_request': 'Create Request',
    'quick_actions': 'Quick Actions',
    'pay_now': 'Pay Now',
    'recent_account_activity': 'Recent Account Activity',
    'view_ledger': 'View ledger',
    'no_ledger_entries_yet': 'No ledger entries yet',
    'active_maintenance': 'Active Maintenance',
    'view_all': 'View all',
    'all_clear_maintenance': 'All clear — no open requests',
    'maintenance_request_default': 'Maintenance Request',
    'building_news': 'Building News',
    'lease_progress': 'Lease Progress',
    'days_left': '{{days}} days left',
    'expires_today': 'Expires today!',
    'pct_elapsed': '{{pct}}% elapsed',
    'balance_after': 'bal:',

    // Payments
    'failed_to_load_payment_data': 'Failed to load payment data',
    'failed_to_initiate_payment': 'Failed to initiate payment',
    'payments_billing': 'Payments & Billing',
    'payments_billing_subtitle': 'Your rent history, service charges, and full account ledger',
    'download_statement': 'Download Statement',
    'current_amount_due': 'Current Amount Due',
    'due_on': 'Due on',
    'view_ledger_hint': 'Want to see exactly how this was calculated?',
    'view_your_ledger': 'View your ledger',
    'in_n_days': 'In {{count}} day',
    'in_n_days_plural': 'In {{count}} days',
    'due_today': '⚡ Due today',
    'all_paid_up': 'All paid up!',
    'tab_rent_payments': 'Rent Payments',
    'tab_service_charges': 'Service Charges',
    'tab_service_charges_due': 'Service Charges ({{count}} due)',
    'tab_account_ledger': 'Account Ledger',
    'transaction_history': 'Transaction History',
    'no_transactions': 'No transactions yet',
    'no_transactions_subtitle': 'Your payment history will appear here once payments are recorded.',
    'rejected': 'Rejected',
    'outstanding_service_charges': 'Outstanding Service Charges',
    'paid_service_history': 'Paid Service History',
    'service_charge_default': 'Service Charge',
    'pay': 'Pay',
    'paid_badge': 'Paid',
    'no_service_charges': 'No service charges',
    'no_service_charges_subtitle': 'You have no service charges at this time.',
    'account_balance': 'Account Balance',
    'ledger_calculated_from': 'Calculated from {{count}} ledger entries',
    'full_account_statement': 'Full Account Statement',
    'full_account_statement_subtitle': 'Every charge and payment on your account, with running balance.',
    'balance_after_col': 'Balance After',
    'no_ledger_entries': 'No ledger entries yet',
    'no_ledger_entries_subtitle': 'Your financial history will appear here once charges are posted.',
    'ledger_type_charge': 'Charge',
    'ledger_type_late_fee': 'Late Fee',
    'ledger_type_deposit': 'Deposit',
    'ledger_type_payment': 'Payment',
    'ledger_type_credit': 'Credit',
    'payment_success_stripe': 'Payment successful! Your account will be updated shortly.',
    'payment_cancelled_stripe': 'Payment was cancelled. No charge was made.',
    'online_payments_not_enabled': 'Online payments are not enabled yet.',

    // Lease
    'failed_to_load_lease_details': 'Failed to load lease details',
    'lease_signed_success': 'Lease signed successfully!',
    'failed_to_sign_lease': 'Failed to sign lease',
    'lease_pdf_download_success': 'Lease PDF downloaded successfully',
    'lease_pdf_download_failed': 'Failed to download lease PDF. Please try again.',
    'generating': 'Generating…',
    'download_pdf': 'Download PDF',
    'download_your_lease': 'Download your signed lease as PDF',
    'unit_prefix': 'Unit',
    'ip_trace': 'IP Trace:',
    'integrity_hash': 'Integrity Hash:',
    'signature_graphic': 'Signature Graphic:',
    'lease_details': 'Lease Details',
    'lease_details_subtitle': 'Your active lease agreement and payment information',
    'lease_signed': 'Signed',
    'sign_lease_now': 'Sign Lease Now',
    'contract_term': 'Contract Term',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'property_information': 'Property Information',
    'landlord_owner': 'Landlord / Owner',
    'payment_status': 'Payment Status',
    'payment_required': 'Payment required',
    'e_signature_recorded': 'E-Signature Recorded',
    'signed_on': 'Signed on',
    'legal_disclosure': 'Legal Disclosure',
    'legal_disclosure_text': 'This lease agreement is legally binding. By signing electronically, you agree to all terms and conditions. Ensure you have read the complete document before signing.',
    'lease_not_found': 'No Lease Found',
    'contact_management_error': 'Please contact management if you believe this is an error.',

    // Profile
    'my_profile': 'My Profile',
    'my_profile_subtitle': 'Update your contact information and password',
    'personal_information': 'Personal Information',
    'full_name': 'Full Name',
    'your_full_name_placeholder': 'Your full name',
    'phone_placeholder': '+1 234 567 8900',
    'email_placeholder': 'your@email.com',
    'save_changes': 'Save Changes',
    'change_password': 'Change Password',
    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',
    'min_8_chars': 'Min. 8 characters',
    'repeat_new_password': 'Repeat new password',
    'update_password': 'Update Password',
    'updating': 'Updating...',
    'passwords_do_not_match': 'Passwords do not match',
    'password_min_8': 'Password must be at least 8 characters',
    'failed_to_load_profile': 'Failed to load profile',
    'profile_updated': 'Profile updated successfully!',
    'password_changed': 'Password changed successfully!',
    'failed_to_update_profile': 'Failed to update profile',
    'failed_to_change_password': 'Failed to change password',
    'account_id': 'Account ID',
    'tenant_since': 'Tenant Since',

    // Inspections
    'my_inspections': 'My Inspections',
    'my_inspections_subtitle': 'Property inspection reports for your unit',
    'no_inspections_yet': 'No inspections yet',
    'no_inspections_subtitle': 'Completed inspection reports for your unit will appear here.',
    'items_checked': '{{done}}/{{total}} items checked',
    'inspection_items': 'Inspection Items',
    'general_notes': 'General Notes',
    'failed_to_load_inspections': 'Failed to load inspections',
    'inspection_type_move_in': 'Move-In',
    'inspection_type_move_out': 'Move-Out',
    'inspection_type_periodic': 'Periodic',
    'inspection_type_maintenance': 'Maintenance',
    'inspection_status_completed': 'Completed',
    'inspection_status_signed': 'Signed',
    'inspection_status_draft': 'Draft',

    // Services
    'service_charges_title': 'Service Charges',
    'service_charges_subtitle': 'Monthly building service fees for your unit',
    'total_charges': 'Total Charges',
    'outstanding_balance_label': 'Outstanding Balance',
    'service_charges_year': 'Service Charges — {{year}}',
    'no_service_charges_year': 'No service charges for {{year}}',
    'no_service_charges_year_hint': 'Service charges will appear here when generated by your building manager.',
    'paid_on': 'Paid on {{date}}',
    'unpaid': 'Unpaid',
    'pay_online': 'Pay Online',
    'service_paid_success': 'Service charge paid successfully!',
    'payment_canceled': 'Payment canceled.',
    'failed_to_load_service_charges': 'Failed to load service charges',

    // ── Owner Portal ──────────────────────────────────────────────────────────

    // Dashboard
    'portfolio_summary': 'Portfolio Summary',
    'portfolio_subtitle': 'Real-time performance metrics for {{name}}.',
    'portfolio_statement': 'Portfolio Statement',
    'total_units': 'Total Units',
    'occupancy_rate': 'Occupancy Rate',
    'active_leases': '{{count}} Active Leases',
    'monthly_revenue': 'Monthly Revenue',
    'vacant_units': 'Vacant Units',
    'installment_summary': 'Installment Summary',
    'view_detailed_ledger': 'View Detailed Ledger',
    'outstanding': 'Outstanding',
    'across_installments': 'Across {{count}} installments',
    'actions_required': '{{count}} Immediate Actions Required',
    'proceed_to_payments': 'Proceed to Payments',
    'revenue_performance': 'Revenue Performance (Last 6 Months)',
    'no_revenue_data': 'No revenue data found',
    'portfolio_distribution': 'Portfolio Distribution',
    'no_building_data': 'No building data found',
    'occupied_label': 'OCCUPIED',
    'ready_to_scale': 'Ready to scale?',
    'ready_to_scale_subtitle': 'Manage your properties with maximum visibility.',
    'financials': 'Financials',
    'approvals': 'Approvals',
    'failed_to_download_statement': 'Failed to download statement',

    // Properties
    'my_properties': 'My Properties',
    'my_properties_subtitle': 'An overview of all units within your management portfolio.',
    'portfolio_empty': 'Portfolio Empty',
    'portfolio_empty_subtitle': 'There are currently no units assigned to your account.',
    'floor_prefix': 'Floor',
    'current_rent': 'Current Rent',
    'per_month_short': '/mo',
    'sqm': 'sqm',

    // Maintenance
    'maintenance_approvals': 'Maintenance Approvals',
    'maintenance_approvals_subtitle': 'Review and approve repairs requested by tenants across your portfolio.',
    'no_maintenance_requests': 'No Maintenance Requests',
    'no_maintenance_subtitle': 'All your properties are currently well-maintained.',
    'pending_approval': 'Pending Approval',
    'approved_in_progress': 'Approved / In Progress',
    'rejected_cancelled': 'Rejected/Cancelled',
    'above_threshold': 'Above ${{amount}} Threshold',
    'high_priority': 'High Priority',
    'medium_priority': 'Medium Priority',
    'low_priority': 'Low Priority',
    'est_cost': 'Est. Cost',
    'approve': 'Approve',
    'reject': 'Reject',
    'request_status_updated': 'Request status updated',
    'failed_to_update_request': 'Failed to update request status',
    'failed_to_load_maintenance': 'Failed to load maintenance requests',
    'failed_to_load_properties': 'Failed to load your properties',

    // Financials
    'financial_overview': 'Financial Overview',
    'financial_subtitle': 'Track the revenue generated from your tenants across all properties.',
    'no_financial_data': 'No Financial Data',
    'no_payments_message': 'There are currently no recorded payments for your portfolio.',
    'recent_payments': 'Recent Payments',
    'generating': 'Generating…',
    'overdue_payments': 'Overdue Payments',
    'property_tenant': 'Property / Tenant',
    'gross_amount': 'Gross Amount',
    'commission': 'Commission',
    'net_amount': 'Net Amount',
    'since': 'Since',
    'amount_owed': 'Amount Owed',
    'management_commission': 'Management Commission',
    'failed_to_load_financials': 'Failed to load financial records',
    'statement_downloaded': 'Statement for {{month}} {{year}} downloaded!',

    // Profile
    'member_since': 'Member Since',
    'saving': 'Saving...',

    // Messages
    'owner_messages_title': 'Property Administration',
    'owner_messages_subtitle': 'Direct message with the management team',

    // Messages
    'management_team': 'Management Team',
    'management_team_subtitle': 'Direct message with property administration',
    'message_empty_state': 'Send a message to contact management.',
    'message_placeholder': 'Type a message to administration...',
    'failed_to_load_messages': 'Failed to load messages',
    'failed_to_send_message': 'Failed to send message',

    // OwnerServices
    'owner_service_charges': 'Service Charges',
    'owner_service_charges_subtitle': 'Monthly building service fees for your vacant units',
    'owner_service_info': 'Service charges only apply to your <strong>vacant</strong> units. Units occupied by tenants are billed directly to the tenant.',
    'total_charges': 'Total Charges',
    'outstanding_balance': 'Outstanding Balance',
    'no_service_charges_year': 'No service charges for {{year}}',
    'no_service_charges_subtitle': 'Service charges for vacant units will appear here when generated.',
    'paid_on': 'Paid on {{date}}',
    'pay_online': 'Pay Online',
    'service_charge_paid': 'Service charge paid successfully!',
    'unpaid': 'Unpaid',

    // OwnerContracts / OwnerInstallments
    'my_agreements': 'My Agreements',
    'agreements_subtitle': 'View all your management contracts and ownership records.',
    'no_active_agreements': 'No Active Agreements',
    'no_contracts_message': "You don't have any management contracts recorded in our system yet.",
    'total_value': 'Total Value',
    'remaining': 'Remaining',
    'indefinite': 'Indefinite',
    'sign_now': 'Sign Now',
    'failed_to_load_agreements': 'Failed to load agreements',
    'financial_ledger': 'Financial Ledger',
    'ledger_subtitle': 'Detailed breakdown of your management fee installments and pending balances.',
    'total_outstanding': 'Total Outstanding',
    'no_installments': 'No installments found in your ledger.',
    'settled': 'Settled',
    'pay_amount': 'Pay {{amount}}',
    'failed_to_load_installments': 'Failed to load installment schedule',
    'failed_to_initiate_payment': 'Failed to initiate payment',
    'error_connecting_payment': 'Error connecting to payment provider',
    'payment_success_msg': 'Payment completed successfully!',
    'payment_canceled_msg': 'Payment was canceled.',

    // ── Layout / Sidebar / Header ─────────────────────────────────────────────
    'welcome_user': 'Welcome, {{name}}!',
    'owner_portal': 'Owner Portal',
    'tenant_portal': 'Tenant Portal',
    'owner': 'Owner',
    'tenant': 'Tenant',

    // Sidebar section headings
    'core': 'Core',
    'properties_&_contracts': 'Properties & Contracts',
    'financial': 'Financial',
    'financial_&_lease': 'Financial & Lease',
    'maintenance': 'Maintenance',

    // Sidebar nav item labels
    'Dashboard': 'Dashboard',
    'Properties': 'Properties',
    'Contracts': 'Contracts',
    'Installments': 'Installments',
    'Service Charges': 'Service Charges',
    'Financials': 'Financials',
    'Maintenance': 'Maintenance',
    'Payments': 'Payments',
    'Lease Details': 'Lease Details',
    'Inspections': 'Inspections',
    'Profile': 'Profile',
    'documents': 'Documents',
    'announcements': 'Announcements',
    'messages': 'Messages',
    'Messages': 'Messages',

    // ── Tenant Maintenance ────────────────────────────────────────────────
    'maintenance_subtitle': 'Submit and track all your maintenance requests in one place.',
    'new_request': 'New Request',
    'report_an_issue': 'Report an Issue',
    'issue_summary': 'Issue Summary',
    'issue_summary_placeholder': 'e.g. Leaking faucet in bathroom',
    'urgency_level': 'Urgency Level',
    'low_urgency': 'Low – Not urgent',
    'normal_urgency': 'Normal – Needs attention',
    'high_urgency': 'High – Affects daily life',
    'emergency_urgency': 'Emergency – Immediate action needed',
    'describe_the_problem': 'Describe the Problem',
    'describe_problem_placeholder': 'Please describe the issue in as much detail as possible...',
    'upload_photo_optional': 'Upload Photo (Optional)',
    'add_photo': 'Add Photo',
    'photo_upload_tip': 'A photo helps us resolve your issue faster.',
    'photo_upload_specs': 'JPG, PNG or WEBP. Max 5MB.',
    'emergency_contact_warning': 'For life-threatening emergencies, please call emergency services immediately. We will treat this request as a top priority.',
    'processing': 'Processing...',
    'submit_request': 'Submit Request',
    'ongoing_past_requests': 'Ongoing & Past Requests',
    'submitted': 'Submitted',
    'in_progress': 'In Progress',
    'completed': 'Completed',
    'request_cancelled': 'Request Cancelled',
    'all_clear': 'All Clear!',
    'no_maintenance_on_record': 'No maintenance requests on record. Everything looks great!',
    'resolved_on': 'Resolved on {{date}}',
    'failed_to_load_maintenance_requests': 'Failed to load maintenance requests',
    'failed_to_submit_request': 'Failed to submit request',
    'photo_size_limit_error': 'Photo must be less than 5MB',
    'request_submitted_success': 'Request submitted successfully',
    'low': 'Low',
    'normal': 'Normal',
    'high': 'High',
    'emergency': 'Emergency',
    'id': 'ID',

    // ── Tenant Announcements ───────────────────────────────────────────────
    'announcements_subtitle': 'Stay up to date with the latest news and updates from your building management.',
    'no_announcements_title': 'No Announcements',
    'no_announcements_subtitle': 'Check back later for updates from your building management.',
    'posted_by': 'Posted by {{name}}',
    'failed_to_load_announcements': 'Failed to load announcements',

    // ── Tenant Documents ───────────────────────────────────────────────────
    'documents_verification': 'Documents & Verification',
    'documents_verification_subtitle': 'Upload and manage your required documents. Keeping your documents up to date ensures a smooth tenancy experience.',
    'supported_formats_specs': 'Accepted formats: PDF, JPG, JPEG, PNG. Maximum file size 5MB per document.',
    'identification_proof': 'Proof of Identification',
    'identification_proof_desc': 'Government-issued ID such as a passport, national ID, or driver\'s license.',
    'renters_insurance': 'Renters Insurance',
    'renters_insurance_desc': 'A valid renters insurance certificate covering your unit.',
    'verified': 'Verified',
    'missing': 'Missing',
    'pdf_document': 'PDF Document',
    'view_full_size': 'View Full Size',
    'replace': 'Replace',
    'upload_file': 'Upload File',
    'need_help_verification': 'Need Help with Verification?',
    'need_help_verification_subtitle': 'If you have trouble uploading your documents or need to submit an alternative form of identification, contact our support team and we\'ll be happy to help.',
    'contact_support': 'Contact Support',
    'failed_to_load_document_status': 'Failed to load document status',
    'file_size_large_error': 'File size too large. Max 5MB.',
    'document_uploaded_success': 'Document uploaded successfully',
    'failed_to_upload_document': 'Failed to upload document',

    // ── Tenant Inspections ─────────────────────────────────────────────────
    'my_inspections': 'My Inspections',
    'my_inspections_subtitle': 'View all property inspections related to your tenancy.',
    'no_inspections_yet': 'No Inspections Yet',
    'no_inspections_subtitle': 'Your property inspection records will appear here once completed.',
    'failed_to_load_inspections': 'Failed to load inspections',
    'inspection_type_move_in': 'Move-In',
    'inspection_type_move_out': 'Move-Out',
    'inspection_type_periodic': 'Periodic',
    'inspection_type_maintenance': 'Maintenance',
    'inspection_status_completed': 'Completed',
    'inspection_status_signed': 'Signed',
    'inspection_status_draft': 'Draft',
    'unit_prefix': 'Unit',
    'items_checked': '{{done}} / {{total}} items checked',
    'inspection_items': 'Inspection Items',
    'general_notes': 'General Notes',

    // ── Tenant Messages ────────────────────────────────────────────────────
    'management_team': 'Management Team',
    'management_team_subtitle': 'Direct line to your building management',
    'message_empty_state': 'No messages yet. Start the conversation!',
    'failed_to_load_messages': 'Failed to load messages',
    'failed_to_send_message': 'Failed to send message',
    'message_placeholder': 'Type a message...',

    // ── Tenant Lease ───────────────────────────────────────────────────────
    'lease_details_subtitle': 'Review your lease agreement, payment status, and digital signature.',
    'lease_not_found': 'No Lease Found',
    'contact_management_error': 'Please contact your building management for assistance.',
    'lease_signed': 'Signed',
    'download_your_lease': 'Download your lease as PDF',
    'generating': 'Generating...',
    'download_pdf': 'Download PDF',
    'sign_lease_now': 'Sign Lease Now',
    'contract_term': 'Contract Term',
    'property_information': 'Property & Owner',
    'landlord_owner': 'Landlord / Owner',
    'payment_status': 'Payment Status',
    'current_balance': 'Current Balance',
    'payment_required': 'Payment required',
    'account_good_standing': 'Account in good standing',
    'lease_signed_success': 'Lease signed successfully!',
    'failed_to_sign_lease': 'Failed to sign lease',
    'lease_pdf_download_success': 'Lease PDF downloaded successfully',
    'lease_pdf_download_failed': 'Failed to download lease PDF',
    'e_signature_recorded': 'Electronic Signature Recorded',
    'signed_on': 'Signed on',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'Your Signature',
    'legal_disclosure': 'Legal Disclosure',
    'legal_disclosure_text': 'This lease agreement is a legally binding document. By signing electronically, you agree to all terms and conditions outlined in the contract. If you have any questions, please contact your building management before signing.',

    // ── Tenant Payments ────────────────────────────────────────────────────
    'payments_billing': 'Payments & Billing',
    'payments_billing_subtitle': 'Track your rent payments, service charges, and account ledger.',
    'download_statement': 'Download Statement',
    'current_amount_due': 'Current Amount Due',
    'due_on': 'Due on',
    'view_ledger_hint': 'View your full transaction history in the',
    'view_your_ledger': 'Account Ledger',
    'all_paid_up': 'All Paid Up!',
    'tab_rent_payments': 'Rent Payments',
    'tab_service_charges': 'Service Charges',
    'tab_service_charges_due': 'Service Charges ({{count}} due)',
    'tab_account_ledger': 'Account Ledger',
    'transaction_history': 'Transaction History',
    'no_transactions': 'No Transactions Yet',
    'no_transactions_subtitle': 'Your rent payment history will appear here.',
    'outstanding_service_charges': 'Outstanding Service Charges',
    'service_charge_default': 'Service Charge',
    'paid_service_history': 'Paid Service History',
    'paid_badge': 'Paid',
    'no_service_charges': 'No Service Charges',
    'no_service_charges_subtitle': 'No service charges have been billed to your account.',
    'account_balance': 'Account Balance',
    'ledger_calculated_from': 'Calculated from {{count}} transactions',
    'full_account_statement': 'Full Account Statement',
    'full_account_statement_subtitle': 'Every charge and payment on your account',
    'no_ledger_entries': 'No Ledger Entries',
    'no_ledger_entries_subtitle': 'Your account activity will appear here.',
    'balance_after_col': 'Balance After',
    'ledger_type_charge': 'Charge',
    'ledger_type_late_fee': 'Late Fee',
    'ledger_type_deposit': 'Deposit',
    'ledger_type_payment': 'Payment',
    'ledger_type_credit': 'Credit',
    'payment_success_stripe': 'Payment successful! Your account has been updated.',
    'payment_cancelled_stripe': 'Payment cancelled. No charges were made.',
    'online_payments_not_enabled': 'Online payments are not enabled for your account.',
    'failed_to_initiate_payment': 'Failed to initiate payment',
    'failed_to_load_payment_data': 'Failed to load payment data',

    // ── Tenant Profile ─────────────────────────────────────────────────────
    'my_profile': 'My Profile',
    'my_profile_subtitle': 'Manage your personal information and account security.',
    'personal_information': 'Personal Information',
    'full_name': 'Full Name',
    'your_full_name_placeholder': 'Your full name',
    'phone_placeholder': '+1 (555) 000-0000',
    'email_placeholder': 'you@example.com',
    'saving': 'Saving...',
    'save_changes': 'Save Changes',
    'change_password': 'Change Password',
    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',
    'min_8_chars': 'Min. 8 characters',
    'repeat_new_password': 'Repeat new password',
    'passwords_do_not_match': 'Passwords do not match',
    'updating': 'Updating...',
    'update_password': 'Update Password',
    'account_id': 'Account ID',
    'tenant_since': 'Tenant since',
    'failed_to_load_profile': 'Failed to load profile',
    'profile_updated': 'Profile updated successfully',
    'failed_to_update_profile': 'Failed to update profile',
    'password_changed': 'Password changed successfully',
    'failed_to_change_password': 'Failed to change password',
    'password_min_8': 'Password must be at least 8 characters',

    // ── Tenant Services ────────────────────────────────────────────────────
    'service_charges_title': 'Service Charges',
    'service_charges_subtitle': 'View and pay your utility and service charge bills.',
    'total_charges': 'Total Charges',
    'outstanding_balance_label': 'Outstanding',
    'service_charges_year': 'Service Charges — {{year}}',
    'no_service_charges_year': 'No service charges for {{year}}',
    'no_service_charges_year_hint': 'Try selecting a different year.',
    'paid_on_date': 'Paid on {{date}}',
    'unpaid_label': 'Unpaid',
    'pay_online': 'Pay Online',
    'service_paid_success': 'Service charge paid successfully!',
    'payment_canceled': 'Payment was cancelled.',
    'failed_to_load_service_charges': 'Failed to load service charges',

    // ── Owner Dashboard ─────────────────────────────────────────────────────
    'portfolio_summary': 'Portfolio Summary',
    'portfolio_subtitle': 'Welcome back, {{name}}. Here\'s your property portfolio overview.',
    'portfolio_statement': 'Portfolio Statement',
    'total_units': 'Total Units',
    'occupancy_rate': 'Occupancy Rate',
    'active_leases': '{{count}} active leases',
    'monthly_revenue': 'Monthly Revenue',
    'vacant_units': 'Vacant Units',
    'installment_summary': 'Installment Summary',
    'view_detailed_ledger': 'View Detailed Ledger',
    'outstanding': 'Outstanding',
    'across_installments': 'Across {{count}} installments',
    'overdue': 'Overdue',
    'actions_required': '{{count}} actions required',
    'proceed_to_payments': 'Proceed to Payments',
    'revenue_performance': 'Revenue Performance',
    'no_revenue_data': 'No revenue data available',
    'portfolio_distribution': 'Portfolio Distribution',
    'no_building_data': 'No building data available',
    'occupied_label': 'occupied',
    'ready_to_scale': 'Ready to manage your portfolio?',
    'ready_to_scale_subtitle': 'Access key tools to stay on top of your properties',
    'failed_to_load_dashboard_data': 'Failed to load dashboard data',
    'failed_to_download_statement': 'Failed to download statement',

    // ── Owner Messages ─────────────────────────────────────────────────────
    'owner_messages_title': 'Messages',
    'owner_messages_subtitle': 'Direct communications with building management',

    // ── Owner Properties ───────────────────────────────────────────────────
    'my_properties': 'My Properties',
    'my_properties_subtitle': 'View all apartments and units assigned to your portfolio.',
    'portfolio_empty': 'No Properties Found',
    'portfolio_empty_subtitle': 'No apartments have been assigned to your portfolio yet. Contact your building manager for assistance.',
    'floor_prefix': 'Floor',
    'sqm': 'sqm',
    'current_rent': 'Current Rent',
    'per_month_short': '/mo',
    'failed_to_load_properties': 'Failed to load properties',

    // ── Owner Maintenance ──────────────────────────────────────────────────
    'maintenance_approvals': 'Maintenance Approvals',
    'maintenance_approvals_subtitle': 'Review and approve or reject tenant maintenance requests for your properties.',
    'failed_to_load_maintenance': 'Failed to load maintenance requests',
    'request_status_updated': 'Request status updated successfully',
    'failed_to_update_request': 'Failed to update maintenance request',
    'pending_approval': 'Pending Approval',
    'approved_in_progress': 'Approved / In Progress',
    'rejected_cancelled': 'Rejected / Cancelled',
    'above_threshold': 'Above threshold (${{amount}})',
    'no_maintenance_requests': 'No Maintenance Requests',
    'no_maintenance_subtitle': 'Tenant maintenance requests requiring your approval will appear here.',

    // ── Owner Financials ───────────────────────────────────────────────────
    'financial_overview': 'Financial Overview',
    'financial_subtitle': 'Track the revenue generated from your tenants across all properties.',
    'no_financial_data': 'No Financial Data',
    'no_payments_message': 'There are currently no recorded payments for your portfolio.',
    'recent_payments': 'Recent Payments',
    'property_tenant': 'Property / Tenant',
    'gross_amount': 'Gross Amount',
    'commission': 'Commission',
    'net_amount': 'Net Amount',
    'overdue_payments': 'Overdue Payments',
    'failed_to_load_financials': 'Failed to load financials',
    'statement_downloaded': 'Statement for {{month}} {{year}} downloaded',
    'management_commission': 'Management Commission',
    'unit_display': 'Unit {{number}}',
    'since': 'Since',
    'amount_owed': 'Amount Owed',

    // ── Owner Installments ─────────────────────────────────────────────────
    'financial_ledger': 'Financial Ledger',
    'ledger_subtitle': 'All installment payments across your property contracts.',
    'total_outstanding': 'Total Outstanding',
    'installment': 'Installment',
    'due_date': 'Due Date',
    'action': 'Action',
    'partial': 'Partial',
    'owner_contract': 'Owner Contract',
    'pay_amount': 'Pay {{amount}}',
    'settled': 'Settled',
    'no_installments': 'No installments found.',
    'failed_to_load_installments': 'Failed to load installments',
    'payment_success_msg': 'Payment successful! Thank you.',
    'payment_canceled_msg': 'Payment cancelled.',
    'error_connecting_payment': 'Error connecting to payment system',

    // ── Owner Services ─────────────────────────────────────────────────────
    'owner_service_charges': 'Service Charges',
    'owner_service_charges_subtitle': 'View and pay service fees billed to your properties.',
    'owner_service_info': 'Service charges are billed by building management. Please pay outstanding charges promptly to avoid service interruptions.',
    'outstanding_balance': 'Outstanding Balance',
    'service_charge_paid': 'Service charge paid successfully!',
    'paid_on': 'Paid on {{date}}',
    'unpaid': 'Unpaid',

    // ── Owner Contracts ────────────────────────────────────────────────────
    'my_agreements': 'My Agreements',
    'agreements_subtitle': 'Review and sign your property management contracts.',
    'no_active_agreements': 'No Agreements Found',
    'no_contracts_message': 'You currently have no contracts on file. Contact your building manager for assistance.',
    'management_agreement': 'Management Agreement',
    'total_value': 'Total Value',
    'remaining': 'Remaining',
    'failed_to_load_agreements': 'Failed to load agreements',

    // ── Shared Keys ────────────────────────────────────────────────────────
    'rent': 'Rent',
    'download_pdf': 'Download PDF',
    'generating': 'Generating…',

    // ── Admin Announcements Manager ────────────────────────────────────────
    'announcements_manager': 'Announcements',
    'announcements_manager_subtitle': 'Publish and manage announcements for tenants, owners, or specific buildings.',
    'new_announcement': 'New Announcement',
    'publish_announcement': 'Publish',
    'publishing': 'Publishing…',
    'all_announcements': 'All Announcements',
    'announcement_created': 'Announcement published successfully!',
    'announcement_create_failed': 'Failed to publish announcement.',
    'announcement_deleted': 'Announcement deleted.',
    'announcement_delete_failed': 'Failed to delete announcement.',
    'announcement_delete_confirm': 'Delete this announcement? This cannot be undone.',
    'announcement_fields_required': 'Title and content are required.',
    'announcement_building_required': 'Please select a building.',
    'announcement_title_placeholder': 'e.g. Scheduled water maintenance on Monday',
    'announcement_content_placeholder': 'Type your message here…',
    'target_audience': 'Target Audience',
    'audience_all': 'Everyone',
    'audience_tenants': 'Tenants Only',
    'audience_owners': 'Owners Only',
    'audience_building': 'Specific Building',
    'select_building': 'Select Building',
    'select_building_placeholder': '— choose a building —',
    'no_announcements_yet': 'No announcements yet',
    'no_announcements_yet_subtitle': 'Click "New Announcement" to send your first message.',
    'announcements_owner_subtitle': 'View the latest news and updates from your property manager.',
    'announcements_check_back': 'Check back later for news and updates from your property manager.',
    'posted_by': 'Posted by {{name}}',

    // ── Management Fee Report ──────────────────────────────────────────────────
    'management_fee_report': 'Management Fee Report',
    'management_fee_report_subtitle': 'Owner installment collection tracking & aging analysis',
    'ledger_activity_report': 'Ledger Activity Report',
    'ledger_activity_report_subtitle': 'All tenant ledger entries — charges, payments, late fees, credits & deposits',
    'ledger_type_charge': 'Charge',
    'ledger_type_late_fee': 'Late Fee',
    'ledger_type_deposit': 'Deposit',
    'ledger_type_payment': 'Payment',
    'ledger_type_credit': 'Credit',
    'ledger_net_balance': 'Net Owed',

    // Feature lock
    'feature_locked': 'Feature Locked',
    'mgmt_fee_analytics_required': 'Management Fee reports require the Analytics plan.',
    'upgrade': 'Upgrade',

    // Filters
    'year': 'Year',
    'month': 'Month',
    'all_months': 'All Months',
    'all_owners': 'All Owners',
    'all_statuses': 'All Statuses',
    'status_paid': 'Paid',
    'status_pending_upcoming': 'Pending (upcoming)',
    'status_overdue': 'Overdue',
    'status_partial': 'Partial',
    'status_cancelled_label': 'Cancelled',
    'clear_filters': 'Clear filters',

    // Action buttons
    'print_pdf': 'Print / PDF',
    'export_csv': 'Export CSV',
    'exporting': 'Exporting…',

    // KPI cards
    'total_expected': 'Total Expected',
    'total_collected': 'Total Collected',
    'overdue_balance': 'Overdue Balance',
    'collection_rate': 'Collection Rate',
    'n_installments': '{{count}} installments',
    'n_paid': '{{count}} paid',
    'n_overdue_installments': '{{count}} overdue installments',
    'n_upcoming': '{{count}} upcoming',

    // Monthly chart
    'monthly_breakdown': 'Monthly Breakdown — {{year}}',
    'monthly_breakdown_filtered': 'Monthly Breakdown — {{year}} (filtered to {{month}})',
    'chart_expected': 'Expected',
    'chart_collected': 'Collected',
    'chart_overdue': 'Overdue',
    'no_installment_data_year': 'No installment data for {{year}}',

    // Bar chart tooltips
    'tooltip_expected': 'Expected:',
    'tooltip_collected': 'Collected:',
    'tooltip_overdue': 'Overdue:',

    // All Installments table
    'all_installments': 'All Installments',
    'n_records': '{{count}} record',
    'n_records_plural': '{{count}} records',
    'page_of': 'page {{page}}/{{total}}',
    'no_installments_found': 'No installments found',
    'try_adjusting_filters': 'Try adjusting your filters.',

    // Table column headers
    'col_owner': 'Owner',
    'col_apt': 'Apt',
    'col_building': 'Building',
    'col_due_date': 'Due Date',
    'col_amount': 'Amount',
    'col_paid': 'Paid',
    'col_balance': 'Balance',
    'col_status': 'Status',
    'col_days_late': 'Days Late',

    // Footer totals row
    'totals_all_pages': 'Totals (all pages):',

    // Pagination
    'previous': '← Previous',
    'next': 'Next →',
    'page_x_of_y': 'Page {{page}} of {{total}} ({{count}} total)',

    // Aging / Overdue table
    'overdue_aging_title': 'Overdue Installments — Aging Analysis',
    'col_aging': 'Aging',
    'all_installments_up_to_date': 'All installments are up to date!',
    'no_overdue_found': 'No overdue management fee installments found.',
    'total_overdue': 'Total Overdue:',
    'n_days': '{{count}} days',

    // Aging bucket labels
    'aging_1_30': '1–30 days',
    'aging_31_60': '31–60 days',
    'aging_61_90': '61–90 days',
    'aging_90_plus': '90+ days',

    // Status badge labels
    'badge_paid': 'Paid',
    'badge_partial': 'Partial',
    'badge_pending': 'Pending',
    'badge_overdue': 'Overdue',
    'badge_cancelled': 'Cancelled',

    // Failed / error
    'failed_to_load_mgmt_fee_report': 'Failed to load management fee report',
    'export_failed': 'Export failed',
    'export_downloaded_label': 'Downloaded: {{label}}',

    // Sidebar & Navigation
    'finance': 'Finance',
    'transactions': 'Transactions',
    'service_charges': 'Service Charges',
    'owner_installments': 'Owner Installments',
    'messages': 'Messages',
    'announcements_manager': 'Announcements Manager',
    'all_announcements': 'All Announcements',
    'sales': 'Sales',
    'sales_management': 'Sales Management',
    'inspections': 'Inspections',
    'all_inspections': 'All Inspections',
    'renewal_risk': 'Renewal Risk',
    'lease_renewals': 'Lease Renewals',
    'lease_applications': 'Lease Applications',
    'application_links': 'Application Links',
    'leases': 'Leases',
    'violations': 'Violations',
    'notices': 'Notices',
    'screening': 'Screening',
    'documents': 'Documents',
    'amenities_parking': 'Amenities & Parking',

    // Messages
    'messages_title': 'Messages',
    'tenants_tab': 'Tenants',
    'owners_tab': 'Owners',
    'no_conversations': 'No conversations yet',
    'select_conversation_hint': 'Select a conversation from the left to start messaging',
    'type_message_placeholder': 'Type a message...',
    'your_inbox': 'Your Inbox',
    'you_label': 'You: ',
    'mark_as_read': 'Mark as read',
    'failed_to_load_messages': 'Failed to load messages',
    'failed_to_load_chat_history': 'Failed to load chat history',
    'failed_to_send_message': 'Failed to send message',
    'no_messages_yet': 'No messages yet. Say hello!',
    'unit_label': 'Unit',

    // Expenses
    'expenses_title': 'Expenses',
    'expenses_subtitle': 'Operational expense tracking with approval workflow',
    'new_expense': 'New Expense',
    'new_expense_subtitle': 'Record an operational expense',
    'total_expenses': 'Total Expenses',
    'approved_amount': 'Approved',
    'how_it_works': 'How It Works',
    'expense_hint1': 'Record any cost paid for a building: repairs, cleaning, management fees, etc.',
    'expense_hint2': 'Expenses marked "Pending" need approval before they affect NOI',
    'expense_hint3': '"Charge to owner" posts the expense directly to the owner\'s ledger',
    'expense_hint4': 'NOI = Rent Collected − Approved Expenses',
    'search_expenses': 'Search by description, vendor, category…',
    'expense_records': 'Expense Records',
    'no_expenses_found': 'No expenses found',

    // Storage / Inventory
    'storage_title': 'Storage',
    'storage_subtitle': 'Track items in storage and issue them to apartments — auto-posts to Expenses',
    'add_stock': 'Add Stock',
    'stock_value': 'Stock Value',
    'items_in_storage': 'Items in Storage',
    'total_issued': 'Total Issued',
    'stock_on_hand': 'Stock on Hand',
    'issuance_history': 'Issuance History',
    'quantity_on_hand': 'On Hand',
    'issue_to_apartment': 'Issue to Apartment',
    'issue': 'Issue',
    'storage_hint1': 'Log items into storage first: doors, windows, fixtures, etc. — no apartment needed yet',
    'storage_hint2': '"Issue to Apartment" moves stock to a unit and posts the cost automatically',
    'storage_hint3': 'Issued cost posts as a pending expense for approval',
    'storage_hint4': 'Spend-per-apartment summary shows total cost by unit, based on what was actually issued',
    'search_materials': 'Search by item, apartment, vendor…',
    'no_materials_found': 'Nothing here yet',
    'spend_by_apartment': 'Spend by Apartment',
    'apartment_label': 'Apartment',
    'item_name': 'Item',
    'item_name_placeholder': 'e.g. Interior Door, Double-Pane Window',
    'items_logged': 'Items',
    'quantity': 'Quantity',
    'quantity_required': 'Quantity is required',
    'quantity_exceeds_stock': 'Only {{available}} available in stock',
    'available_short': '{{qty}} available',
    'unit_cost': 'Unit Cost',
    'total_cost': 'Total Cost',
    'select_apartment': 'Select apartment',
    'stock_added': 'Stock added to storage',
    'material_issued': 'Issued to apartment and posted to expenses',
    'failed_to_load_materials': 'Failed to load storage data',
    'failed_to_load_apartments': 'Failed to load apartments — check your connection and try again',
    'approve': 'Approve',
    'void': 'Void',
    'confirm_void': 'Void this expense? This cannot be undone.',
    'expense_description_placeholder': 'e.g. Monthly pest control service',
    'select_category': '— Select Category —',
    'charge_to_owner': 'Charge to owner (will post to owner ledger)',
    'create_expense': 'Create Expense',
    'expense_created': 'Expense created',
    'expense_approved': 'Expense approved',
    'expense_voided': 'Expense voided',
    'invoice_number': 'Invoice #',
    'all_statuses': 'All Statuses',
    'failed_to_load_expenses': 'Failed to load expenses',
    'expense_rejected': 'Expense rejected',
    'confirm_reject': 'Reject this expense? This cannot be undone.',
    'date_from': 'Date From',
    'date_to': 'Date To',
    'failed_to_load': 'Failed to load data',
    'assign_failed': 'Assignment failed',
    'unavailable': 'Unavailable',
    'filtered_by': 'Filtered by:',
    'calendar': 'Calendar',
    'notes_placeholder': 'Additional notes…',
    'no_amenities_match_filter': 'No amenities match the selected filter.',
    'all_amenities': 'All Amenities',
    'no_bookings_on_day': 'No bookings on this day.',
    'parking_assigned': 'Parking assigned',
    'parking_unassigned': 'Parking unassigned',
    'parking_space_deleted': 'Parking space deleted',
    'parking_space_created': 'Parking space created',
    'parking_space_updated': 'Parking space updated',
    'parking_spaces_generated': 'Parking spaces generated in bulk',
    'booking_deleted': 'Booking deleted',
    'parking_layout_hint': 'Assign rows via Edit Space to organize your parking layout',
    'delete_amenity_title': 'Delete Amenity',
    'confirm_delete_amenity': 'Are you sure you want to delete this amenity? This cannot be undone.',
    'delete_parking_space_title': 'Delete Parking Space',
    'confirm_delete_parking': 'Are you sure you want to delete this parking space? This cannot be undone.',
    'delete_booking_title': 'Delete Booking',
    'confirm_delete_booking': 'Are you sure you want to delete this booking? This cannot be undone.',
    'unassign_parking_title': 'Unassign Parking',
    'confirm_unassign_parking': 'Are you sure you want to unassign this parking space?',
    'start_end_required': 'Start and end numbers required',
    'space_number_required': 'Space number is required',
    'row_zone': 'Row / Zone',
    'row_zone_hint': 'for map layout',
    'status_pending_approval': 'Pending Approval',
    'status_approved': 'Approved',
    'status_voided': 'Voided',
    'status_rejected': 'Rejected',
    'owner_label': 'Owner',
    'select_building': '— Select Building —',
    'payment_method': 'Payment Method',
    'method_bank_transfer': 'Bank Transfer',
    'method_cash': 'Cash',
    'method_check': 'Check',
    'method_credit_card': 'Credit Card',
    'method_stripe': 'Stripe',
    'method_wire': 'Wire Transfer',
    'method_other': 'Other',
    'items_plural': 'items',
    'item_singular': 'item',
    'all_buildings': 'All Buildings',

    // Late Fees
    'late_fee_mgmt': 'Late Fee Management',
    'pending_charges': 'Pending Charges',
    'history_tab': 'History',
    'fee_settings': 'Fee Settings',
    'late_fees_disabled_hint': 'Late fees are disabled — enable in settings',
    'tenants_due_fee': 'Tenants due for a late fee',
    'next_cron_run': 'Next cron run at 10:00 AM org-time',
    'apply_now': 'Apply Now',
    'applying': 'Applying...',
    'waive': 'Waive',
    'waive_late_fee': 'Waive Late Fee',
    'waive_reason_label': 'Reason',
    'waive_reason_placeholder': 'e.g. Payment arrangement agreed, first-time courtesy, etc.',
    'confirm_waiver': 'Confirm Waiver',
    'waiving': 'Waiving...',
    'failed_to_load_pending': 'Failed to load pending charges',
    'failed_to_load_history': 'Failed to load history',
    'fee_waived': 'Fee waived',
    'failed_to_waive': 'Failed to waive',
    'late_fee_assessed': 'Late fee assessed',
    'failed_to_assess': 'Failed to assess',
    'days_overdue': 'Days Overdue',
    'projected_fee': 'Projected Fee',
    'last_fee': 'Last Fee',
    'waive_amount_label': 'Waiver Amount ($)',
    'not_found': 'Not found',
    'never': 'Never',
    'balance': 'Balance',
    'source': 'Source',
    'auto_label': 'Auto',
    'manual_label': 'Manual',
    'late_fees_disabled': 'Late fees disabled',
    'of_rent': 'of rent',
    'day_grace': 'day grace',
    'no_pending_late_fees': 'No tenants are pending a late fee right now.',
    'enable_late_fees_hint': 'Enable late fees in settings to start tracking.',
    'no_late_fee_records': 'No late fee records found.',
    'page_info': 'Page {{current}} of {{total}}',
    'failed_to_load_owner_balances': 'Failed to load owner balances',
    'select_at_least_one_owner': 'Select at least one owner',
    'confirm_bulk_payout': 'Pay {{count}} owner(s) a total of {{amount}}?',
    'bulk_payout_success': 'Paid {{count}} owner(s) — {{amount}} total',
    'bulk_payout_failed': 'Bulk payout failed',
    'bulk_owner_payout': 'Bulk Owner Payout',
    'bulk_payout_subtitle': 'Pay all owners with outstanding balances in one batch',
    'total_owed_all': 'Total Owed (all owners)',
    'owners_with_balance': 'Owners With Balance',
    'selected_to_pay': 'Selected to Pay',
    'balance_owed': 'Balance Owed',
    'last_payout': 'Last Payout',
    'payout_settings': 'Payout Settings',
    'period_month': 'Period Month',
    'payout_notes_placeholder': 'e.g. Monthly distribution',
    'pay_owners_btn': 'Pay {{count}} Owner(s) · {{amount}}',
    'last_batch_results': 'Last Batch Results',
    'wire_transfer': 'Wire Transfer',
    'wire_transfer': 'Wire Transfer',
    'status_held': 'Held',
    'status_returned': 'Returned',
    'status_not_collected': 'Not Collected',
    'error_loading_deposits': 'Failed to load security deposits',
    'deposit_collected': 'Security deposit collected',
    'deposit_returned': 'Security deposit returned',
    'security_deposits_subtitle': 'US/Canada compliant deposit tracking — legally separate from rent',
    'total_held': 'Total Held',
    'active_deposits': 'Active Deposits',
    'deposits_returned': 'Deposits Returned',
    'all_tenants_deposit_status': 'All Tenants — Deposit Status',
    'paid_on': 'Paid On',
    'collect': 'Collect',
    'return': 'Return',
    'collect_security_deposit': 'Collect Security Deposit',
    'return_security_deposit': 'Return Security Deposit',
    'damages_unpaid_rent': 'damages, unpaid rent, etc.',
    'optional_notes': 'Optional notes...',
    'record_collection': 'Record Collection',
    'record_return': 'Record Return',
    'deposit_amount_placeholder': 'e.g. 1500.00',
    'error_loading_utility_data': 'Failed to load utility data',
    'utility_account_created': 'Utility account created',
    'reading_recorded_generate_bills': 'Reading recorded — generate bills below',
    'rubs_complete_msg': 'RUBS complete — {{count}} tenants billed {{amount_each}} each (total {{total}})',
    'no_pending_bills_to_charge': 'No pending bills to charge',
    'confirm_charge_all_bills': 'Post {{count}} pending bills to tenant ledgers?',
    'confirm_charge_all_bills_title': 'Charge All Pending Bills',
    'charge_all_success_msg': '{{count}} bills posted to tenant ledgers!{{failed_msg}}',
    'generate_bills_btn': 'Generate Bills',
    'generate_from_meters': 'Generate from Meters',
    'charge_all_btn': 'Charge All ({{count}})',
    'bills_generated_msg': '{{count}} utility bills generated',
    'rubs_failed': 'RUBS calculation failed',
    'failed_to_update_account': 'Failed to update account',
    'utility_management': 'Utility Management',
    'utility_subtitle': 'Track meters, readings, and bill tenants for utility usage',
    'add_account': 'Add Account',
    'utility_accounts': 'Utility Accounts',
    'no_utility_accounts': 'No utility accounts — add one to get started',
    'provider': 'Provider',
    'account_number_label': 'Account #',
    'meter_number_label': 'Meter #',
    'utility_bills': 'Utility Bills',
    'no_bills_found_msg': 'No bills found — use "Generate Bills" to create them',
    'period': 'Period',
    'usage': 'Usage',
    'charge_tenant': 'Charge Tenant',
    'add_utility_account': 'Add Utility Account',
    'add_utility_account_subtitle': 'Register a new meter or utility service',
    'utility_type': 'Utility Type',
    'provider_name': 'Provider Name',
    'provider_placeholder': 'e.g. City Electric Co.',
    'shared_meter': 'Shared meter (covers entire building)',
    'add_meter_reading': 'Add Meter Reading',
    'reading_value': 'Current Reading',
    'reading_date': 'Reading Date',
    'record_reading': 'Record Reading',
    'record_reading': 'Record Reading',
    'error_loading_kpi_data': 'Failed to load KPI data',
    'snapshot_complete': 'Snapshot complete',
    'snapshot_failed': 'Snapshot failed',
    'kpi_dashboard': 'KPI Dashboard',
    'kpi_subtitle': 'Live portfolio performance — occupancy, NOI, cap rate, collection rate',
    'capturing': 'Capturing...',
    'snapshot_now': 'Snapshot Now',
    'occupancy_rate': 'Occupancy Rate',
    'annual_gross_rent': 'Annual Gross Rent',
    'portfolio_value': 'Portfolio Value',
    'total_units': 'Total Units',
    'units_occupied_msg': '{{occupied}} of {{total}} units occupied',
    'per_month_suffix': '{{amount}} / month',
    'equity_label_val': '{{amount}} equity',
    'vacant_units_count': '{{count}} vacant',
    'kpi_step1': 'Click "Snapshot Now" to calculate today\'s metrics for all buildings',
    'kpi_step2': 'Snapshot runs automatically every night',
    'kpi_step3': 'Record property valuations in the Portfolio page to unlock Cap Rate & Yield',
    'per_building_metrics': 'Per-Building Metrics',
    'no_snapshots_yet': 'No snapshots yet — click "Snapshot Now" to generate',
    'collection_rate': 'Collection',
    'monthly_noi': 'Monthly NOI',
    'cap_rate': 'Cap Rate',
    'gross_yield': 'Gross Yield',
    'overdue_tenants': 'Overdue',
    'investment_summary': 'Investment Summary',
    'current_value': 'Current Value',
    'purchase_cost': 'Purchase Cost',
    'equity': 'Equity',
    'equity': 'Equity',
    'error_loading_portfolio_data': 'Failed to load portfolio data',
    'valuation_recorded': 'Valuation recorded',
    'investment_portfolio': 'Investment Portfolio',
    'investment': 'Investment',
    'portfolio_subtitle': 'Portfolio valuation, equity, cap rate, and yield per building',
    'record_valuation': 'Record Valuation',
    'total_portfolio_value': 'Portfolio Value',
    'annualized_amount': '{{amount}} annualized',
    'avg_cap_rate': 'Avg Cap Rate',
    'annualized': 'Annualized',
    'avg_gross_yield': 'Avg Gross Yield',
    'gross_rent_on_value': 'Gross rent / value',
    'portfolio_step1': 'Click "Record Valuation" to enter the current market value of a building',
    'portfolio_step2': 'Cap Rate = Annual NOI ÷ Property Value × 100',
    'portfolio_step3': 'Gross Yield = Annual Gross Rent ÷ Property Value × 100',
    'portfolio_step4': 'NOI data comes from the KPI Dashboard — run a snapshot first',
    'per_building_breakdown': 'Per-Building Breakdown',
    'no_portfolio_data': 'No portfolio data — run a KPI snapshot first, then record valuations',
    'last_valuation': 'Last Valuation',
    'occupied_short': 'occ.',
    'no_valuation': 'No valuation',
    'update_value': 'Update Value',
    'record_valuation_subtitle': 'Record current market value for a building',
    'appraised_value': 'Appraised Value',
    'valuation_date': 'Date',
    'method': 'Method',
    'record': 'Record',
    'market': 'Market',
    'income': 'Income',
    'cost': 'Cost',
    'broker_opinion': 'Broker Opinion',
    'appraisal': 'Appraisal',
    'record': 'Record',
    'error_loading_accounts': 'Failed to load accounts',
    'error_loading_journal_entries': 'Failed to load journal entries',
    'error_loading_trial_balance': 'Failed to load trial balance',
    'error_loading_pnl': 'Failed to load P&L',
    'gl_account_required_fields': 'Code, name, and type are required',
    'account_created': 'Account created',
    'journal_min_lines_error': 'At least 2 lines required',
    'entry_out_of_balance_error': 'Entry out of balance: debits {{debits}} ≠ credits {{credits}}',
    'journal_account_required_error': 'All lines must have an account selected',
    'journal_entry_posted': 'Journal entry posted',
    'reason_for_reversal_prompt': 'Reason for reversal:',
    'entry_reversed': 'Entry reversed',
    'reversal_failed': 'Reversal failed',
    'chart_of_accounts': 'Chart of Accounts',
    'journal_entries': 'Journal Entries',
    'trial_balance': 'Trial Balance',
    'pnl_statement': 'P&L Statement',
    'general_ledger': 'General Ledger',
    'gl_subtitle': 'Chart of accounts, journal entries, trial balance & P&L',
    'new_gl_account': 'New GL Account',
    'normal_balance': 'Normal Balance',
    'no_accounts_found': 'No accounts found',
    'all_sources': 'All Sources',
    'new_entry': 'New Entry',
    'new_journal_entry': 'New Journal Entry',
    'select_account': 'Select account...',
    'line_description_placeholder': 'Line description',
    'balanced_msg': '✓ Balanced',
    'out_of_balance_amount': 'Out of balance by {{amount}}',
    'add_line': '+ Add line',
    'post_entry': 'Post Entry',
    'posting': 'Posting...',
    'no_journal_entries_found': 'No journal entries found',
    'reversed': 'Reversed',
    'posted': 'Posted',
    'draft': 'Draft',
    'lines_count': '{{count}} lines',
    'as_of_date': 'As of date',
    'balanced': 'Balanced',
    'out_of_balance': 'Out of Balance',
    'net': 'Net',
    'total_revenue': 'Total Revenue',
    'total_expenses': 'Total Expenses',
    'net_income': 'Net Income',
    'no_revenue_entries': 'No revenue entries',
    'no_expense_entries': 'No expense entries',
    'select_date_range_run_msg': 'Select a date range and click Run',
    'asset': 'Asset',
    'liability': 'Liability',
    'revenue': 'Revenue',
    'expense': 'Expense',
    'all_late_fee_charges': 'All late fee charges',
    'waive_confirm_hint': 'Waiving a late fee for {{name}}. This adds a credit entry to their ledger — the original charge is preserved for audit.',
    'enter_reason_error': 'Please enter a reason',
    'enter_valid_amount_error': 'Enter a valid amount',
    'confirm_manual_assess': 'Manually assess a late fee for {{name}}?',
    'search_late_fees': 'Search tenant, unit, building…',
    'page_info': 'Page {{current}} of {{total}}',
    "service_payments_for_building_year": "Service Payments for {{building}} - {{year}}",
    "no_apartments_on_floor": "No apartments found on this floor.",
    "tenant_owner": "Tenant/Owner",
    "no_owner": "No Owner",
    "rented": "Rented",
    "payment_due": "Payment Due",
    "paid_on": "Paid on",
    "marked_as_paid_via_service_management": "Marked as paid via service management",
    "marked_as_unpaid_via_service_management": "Marked as unpaid via service management",
    "payment_marked_as_paid": "Payment marked as paid successfully.",
    "payment_marked_as_unpaid": "Payment marked as unpaid successfully.",
    "no_floors_available": "No Floors Available",
    "no_floors_message": "There are no floors with apartments in this building, or no service payments have been generated yet.",
    "summary": "Summary",
    "floor_apartment_count": "{{floors}} floors, {{apartments}} apartments",
    "count_formatted": "({{count}})",
    "processing": "Processing...",
    "confirm_delete_payment": "Are you sure you want to delete the {{amount}} payment for {{tenantName}}? This action cannot be undone.",

    // Insurance Page
    "insurance_tracking": "Insurance Tracking",
    "insurance_desc": "Manage tenant, owner, and building insurance policies",
    "add_policy": "Add Policy",
    "edit_policy": "Edit Policy",
    "expiring_30d": "Expiring 30d",
    "total_coverage": "Total Coverage",
    "insurer": "Insurer",
    "insurer_name": "Insurer Name",
    "policy_number": "Policy Number",
    "policy_type": "Policy Type",
    "coverage_amount": "Coverage Amount",
    "annual_premium": "Annual Premium",
    "policy_added": "Policy added",
    "policy_updated": "Policy updated",
    "confirm_delete_policy": "Delete this policy?",
    "entity_type": "Entity Type",
    "entity_name": "Entity Name",
    "no_policies_found": "No policies found",
    "add_first_policy": "Add First Policy",
    "error_loading_insurance": "Failed to load insurance policies",
    "renters_insurance": "Renter's Insurance",
    "renters_insurance_desc": "Track coverage, compliance, and expiration dates for all residents",
    "audit_compliance": "Audit Compliance",
    "compliant": "Compliant",
    "non_compliant": "Non-Compliant",
    "expiring_soon": "Expiring Soon",
    "provider": "Provider",
    "expiration": "Expiration",
    "send_notice": "Send Notice",
    "view_policy": "View Policy",
    "no_insurance_records": "No insurance records found",
    "all_tenants_compliant_desc": "All tenants are currently compliant",

    // Email Template Form
    'et_new_title': 'New Email Template',
    'et_edit_title': 'Edit Email Template',
    'et_basic_info': 'Basic Info',
    'et_template_name': 'Template Name *',
    'et_template_name_placeholder': 'e.g. Monthly Rent Reminder',
    'et_trigger_event': 'Trigger Event',
    'et_description': 'Description',
    'et_description_placeholder': 'Optional internal note',
    'et_subject_line': 'Subject Line *',
    'et_subject_placeholder': 'e.g. Your rent of ${{rent_amount}} is due on {{due_date}}',
    'et_html_body': 'HTML Body',
    'et_editor': 'Editor',
    'et_preview': 'Preview',
    'et_quick_insert': 'Quick-Insert Variables',
    'et_update_btn': 'Update Template',
    'et_create_btn': 'Create Template',
    'et_created': 'Template created',
    'et_updated': 'Template updated',
    'et_failed_load': 'Failed to load template',
    'et_save_failed': 'Save failed',
    'et_fields_required': 'Name, subject, and body are required',

    // ── Utility Management ───────────────────────────────────
    'utility_management': 'Utility Management',
    'utility_subtitle': 'Track meters, generate bills, and charge tenants',
    'how_it_works': 'How It Works',
    'utility_step1': 'Add a utility account (electricity, water, gas…)',
    'utility_step2': 'Record a meter reading',
    'utility_step3': 'Generate bills from readings',
    'utility_step4': 'Charge bills directly to tenant ledger',
    'utility_accounts': 'Utility Accounts',
    'utility_bills': 'Utility Bills',
    'add_account': 'Add Account',
    'add_utility_account': 'Add Utility Account',
    'create_account': 'Create Account',
    'account_created': 'Account created successfully',
    'add_meter_reading': 'Add Meter Reading',
    'record_reading': 'Record Reading',
    'reading_value': 'Reading Value',
    'reading_date': 'Reading Date',
    'reading_recorded_generate_bills': 'Reading recorded — generate bills now',
    'reading_recorded_for': 'Reading recorded for {{name}}',
    'building_meter_hint': 'Building meter — use RUBS to split cost across all tenants',
    'individual_meter_hint': 'Individual meter — generate a bill for this unit',
    'generate_bills': 'Generate Bills',
    'generate_bills_now': 'Generate Bills Now',
    'run_rubs_btn': 'Run RUBS Split',
    'calculating': 'Calculating…',
    'charging': 'Charging…',
    'charge_tenant': 'Charge Tenant',
    'charge_all': 'Charge All',
    'bill_charged': 'Bill charged to tenant ledger',
    'no_pending_bills_to_charge': 'No pending bills to charge',
    'confirm_charge_bill': "Post this utility bill to the tenant's ledger?",
    'confirm_charge_all_bills': 'Post all {{count}} pending bills to tenant ledgers?',
    'charge_all_success_msg': '{{count}} bills charged{{failed_msg}}',
    'rubs_complete_msg': 'RUBS complete — {{count}} tenants charged {{amount_each}} each (total {{total}})',
    'no_utility_accounts': 'No utility accounts yet — click Add Account to get started',
    'no_bills_found_msg': 'No bills found — generate bills after recording readings',
    'error_loading_utility_data': 'Error loading utility data',
    'utility_type': 'Utility Type',
    'provider_name': 'Provider Name',
    'provider_placeholder': 'e.g. City Power Co.',
    'account_number_label': 'Account Number',
    'meter_number_label': 'Meter Number',
    'shared_meter': 'Shared meter (split between units)',
    'rate_per_unit': 'Rate per Unit',
    'unit_of_measure': 'Unit of Measure',
    'billing_day': 'Billing Day of Month',
    'reading': 'Reading',

    // Utility Billing Enhancement
    'issue_utility_bill': 'Issue Utility Bill',
    'tenant_billing_assignment': 'Tenant & Billing Assignment',
    'select_tenant': 'Select Tenant',
    'search_tenant_placeholder': 'Search by name or apartment number...',
    'utility_details': 'Utility Details',
    'period_month': 'Month',
    'period_year': 'Year',
    'due_date': 'Due Date',
    'posting_options': 'Posting Options',
    'charge_immediately': 'Charge to Ledger Immediately',
    'charge_immediately_desc_on': 'The amount will be posted to the tenant balance as soon as you save.',
    'charge_immediately_desc_off': 'The bill will be saved as "Pending" and you must charge it manually later.',
    'processing': 'Processing...',
    'issue_and_charge': 'Issue & Charge',
    'issue_bill': 'Issue Bill',
    'meter_identity_provider': 'Meter Identity & Provider',
    'account_number': 'Account Number',
    'meter_number': 'Meter Number',
    'shared_meter_rubs': 'Shared meter (RUBS split)',
    'pricing_unit_measurement': 'Pricing & Unit Measurement',
    'rate_per_unit': 'Rate per Unit ($)',
    'unit_of_measure': 'Unit of Measure',
    'billing_day_monthly': 'Billing Day (Monthly)',
    'internal_notes': 'Internal Notes',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'Edit Utility Account',
    'void_bill': 'Void Bill',
    'void_reason': 'Reason (optional)',
    'void_reason_placeholder': 'e.g. Billing error, duplicate...',
    'confirm_void_bill': 'This bill will be voided and cannot be charged.',
    'confirm_void_bill_sent': 'This bill was already charged. A credit entry will be issued to reverse it.',
    'bill_voided': 'Bill voided',
    'bill_marked_paid': 'Bill marked as paid',
    'confirm_mark_paid': 'Mark this bill as paid (external payment)?',
    'deactivate_utility_account': 'Deactivate Account',
    'confirm_deactivate_utility_account': 'Are you sure you want to deactivate this utility account?',
    'post_utility_charge': 'Post Utility Charge',
    'account_updated': 'Account updated successfully',
    'utility_bill': 'Utility Bill',
    'tenant_info': 'Tenant',
    'tenant_name_5': 'Name',
    'email_15': 'Email',
    'reading_history': 'Reading History',
    'usage_breakdown': 'Usage Breakdown',
    'previous_reading': 'Previous Reading',
    'current_reading': 'Current Reading',
    'view_account': 'View Utility Account',

    // Currency
    'currency_selector_label': 'Organization Currency',
    'currency_stripe_warning': 'Online Stripe payments are not available for this currency. Tenants will pay in person only.',
    'online_payment_unavailable': 'Online payment is not available for your currency. Please pay in person.',

    // Buildings / Bulk creator
    'units_per_floor': 'Units per Floor',
    'QTY_PER_FLOOR': 'Qty / Floor',
    'qty_per_floor': 'Qty / Floor',
    'SIZE': 'Size',
    'SELECT_FLOORS': 'Select Floors',
    'select_floors': 'Select Floors',
    'BULK_ADD': 'Bulk Add',
    'bulk_add': 'Bulk Add',
    'avg_occupancy': 'Avg. Occupancy',
    'total_buildings': 'Total Buildings',

    // Dashboard & Risk Widgets
    'payment_risk': 'Payment Risk',
    'ai_scored_late_payment': 'AI-scored late payment likelihood',
    'high_risk': 'High Risk',
    'medium': 'Medium',
    'low_risk': 'Low Risk',
    'no_scores_yet': 'No scores yet. Click refresh to run AI scoring.',
    'owed': 'owed',
    'view_all_risk_scores': 'View all risk scores',
    'renewal_risk': 'Renewal Risk',
    'leases_expiring_90d': 'Leases expiring in 90 days',
    'exp_in_30d': 'Exp. in 30d',
    'exp_in_90d': 'Exp. in 90d',
    'no_leases_expiring_90d': 'No leases expiring in the next 90 days.',
    'left': 'left',
    'view_all_renewal_risks': 'View all renewal risks',
    're_run_ai_scoring': 'Re-run AI scoring',

    // User Form
    'invitation_only_onboarding': 'Invitation Only Onboarding',
    'invitation_only_onboarding_desc': 'For security, passwords are no longer set by administrators. A secure invitation will be sent to the user\'s email address allowing them to set up their own account and password.',
    'user_created_email_failed': 'The account for ',
    'user_created_email_failed_2': ' has been created, but the ',
    'invitation_email_could_not_be_sent': 'invitation email could not be sent',
    'user_created_email_failed_3': ' due to a mail server issue.',
    'manual_onboarding_link': 'Manual Onboarding Link',
    'manual_onboarding_desc': 'Please copy this link and send it to the user manually so they can set their password:',
    'link_copied_to_clipboard': 'Link copied to clipboard!',
    'copy_link': 'Copy Link',
    'done': 'Done',
    'add_another_user': 'Add Another User',

    // Apartment List
    'furnished_apartment': 'Furnished Apartment',
    'multiple_leases': 'Multiple Leases',
    'manage': 'Manage',
    'delete_apartment': 'Delete Apartment',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'Total Properties',
    'active_properties': 'Active Properties',
    'active_tenants': 'Active Tenants',
    'monthly_revenue': 'Monthly Revenue',
    'pending_payments': 'Pending Payments',
    'lease_expiring_soon': 'Lease Expiring Soon',
    'payment_risk': 'Payment Risk',
    'ai_scored_late_payment': 'AI-scored late payment likelihood',
    'high_risk': 'High Risk',
    'medium_risk': 'Medium Risk',
    'low_risk': 'Low Risk',
    'no_scores_yet': 'No scores yet. Click refresh to run AI scoring.',
    'renewal_risk': 'Renewal Risk',
    'leases_expiring_in_90_days': 'Leases expiring in 90 days',
    'exp_in_30d': 'Exp. in 30d',
    'exp_in_90d': 'Exp. in 90d',
    'no_leases_expiring_90d': 'No leases expiring in the next 90 days.',
    'leasing_office': 'Leasing Office',
    'marketing_links': 'Marketing Links',
    'bulk_import': 'Bulk Import',
    'evictions': 'Evictions',
    'accounting': 'Accounting',
    'payments': 'Payments',
    'portfolio_kpis': 'Portfolio & KPIs',
    'bulk_comms': 'Bulk Message',
    'email_templates': 'Email Templates',
    'building_view': 'Building View',
    'failed_to_load_logs': 'Failed to load activity logs',
    'export_failed': 'Failed to export logs',
    'all_user_activities_desc': 'Track all system actions and events',
    'search_logs': 'Search logs...',
    'entries': 'entries',
    'filter_activities': 'Filter Activities',
    'action_type': 'Action Type',
    'all_actions': 'All Actions',
    'entity_type': 'Entity Type',
    'all_types': 'All Types',
    'start_date': 'Start Date',
    'end_date': 'End Date',
    'reset': 'Reset',
    'apply_filter': 'Apply Filter',
    'time': 'Time',
    'user': 'User',
    'action': 'Action',
    'entity': 'Entity',
    'details': 'Details',
    'amount': 'Amount',
    'no_logs_matching_search': 'No logs matching your search.',
    'no_logs_available': 'No activity logs available.',
    'showing_range': 'Showing {{start}} to {{end}} of {{total}}',
    'previous': 'Previous',
    'next': 'Next',
    'exporting': 'Exporting...',
    'export': 'Export',
    'filter': 'Filter',
    'activity_logs': 'Activity Logs',
    'invitation_only_onboarding': 'Invitation Only Onboarding',
    'approve_payment_msg': 'Are you sure you want to approve this payment?',
    'reject_payment_msg': 'Please provide a reason for rejecting this payment.',
    'errors_serverError': 'Internal Server Error',
    'timePeriods_month': 'Month',
    'timePeriods_quarter': 'Quarter',
    'timePeriods_year': 'Year',
    'common_startDate': 'Start Date',
    'common_endDate': 'End Date',
    'common_type': 'Type',
    'common_all': 'All',
    'common_tenant': 'Tenant',

  
  
  
    // Auto-added translations
    'unpaid_balance': 'Unpaid Balance',
    'lease_period': 'Lease Period',
    'view_record': 'View Record',
    'apartment_created_successfully': 'Apartment Created Successfully',
    'apartment_updated_successfully': 'Apartment Updated Successfully',
    'manage_your_properties': 'Manage Your Properties',
    'filter_apartments': 'Filter Apartments',
    'no_matching_apartments_message': 'No Matching Apartments Message',
    'select_at_least_one_floor': 'Select At Least One Floor',
    'add_at_least_one_unit_type': 'Add At Least One Unit Type',
    'apartments_created': 'Apartments Created',
    'skipped_duplicates': 'Skipped Duplicates',
    'apartments_created_successfully': 'Apartments Created Successfully',
    'error_creating_apartments': 'Error Creating Apartments',
    'clear': 'Clear',
    'select_floors_and_types': 'Select Floors And Types',
    'future_tenant_only': 'Future Tenant Only',
    'converted': 'Converted',
    'confirmed': 'Confirmed',
    'hold': 'Hold',
    'failed_confirm_booking': 'Failed Confirm Booking',
    'failed_cancel_booking': 'Failed Cancel Booking',
    'failed_convert_tenant': 'Failed Convert Tenant',
    'converted_to_tenant': 'Converted To Tenant',
    'hold_expired': 'Hold Expired',
    'booking_created': 'Booking Created',
    'failed_save_booking': 'Failed Save Booking',
    'failed_load_bookings': 'Failed to load bookings',
    'building_created_successfully': 'Building Created Successfully',
    'building_updated_successfully': 'Building Updated Successfully',
    'building_has_no_apartments': 'Building Has No Apartments',
    'add_apartments_hint': 'Add Apartments Hint',
    'due': 'Due',
    'description': 'Description',
    'inactive': 'Inactive',
    'next_7_days': 'Next 7 Days',
    'next_14_days': 'Next 14 Days',
    'next_30_days': 'Next 30 Days',
    'view_arrow': 'View Arrow',
    'search_unit_tenant': 'Search Unit Tenant',
    'no_results_for_filters': 'No Results For Filters',
    'charged': 'Charged',
    'bank': 'Bank',
    'cheque': 'Cheque',
    'stripe': 'Stripe',
    'notifications': 'Notifications',
    'view_all_notifications': 'View All Notifications',
    'failed_to_load_revenue': 'Failed To Load Revenue',
    'no_tenant_logs': 'No Tenant Logs',
    'payment_record_error': 'Payment Record Error',
    'contract_not_found': 'Contract Not Found',
    'back_to_owner': 'Back To Owner',
    'contract_id': 'Contract Id',
    'summary_info': 'Summary Info',
    'n_a': 'N A',
    'paid_progress': 'Paid Progress',
    'total_installments': 'Total Installments',
    'paid_installments': 'Paid Installments',
    'pending_installments': 'Pending Installments',
    'legal_document': 'Legal Document',
    'signatures': 'Signatures',
    'owner_signature': 'Owner Signature',
    'awaiting_owner_signature': 'Awaiting Owner Signature',
    'admin_signature': 'Admin Signature',
    'awaiting_admin_signature': 'Awaiting Admin Signature',
    'paid_amount': 'Paid Amount',
    'save_payment': 'Save Payment',
    'language': 'Language',
    'exportPDF': 'Export PDF',
    'print': 'Print',
    'receiptNo': 'Receipt No',
    'contractDetails': 'Contract Details',
    'contractNo': 'Contract No',
    'contractType': 'Contract Type',
    'startDate': 'Start Date',
    'endDate': 'End Date',
    'openEnded': 'Open Ended',
    'financialSummary': 'Financial Summary',
    'totalValue': 'Total Value',
    'totalPaid': 'Total Paid',
    'balanceDue': 'Balance Due',
    'installmentSchedule': 'Installment Schedule',
    'dueDate': 'Due Date',
    'paidAmt': 'Paid Amt',
    'paymentDate': 'Payment Date',
    'paidWatermark': 'Paid Watermark',
    'paymentDetails': 'Payment Details',
    'installmentNo': 'Installment No',
    'amountDue': 'Amount Due',
    'amountPaid': 'Amount Paid',
    'paymentStatus': 'Payment Status',
    'paymentConfirmed': 'Payment Confirmed',
    'awaitingPayment': 'Awaiting Payment',
    'balanceRemaining': 'Balance Remaining',
    'authorizedSig': 'Authorized Sig',
    'ownerSig': 'Owner Sig',
    'generatedBy': 'Generated By',
    'informationalOnly': 'Informational Only',
    'failed_to_load_owner_data': 'Failed To Load Owner Data',
    'sending': 'Sending',
    'payment_reminder_message': 'Payment Reminder Message',
    'reminder_sent_success': 'Reminder Sent Success',
    'failed_to_send_reminder': 'Failed To Send Reminder',
    'owner_has_no_email': 'Owner Has No Email',
    'portal_invitation_sent_successfully': 'Portal Invitation Sent Successfully',
    'failed_to_send_portal_invite': 'Failed To Send Portal Invite',
    'owner_not_found': 'Owner Not Found',
    'total_income': 'Total Income',
    'residence': 'Residence',
    'does_not_live_on_property': 'Does Not Live On Property',
    'outstanding_fees_note': 'Outstanding Fees Note',
    'pending_signature': 'Pending Signature',
    'fully_executed': 'Fully Executed',
    'error_loading_financials': 'Error Loading Financials',
    'due_soon': 'Due Soon',
    'owner_updated_successfully': 'Owner Updated Successfully',
    'invitation_sent': 'Invitation Sent',
    'invitation_failed': 'Invitation Failed',
    'owner_created_successfully': 'Owner Created Successfully',
    'preferred_language': 'Preferred Language',
    'drop_here': 'Drop Here',
    'failed_to_load_owners_data': 'Failed To Load Owners Data',
    'connection_error': 'Connection Error',
    'failed_to_delete_owner': 'Failed To Delete Owner',
    'failed_to_delete_owners': 'Failed To Delete Owners',
    'edit_owner': 'Edit Owner',
    'delete_owner': 'Delete Owner',
    'occupied_lowercase': 'Occupied Lowercase',
    'confirm_bulk_delete_title': 'Confirm Bulk Delete Title',
    'refresh_owners': 'Refresh Owners',
    'delete_selected_owners': 'Delete Selected Owners',
    'export_to_pdf': 'Export To Pdf',
    'print_owners': 'Print Owners',
    'min_zero': 'Min Zero',
    'invalid_plan_selected': 'Invalid Plan Selected',
    'could_not_start_checkout': 'Could Not Start Checkout',
    'checkout_failed': 'Checkout Failed',
    'could_not_open_portal': 'Could Not Open Portal',
    'failed_to_open_portal': 'Failed To Open Portal',
    'payment_approved_success': 'Payment Approved Success',
    'failed_to_approve_payment': 'Failed To Approve Payment',
    'provide_rejection_reason': 'Provide Rejection Reason',
    'payment_rejected': 'Payment Rejected',
    'failed_to_reject_payment': 'Failed To Reject Payment',
    'stripe_connected': 'Stripe Connected',
    'redirecting': 'Redirecting',
    'approve_payment': 'Approve Payment',
    'reject_payment': 'Reject Payment',
    'errors.serverError': 'Server Error',
    'export_excel': 'Export Excel',
    'timePeriods.month': 'Month',
    'timePeriods.quarter': 'Quarter',
    'timePeriods.year': 'Year',
    'common.startDate': 'Start Date',
    'common.endDate': 'End Date',
    'common.type': 'Type',
    'common.all': 'All',
    'common.tenant': 'Tenant',
    'common.searchTenant': 'Search Tenant',
    'ledgerReport.netBalance': 'Net Balance',
    'ledgerReport.entries': 'Entries',
    'common.noData': 'No Data',
    'common.date': 'Date',
    'common.building': 'Building',
    'common.apartment': 'Apartment',
    'common.description': 'Description',
    'common.amount': 'Amount',
    'ledgerReport.balanceAfter': 'Balance After',
    'ledgerReport.createdBy': 'Created By',
    'common.page': 'Page',
    'metric': 'Metric',
    'value': 'Value',
    'failed_to_export': 'Failed To Export',
    'select_date_range': 'Select Date Range',
    'revenue_deep_dive_restricted': 'Revenue Deep Dive Restricted',
    'showing_building_revenue': 'Showing Building Revenue',
    'showing_owner_revenue': 'Showing Owner Revenue',
    'showing_monthly_revenue': 'Showing Monthly Revenue',
    'receiptTitle': 'Receipt Title',
    'receiptDate': 'Receipt Date',
    'residentName': 'Resident Name',
    'servicePeriod': 'Service Period',
    'signature': 'Signature',
    'responsible': 'Responsible',
    'thankYou': 'Thank You',
    'invalid_amount': 'Invalid Amount',
    'payment_generated_successfully': 'Payment Generated Successfully',
    'failed_to_generate_payment': 'Failed To Generate Payment',
    'payer': 'Payer',
    'failed_to_load_service_data': 'Failed To Load Service Data',
    'records': 'Records',
    'no_matching_payments_found': 'No Matching Payments Found',
    'paid_count': 'Paid Count',
    'unpaid_count': 'Unpaid Count',
    'no_data_to_export': 'No Data To Export',
    'export_successful': 'Export Successful',
    'months_with_data': 'Months With Data',
    'data_refreshed_successfully': 'Data Refreshed Successfully',
    'payment_marked_as_paid': 'Payment Marked as Paid Successfully',
    'payment_marked_as_unpaid': 'Payment Marked as Unpaid Successfully',
    'rented': 'Rented',
    'service_charge_deleted': 'Service Charge Deleted Successfully',
    'failed_to_delete_service_charge': 'Failed to Delete Service Charge',
    'service_payment_note_default': 'Service payment for {{month}} {{year}}',
    'failed_init_stripe': 'Failed Init Stripe',
    'refresh_status': 'Refresh Status',
    'failed_to_load_user_data': 'Failed To Load User Data',
    'error_updating_profile': 'Error Updating Profile',
    'error_updating_password': 'Error Updating Password',
    'error_from_server': 'Error From Server',
    'nameLabel': 'Name Label',
    'floorPre': 'Floor Pre',
    'aptPre': 'Apt Pre',
    'periodLabel': 'Period Label',
    'officeCommission': 'Office Commission',
    'invalid_date': 'Invalid Date',
    'tenant_has_no_email': 'Tenant Has No Email',
    'portal_invitation_failed': 'Portal Invitation Failed',
    'lease_extended_success': 'Lease Extended Success',
    'failed_to_extend_lease': 'Failed To Extend Lease',
    'lease_renewed_success': 'Lease Renewed Success',
    'failed_to_renew_lease': 'Failed To Renew Lease',
    'ending_lease': 'Ending Lease',
    'no_additional_fees': 'No Additional Fees',
    'electronic_signature': 'Electronic Signature',
    'no_maintenance_requests_message': 'No Maintenance Requests Message',
    'add_first_request': 'Add First Request',
    'tenant_updated_successfully': 'Tenant Updated Successfully',
    'tenant_created_successfully': 'Tenant Created Successfully',
    'no_phone': 'No Phone',
    'not_assigned': 'Not Assigned',
    'financial_details': 'Financial Details',
    'more_info': 'More Info',
    'apartment_specs': 'Apartment Specs',
    'hide_inactive_users': 'Hide Inactive Users',
    'show_inactive_users': 'Show Inactive Users',
    'error_loading_users': 'Error Loading Users',
    'no_users_message': 'No Users Message',
    'create_first_user': 'Create First User',
    'request_failed': 'Request Failed',
    'loading_units': 'Loading Units',
    'listed_rent': 'Listed Rent',
    'portfolio_occupancy': 'Portfolio Occupancy',
    'avg_renewal_increase': 'Avg Renewal Increase',
    'title': 'Title',
    'content': 'Content',
    'download_failed': 'Download Failed',
    'run_report': 'Run Report',
    'downloading': 'Downloading',
    'total_ar': 'Total Ar',
    'total_balance': 'Total Balance',
    'no_outstanding_balances_found': 'No Outstanding Balances Found',
    'totals': 'Totals',
    'subject_body_required': 'Subject Body Required',
    'no_active_tenants': 'No Active Tenants',
    'confirm_send_bulk': 'Confirm Send Bulk',
    'message_sent_to_tenants': 'Message Sent To Tenants',
    'bulk_communications': 'Bulk Communications',
    'message_sent_successfully': 'Message Sent Successfully',
    'in_app_announcement': 'In App Announcement',
    'dismiss': 'Dismiss',
    'target_building': 'Target Building',
    'all_buildings_count': 'All Buildings Count',
    'compose_message': 'Compose Message',
    'subject': 'Subject',
    'message_body': 'Message Body',
    'markdown_hint': 'Markdown Hint',
    'characters': 'Characters',
    'delivery_channels': 'Delivery Channels',
    'email_blast': 'Email Blast',
    'send_to_tenants': 'Send To Tenants',
    'bulk_guidelines': 'Bulk Guidelines',
    'in_app_announcements': 'In App Announcements',
    'in_app_desc': 'In App Desc',
    'email_blasts': 'Email Blasts',
    'email_blast_desc': 'Email Blast Desc',
    'send_immediate_desc': 'Send Immediate Desc',
    'professional_desc': 'Professional Desc',
    'owner_balances': 'Owner Balances',
    'deselect_all': 'Deselect All',
    'select_all': 'Select All',
    'notes_optional': 'Notes Optional',
    'confirm_bulk_payout_title': 'Confirm Bulk Payout',
    'error_loading_churn_data': 'Error Loading Churn Data',
    'running_scoring': 'Running Scoring',
    'scored_tenants': 'Scored Tenants',
    'scoring_failed': 'Scoring Failed',
    'vendor_dashboard_subtitle': 'Vendor Dashboard Subtitle',
    'view_your_work_orders': 'View Your Work Orders',
    'templates': 'Templates',
    'editor': 'Editor',
    'desktop': 'Desktop',
    'mobile': 'Mobile',
    'realistic_sample_data': 'Realistic Sample Data',
    'template_logic': 'Template Logic',
    'event_trigger_desc': 'Event Trigger Desc',
    'admin_only': 'Admin Only',
    'click_to_insert': 'Click To Insert',
    'body': 'Body',
    'template_deactivated': 'Template Deactivated',
    'failed_to_deactivate': 'Failed To Deactivate',
    'enter_test_email': 'Enter Test Email',
    'test_email_sent_to': 'Test Email Sent To',
    'failed_to_send_test': 'Failed To Send Test',
    'active_templates_count': 'Active Templates Count',
    'send_test_email': 'Send Test Email',
    'save_failed': 'Save Failed',
    'description_required': 'Description Required',
    'post_failed': 'Post Failed',
    'code': 'Code',
    'apply': 'Apply',
    'account': 'Account',
    'debit': 'Debit',
    'credit': 'Credit',
    'lines': 'Lines',
    'hide': 'Hide',
    'reverse': 'Reverse',
    'run': 'Run',
    'total_debits': 'Total Debits',
    'total_credits': 'Total Credits',
    'journal_entry': 'Journal Entry',
    'building_id_label': 'Building Id Label',
    'units_count': 'Units Count',
    'enable_in_settings': 'Enable In Settings',
    'failed_to_load_notification_log': 'Failed To Load Notification Log',
    'no_notifications_found': 'No Notifications Found',
    'channel': 'Channel',
    'recipient': 'Recipient',
    'discount_rent': 'Discount Rent',
    'lease_start': 'Lease Start',
    'lease_end': 'Lease End',
    'next_bill': 'Next Bill',
    'no_units_found': 'No Units Found',
    'csv_download_failed': 'Csv Download Failed',
    'all_1099_downloaded': 'All 1099 Downloaded',
    'no_reportable_owners': 'No Reportable Owners',
    'pdf_download_failed': 'Pdf Download Failed',
    'pdf_generation_failed': 'Pdf Generation Failed',
    'generating_pdfs': 'Generating Pdfs',
    'download_all_pdfs': 'Download All Pdfs',
    'important': 'Important',
    'irs_1099_disclaimer': 'Irs 1099 Disclaimer',
    'owner_payment_summary': 'Owner Payment Summary',
    'irs_threshold': 'Irs Threshold',
    'total_paid': 'Total Paid',
    'form': 'Form',
    'file_form': 'File Form',
    'no_owner_payments_found': 'No Owner Payments Found',
    'no_deposits_found': 'No Deposits Found',
    'deposit_amount': 'Deposit Amount',
    'deductions': 'Deductions',
    'error_loading_showing': 'Error Loading Showing',
    'required_fields_error': 'Required Fields Error',
    'showing_updated': 'Showing Updated',
    'showing_scheduled': 'Showing Scheduled',
    'time_conflict_error': 'Time Conflict Error',
    'choose_unit': 'Choose Unit',
    'agent_name_placeholder': 'Agent Name Placeholder',
    'schedule': 'Schedule',
    'error_loading_showings': 'Error Loading Showings',
    'marked_as': 'Marked As',
    'update_failed': 'Update Failed',
    'delete_failed': 'Delete Failed',
    'mark_completed': 'Mark Completed',
    'mark_no_show': 'Mark No Show',
    'confirm_delete': 'Confirm Delete',
    'confirm_delete_showing': 'Confirm Delete Showing',
    'error_loading_surveys': 'Error Loading Surveys',
    'from_responses': 'From Responses',
    'no_data_yet': 'No Data Yet',
    'utility_type_required': 'Utility Type Required',
    'failed_to_create_account': 'Failed To Create Account',
    'select_tenant_error': 'Select Tenant Error',
    'please_fix_errors': 'Please Fix Errors',
    'bill_issued_successfully': 'Bill Issued Successfully',
    'failed_to_issue_bill': 'Failed To Issue Bill',
    'download_csv': 'Download Csv',
    'vendor_1099_disclaimer': 'Vendor 1099 Disclaimer',
    'vendor': 'Vendor',
    'first_payment': 'First Payment',
    'last_payment': 'Last Payment',
    'no_vendor_payments_recorded': 'No Vendor Payments Recorded',
    'account_deactivated': 'Account Deactivated',
    'server_no_response': 'Server No Response',
    'logging_in': 'Logging In',
    'company_name_required': 'Company Name Required',
    'registration_failed': 'Registration Failed',
    'enter_company_name': 'Enter Company Name',
    'fully_signed_active': 'Fully Signed Active',
    'pending_owner_signature': 'Pending Owner Signature',
    'pending_admin_signature': 'Pending Admin Signature',
    'terminated': 'Terminated',
    'back_to_contracts': 'Back To Contracts',
    'contract_terms': 'Contract Terms',
    'payment_schedule': 'Payment Schedule',
    'no_installments_defined': 'No Installments Defined',
    'signed_by': 'Signed By',
    'awaiting_admin_review': 'Awaiting Admin Review',
    'sign_contract': 'Sign Contract',
    'past': 'Past',
    'tenant_signin_success': 'Tenant Signin Success',

    // Auto-added mass translations from ESLint Codemod
    '10': '10 /',
    '12': '/ 12',
    '16': '−16%',
    '25': '25 /',
    '50': '50 /',
    '100': '100 /',
    '600': ': $600',
    'ai_assistant_pro_only': 'AI Assistant — Pro only',
    'ask_questions_about_your_portfolio_in_pl': 'Ask questions about your portfolio in plain English. Get instant answers on revenue, overdue payments, vacancies, and more.',
    'upgrade_to_pro': 'Upgrade to Pro',
    'here_s_what_s_happening_across_your_port': 'Here\'s what\'s happening across your portfolio today.',
    'portfolio_risk': 'Portfolio Risk',
    'pro_only': 'Pro only',
    'pending_collections': 'Pending Collections',
    'ask_ai_assistant': 'Ask AI Assistant',
    'unlock_ai_assistant_upgrade_to_pro': 'Unlock AI Assistant — Upgrade to Pro',
    'download': 'Download',
    'd': 'd',
    'view_details_1': 'View Details',
    'export_data': 'Export Data',
    'refresh_data': 'Refresh Data',
    'property_pulse': 'Property Pulse',
    'cash_flow_analysis_for_the_current_fisca': 'Cash flow analysis for the current fiscal year',
    'yearly_report': 'Yearly Report',
    'analytics_pro_required': 'Analytics Pro Required',
    'unlock_deep_financial_insights_and_custo': 'Unlock deep financial insights and custom forecasting reports.',
    'upgrade_now': 'Upgrade Now',
    'items_requiring_immediate_follow_up': 'Items requiring immediate follow-up',
    'activity_log': 'Activity Log',
    'view_history': 'View History',
    'no_recent_logs_found': 'No recent logs found',
    'active_issues': 'Active Issues',
    'pro': 'Pro',
    'pro_1': 'Pro',
    'sell_unit': 'Sell Unit',
    'floor_1': 'Floor',
    'size_1': 'Size',
    'm': 'm²',
    'amenities': 'Amenities',
    'last_updated_today': 'Last updated: Today',
    'back_to_apartment': 'Back to Apartment',
    'sell_unit_1': 'Sell Unit',
    'floor_2': 'Floor',
    'select_buyer': 'Select Buyer',
    'existing_owner': 'Existing Owner',
    'new_buyer': 'New Buyer',
    'no_owners_found_switch_to_new_buyer_to_c': 'No owners found — switch to "New Buyer" to create one',
    'search_owners_placeholder': 'Search owners by name, phone, or email...',
    'buyer_name_placeholder': 'e.g. Ahmed Al-Rashidi',
    'sale_notes_placeholder': 'Optional notes...',
    'edit_1': 'Edit',
    'the_buyer_will_be_created_as_an_owner_an': 'The buyer will be created as an owner and linked to this sale automatically.',
    'sale_terms': 'Sale Terms',
    'total_sale_price': 'Total Sale Price *',
    'down_payment': 'Down Payment',
    'annual_interest_rate': 'Annual Interest Rate (%)',
    'term_months': 'Term (months) *',
    'yrs': 'yrs)',
    'sale_start_date': 'Sale / Start Date *',
    'quick_preview': 'Quick Preview',
    'principal': 'Principal',
    'down_payment_1': 'Down Payment',
    'term': 'Term',
    'months_1': 'months',
    'amortization_schedule': 'Amortization Schedule',
    'confirm_sale': 'Confirm Sale',
    'buyer': 'Buyer',
    'floor_3': '— Floor',
    'financial_terms': 'Financial Terms',
    'draft_sale_contract': 'draft sale contract',
    'will_be_created_the_apartment_will_be_ma': 'will be created. The apartment will be marked as',
    'sold': 'Sold',
    'only_after_both_you_and_the_buyer_digita': 'only after both you and the buyer digitally sign the contract.',
    'sale_finalized': 'Sale Finalized!',
    'the_sale_contract_for_unit': 'The sale contract for Unit',
    'has_been_created_use_the_links_below_to': 'has been created. Use the links below to onboard the buyer.',
    'public_sign_link': 'Public Sign Link',
    'p_sign_owner': '/p/sign/owner/',
    'portal_invite_link': 'Portal Invite Link',
    'portal_setup_password_type_owner_id': '/portal/setup-password?type=owner&id=',
    'email_1': '&email=',
    'token': '&token=',
    'view_owner': 'View Owner',
    'manage_contract': 'Manage Contract',
    '0_10': '(0–10,',
    'm_1': 'm²',
    'm_2': 'm²',
    'm_3': 'm²',
    'm_4': 'm²',
    'empty_key': '✕',
    'this_apartment_already_has': 'This apartment already has',
    'active_booking_s_for_these_dates': 'active booking(s) for these dates.',
    'levels': 'Levels',
    'cap': 'Cap',
    'no_inventory_data': 'No Inventory Data',
    'init_units': 'Init Units',
    'm_5': 'm²',
    'm_6': 'm²',
    'supports_markdown_placeholders_e_g': 'Supports MarkDown & Placeholders e.g.',
    'empty_key_1': '✓',
    'trial_ends_in': 'Trial ends in',
    'days_subscribe': 'days - Subscribe',
    'new_lease_agreement': 'New Lease Agreement',
    'tenant_unit_assignment': 'Tenant & Unit Assignment',
    'please_select_a_building_first': 'Please select a building first',
    'lease_terms_duration': 'Lease Terms & Duration',
    'lease_type': 'Lease Type',
    'fixed_term': 'Fixed Term',
    'month_to_month': 'Month-to-Month',
    'end_date_optional': 'End Date (Optional)',
    'financial_obligations': 'Financial Obligations',
    'empty_key_2': ') *',
    'notes_special_provisions': 'Notes / Special Provisions',
    'empty_key_3': ': #',
    'send_for_signature': 'Send for Signature',
    'copy_sign_link': 'Copy Sign Link',
    'download_contract_pdf': 'Download Contract PDF',
    'contract_summary': 'Contract Summary',
    'generated_from_template': 'Generated from Template:',
    'digitally_executed': 'Digitally Executed',
    'electronic_signatures': 'Electronic Signatures',
    'management_office': 'Management Office',
    'authorized_signature': 'Authorized Signature',
    'owner_landlord': 'Owner / Landlord',
    'email_2': 'Email:',
    'signed': 'Signed:',
    'ip': 'IP:',
    'reason_for_voiding': 'Reason for voiding',
    'building_agreement_for': 'Building agreement for',
    'contract_builder_rules': 'Contract Builder Rules',
    'select_contract_template': 'Select Contract Template',
    'no_template_manual_mode': 'No Template (Manual Mode)',
    'template_dynamic_variables': 'Template Dynamic Variables',
    'owner_default_commission': 'Owner default Commission:',
    'maintenance_threshold': 'Maintenance Threshold:',
    'unit_1': 'Unit',
    'sale_unit_purchase': 'Sale / Unit Purchase',
    'fixed_maintenance_contract': 'Fixed Maintenance Contract',
    'lease_agreement': 'Lease Agreement',
    'start_date_1': 'Start Date',
    'auto_generate_quarterly': 'Auto-Generate Quarterly',
    'add_custom_installment': 'Add Custom Installment',
    'plan_total': 'Plan Total',
    'agreement': 'Agreement',
    'copy_portal_link': 'Copy Portal Link',
    'portal_link_copied': 'Portal setup link copied to clipboard',
    'failed_generate_invite_link': 'Failed to generate invite link',
    'ledger': 'Ledger',
    'empty_key_4': ') â†’',
    'owner_documents': 'Owner Documents',
    'add_document': 'Add Document',
    'name_1': 'Name *',
    'tax': 'Tax',
    'file_url': 'File URL *',
    'cancel_1': 'Cancel',
    'no_documents_yet': 'No documents yet',
    'document_added': 'Document added',
    'name_and_url_required': 'Name and URL are required',
    'uploaded_by': 'Uploaded by',
    'delete_document': 'Delete Document',
    'document_name_placeholder': 'Document name',
    '30_days': '(30 days)',
    'view_1': 'View',
    'future_scheduled_installments': 'future scheduled installments',
    'unit_2': ', Unit',
    'no_investment_data_available_add_purchas': 'No investment data available. Add purchase price and current value to apartments to see metrics.',
    'click_the_edit_icon_on_any_unit_to_updat': 'Click the edit icon on any unit to update its current market value or purchase price.',
    'unit_3': 'Unit',
    'unit_mo': '/unit/mo',
    'save_16_billed_annually': 'Save 16% · billed annually',
    'reason_for_rejection': 'Reason for rejection',
    'of_1': 'of',
    'error_loading_receipt': 'Error Loading Receipt',
    'go_back': 'Go Back',
    'receipt_not_found': 'Receipt Not Found',
    'the_requested_payment_receipt_could_not': 'The requested payment receipt could not be found.',
    'go_back_1': 'Go Back',
    'payment_receipt': 'Payment Receipt',
    'issue_date': 'Issue Date:',
    'from_1': 'From',
    'phone_1': 'Phone:',
    'to_1': 'To',
    'phone_2': 'Phone:',
    'amount_1': 'Amount',
    'notes_1': 'Notes',
    'thank_you_for_your_payment': 'Thank you for your payment!',
    'this_receipt_was_generated_automatically': 'This receipt was generated automatically.',
    'delete_template': 'Delete Template',
    'cancel_2': 'Cancel',
    'delete_1': 'Delete',
    'description_optional': 'Description (optional)',
    'report_type': 'Report Type',
    'choosing_a_report_type_shows_the_relevan': 'Choosing a report type shows the relevant filters below.',
    'saved_filters': 'Saved Filters',
    'select_a_report_type_above_to_set_saved': 'Select a report type above to set saved filter values for this template.',
    'cancel_3': 'Cancel',
    'saved_filter': 'saved filter',
    'saved_1': 'Saved',
    'favourites': 'Favourites',
    'all_templates': 'All Templates',
    'load_template': 'Load Template',
    'favourites_1': 'Favourites',
    'no_templates_for_this_report_type': 'No templates for this report type',
    'saved_filter_1': 'saved filter',
    'manage_apartment_sales_and_track_sold_un': 'Manage apartment sales and track sold units',
    'apartments_1': 'apartments',
    'available': 'available',
    'sold_1': 'sold',
    'sold_rate': '% sold rate',
    'floor_4': 'Floor',
    'units_1': 'units',
    'available_1': 'available',
    'sold_2': 'sold',
    'unit_4': 'Unit',
    'owner_buyer': 'Owner / Buyer',
    'sale_price': 'Sale Price',
    'sale_date': 'Sale Date',
    'sell_unit_2': 'Sell Unit',
    'search_unit_or_buyer': 'Search unit or buyer...',
    'stat_available_to_sell': 'Available to Sell',
    'stat_sold_units': 'Sold Units',
    'status_all': 'All',
    'status_vacant': 'Vacant',
    'status_available': 'Available',
    'status_occupied': 'Occupied',
    'status_sold': 'Sold',
    'status_maintenance': 'Maintenance',
    'view_details_2': 'View Details',
    'print_1': 'Print',
    'apartment_management_system': 'Apartment Management System',
    'erbil_kurdistan_region_iraq': 'Erbil, Kurdistan Region - Iraq',
    'tel_xxx_xxxxxxxx': 'Tel: +XXX XXXXXXXX',
    'receipt': 'Receipt #:',
    'name_2': 'Name:',
    'phone_3': 'Phone:',
    'building_1': 'Building:',
    'payment_details_1': 'Payment Details',
    'amount_2': 'Amount:',
    'payment_date_1': 'Payment Date:',
    'period_1': 'Period:',
    'notes_2': 'Notes',
    'thank_you_for_your_payment_1': 'Thank you for your payment!',
    'tenant_information_1': 'Tenant Information',
    'name_3': 'Name:',
    'phone_4': 'Phone:',
    'apartment_1': 'Apartment:',
    'building_2': 'Building:',
    'furnished_1': 'Furnished:',
    'at_12_00_pm': 'at 12:00 PM',
    'monthly_rent_1': 'Monthly Rent:',
    'insurance_1': 'Insurance:',
    'additional_notes': 'Additional Notes',
    'tenant_signature': 'Tenant Signature',
    'this_receipt_is_electronically_generated': 'This receipt is electronically generated and is valid without a signature.',
    'apartment_management_system_all_rights_r': 'Apartment Management System. All rights reserved.',
    'lease_renewal_risk': 'Lease Renewal Risk',
    'expiring_in_30_days': 'Expiring in 30 days',
    'expiring_in_60_days': 'Expiring in 60 days',
    'expiring_in_90_days': 'Expiring in 90 days',
    'expiring_in_180_days': 'Expiring in 180 days',
    'all_risk_levels': 'All Risk Levels',
    'no_leases_matching_the_selected_filters': 'No leases matching the selected filters.',
    'd_1': 'd',
    'no_documents_uploaded_for_this_tenant': 'No documents uploaded for this tenant.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'AI Lease Reader',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'Upload a lease PDF to auto-fill the form',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10 /',
    '25_1': '25 /',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'Register as Maintenance Provider (Service Vendor)',
    'this_will_automatically_create_a_record': 'This will automatically create a record in the Maintenance Hub so you can assign work orders to this user.',
    'assigned_buildings_portfolio': 'Assigned Buildings (Portfolio)',
    'select_the_buildings_this_portfolio_mana': 'Select the buildings this Portfolio Manager can access. They will ONLY see data for these buildings.',
    'no_buildings_found_please_create_buildin': 'No buildings found. Please create buildings first.',
    'building_3': 'building',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ Sent! SID:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 Iraq (+964) is blocked by default. Enable it:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → Messaging → Geo Permissions → Iraq → ON → Save',
    'trial_accounts_can_only_message': '🔒 Trial accounts can only message',
    'verified_numbers': 'verified numbers',
    'apt_1': '· Apt',
    'mo_1': '/mo',
    'mo_2': '/mo',
    'manage_building_amenities_unit_features': 'Manage building amenities, unit features, and parking spaces',
    'all_buildings_1': 'All Buildings',
    'add_amenity': 'Add Amenity',
    'no_building_amenities_found': 'No building amenities found',
    'all_buildings_2': 'All Buildings',
    'all_units': 'All Units',
    'add_unit_amenity': 'Add Unit Amenity',
    'no_unit_amenities_found': 'No unit amenities found',
    'all_buildings_3': 'All Buildings',
    'available_2': 'Available',
    'reserved': 'Reserved',
    'add_space': 'Add Space',
    'no_parking_spaces_found': 'No parking spaces found',
    'assign': 'Assign',
    'unassign': 'Unassign',
    'spaces': 'Spaces',
    'driveway_area': 'Driveway Area',
    'cancel_4': 'Cancel',
    'complete': 'Complete',
    'confirm_1': 'Confirm',
    'cancel_5': 'Cancel',
    'complete_1': 'Complete',
    'assign_space': 'Assign Space',
    'select_tenant_1': 'Select Tenant',
    'choose_tenant': '-- Choose Tenant --',
    'select_owner': 'Select Owner',
    'choose_owner': '-- Choose Owner --',
    'cancel_6': 'Cancel',
    'assign_1': 'Assign',
    'unit_amenities': 'Unit Amenities',
    'edit_unit_amenity': 'Edit Unit Amenity',
    'save_changes': 'Save Changes',
    'col_monthly_fee': 'Monthly Fee',
    'col_available': 'Available',
    'col_space': 'Space',
    'col_amenity': 'Amenity',
    'new_amenity_booking': 'New Amenity Booking',
    'amenity': 'Amenity *',
    'select_amenity': 'Select amenity…',
    'tenant_1': 'Tenant *',
    'select_tenant_2': 'Select tenant…',
    'date_1': 'Date *',
    'notes_3': 'Notes',
    'cancel_7': 'Cancel',
    'deactivated': 'Deactivated',
    'max_uses': 'Max Uses',
    'generate_application_link': 'Generate Application Link',
    'building_4': 'Building *',
    'specific_unit_optional': 'Specific Unit (optional)',
    'any_unit_in_building': 'Any unit in building',
    'unit_5': 'Unit',
    'floor_5': '– Floor',
    'label': 'Label',
    'expires_at': 'Expires At',
    'max_uses_1': 'Max Uses',
    'cancel_8': 'Cancel',
    'label_unit': 'Label / Unit',
    'token_url': 'Token URL',
    'uses': 'Uses',
    'status_1': 'Status',
    'no_links_yet_click_generate_link_to_crea': 'No links yet. Click "Generate Link" to create one.',
    'link_generated': 'Link generated!',
    'failed_to_generate_link': 'Failed to generate link',
    'failed_to_load_links': 'Failed to load links',
    'link_deactivated': 'Link deactivated',
    'search_label_building_token': 'Search by label, building, or token…',
    'links_count': '{{count}} link(s)',
    'untitled': 'Untitled',
    'open_form': 'Open form',
    'no_links_match_filters': 'No links match your filters.',
    'unit_6': '· Unit',
    '1_30': '1–30',
    '31_60': '31–60',
    '61_90': '61–90',
    'building_amenity': 'Building Amenity',
    'amenity_details': 'Amenity Details',
    'building_5': 'Building *',
    'name_4': 'Name *',
    'category_1': 'Category',
    'monthly_fee': 'Monthly Fee ($)',
    'operating_hours': 'Operating Hours',
    'capacity': 'Capacity',
    'description_1': 'Description',
    'notes_4': 'Notes',
    'available_for_booking': 'Available for booking',
    'cancel_9': 'Cancel',
    'saving_1': 'Saving…',
    'bulk_tenant_import': 'Bulk Tenant Import',
    'import_tenants_from_a_csv_file_apartment': 'Import tenants from a CSV file — apartments are matched by building name + unit number',
    'download_csv_template': 'Download CSV Template',
    'use_this_template_to_format_your_data_co': 'Use this template to format your data correctly',
    'template': 'Template',
    'required_columns': 'Required Columns',
    'optional_columns': 'Optional Columns',
    'payment_date_2': 'payment_date',
    'day_of_month_1_31': '= day of month (1–31)  ·',
    'contract_start_contract_end': 'contract_start / contract_end',
    'yyyy_mm_dd': '= YYYY-MM-DD  ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'Parsing CSV…',
    'or_click_to_browse_max_2_mb': 'or click to browse — max 2 MB',
    'import_preview': 'Import Preview',
    'rows_found_review_before_importing': 'rows found — review before importing',
    'start_over': 'Start Over',
    'name_5': 'Name',
    'phone_5': 'Phone',
    'building_unit': 'Building / Unit',
    'contract_1': 'Contract',
    'status_2': 'Status',
    'empty_key_11': '· #',
    'ready_to_import': 'Ready to import',
    'tenant_2': 'tenant',
    'row': 'row',
    'with_errors_will_be_skipped': 'with errors will be skipped',
    'no_valid_rows_to_import': 'No valid rows to import',
    'fix_the_errors_in_your_csv_and_try_again': 'Fix the errors in your CSV and try again',
    'upload_new_file': 'Upload New File',
    'import_complete': 'Import Complete',
    'tenants_successfully_imported': 'Tenants successfully imported',
    'row_1': 'row',
    'skipped_rows': 'Skipped Rows',
    'row_2': 'Row',
    'import_another_file': 'Import Another File',
    'view_tenants': 'View Tenants',
    'upload_document': 'Upload Document',
    'tenant_3': 'Tenant *',
    'select_tenant_3': 'Select tenant…',
    'document_name': 'Document Name *',
    'category_2': 'Category',
    'file_pdf_image_word_max_5mb': 'File * (PDF, Image, Word — max 5MB)',
    'upload_document_1': 'Upload Document',
    'document_management': 'Document Management',
    'document': 'document',
    'across_all_tenants': 'across all tenants',
    'upload': 'Upload',
    'all_categories': 'All Categories',
    'document_1': 'Document',
    'tenant_4': 'Tenant',
    'category_3': 'Category',
    'status_3': 'Status',
    'uploaded': 'Uploaded',
    'actions_1': 'Actions',
    'no_documents_found': 'No documents found',
    'of_2': 'of',
    'prev': 'Prev',
    'next_1': 'Next',
    'select_tenant_required': 'Select a tenant',
    'document_name_required': 'Document name is required',
    'select_file_required': 'Please select a file',
    'document_uploaded': 'Document uploaded',
    'upload_failed': 'Upload failed',
    'failed_to_load_documents': 'Failed to load documents',
    'document_status_updated': 'Document status updated',
    'failed_to_update_status': 'Failed to update status',
    'confirm_delete_doc': 'Delete "{{name}}"? This can be undone by admin.',
    'failed_to_delete_document': 'Failed to delete',
    'documents_count': '{{count}} document(s)',
    'search_by_tenant_name': 'Search by tenant name…',
    'doc_results_count': '{{count}} result(s)',
    'uploaded_from': 'Uploaded From',
    'uploaded_to': 'Uploaded To',
    'doc_cat_id': 'ID',
    'doc_cat_contract': 'Contract',
    'doc_cat_financial': 'Financial',
    'doc_cat_insurance': 'Insurance',
    'doc_cat_other': 'Other',
    'approved': 'Approved',
    'file_1': 'File',
    'open_eviction_case': 'Open Eviction Case',
    'tenant_5': 'Tenant',
    'tenant_6': 'Tenant *',
    'building_apartment_auto_filled_from_tena': 'Building & apartment auto-filled from tenant record',
    'case_details': 'Case Details',
    'reason': 'Reason *',
    'notice_type': 'Notice Type',
    'cancel_10': 'Cancel',
    'open_case': 'Open Case',
    'eviction_management': 'Eviction Management',
    'track_and_manage_eviction_cases_from_not': 'Track and manage eviction cases from notice to completion',
    'new_case': 'New Case',
    'pipeline': 'Pipeline',
    'no_eviction_cases_found': 'No eviction cases found',
    'advance': 'Advance →',
    'eviction_case': 'Eviction Case #',
    'tenant_7': 'Tenant',
    'unit_7': '· Unit #',
    'reason_1': 'Reason',
    'amount_owed_1': 'Amount Owed',
    'pipeline_status': 'Pipeline Status',
    'notes_5': 'Notes',
    'expense_details': 'Expense Details',
    'payment_info': 'Payment Info',
    'description_2': 'Description',
    'no_accounts_posted_yet': 'No accounts posted yet.',
    'total_1': 'Total',
    'assets': 'Assets',
    'liabilities': 'Liabilities',
    'select_a_date_and_click_run_to_generate': 'Select a date and click Run to generate the balance sheet.',
    'from_2': 'From',
    'to_2': 'To',
    'run_1': 'Run',
    'operating_activities': 'Operating Activities',
    'net_operating_cash_flow': 'Net Operating Cash Flow',
    'financing_activities': 'Financing Activities',
    'net_financing_cash_flow': 'Net Financing Cash Flow',
    'net_change_in_cash': 'Net Change in Cash',
    'select_a_date_range_and_click_run': 'Select a date range and click Run.',

    // GL — Balance Sheet & Cash Flow (new keys)
    'balance_sheet': 'Balance Sheet',
    'cash_flow_statement': 'Cash Flow',
    'total_assets': 'Total Assets',
    'total_liabilities': 'Total Liabilities',
    'total_equity': 'Total Equity',
    'bs_balanced_msg': '✓ Balanced — Assets = Liabilities + Equity',
    'bs_unbalanced_msg': '⚠ Out of balance — check journal entries',
    'operating_cash_flow': 'Operating Cash Flow',
    'financing_cash_flow': 'Financing Cash Flow',

    // Expenses — Edit flow
    'edit_expense': 'Edit Expense',
    'expense_updated': 'Expense updated',

    'rated': 'rated',
    'property_inspections': 'Property Inspections',
    'move_in_move_out_periodic_20_item_standa': 'Move-in · Move-out · Periodic · 20-item standardized checklist',
    'new_inspection': 'New Inspection',
    'no_inspections_found': 'No inspections found.',
    'adjust_the_filters_or_create_a_new_inspe': 'Adjust the filters or create a new inspection.',
    'showing_1': 'Showing',
    'of_3': 'of',
    'new_inspection_1': 'New Inspection',
    'apartment_2': 'Apartment',
    'nothing_found': 'Nothing found.',
    'unit_8': '— Unit',
    'no_active_tenant_on_this_unit': 'No active tenant on this unit.',
    'tenant_8': 'Tenant',
    'no_tenant_vacant': 'No tenant (vacant)',
    'inspection_type': 'Inspection Type',
    'overall_condition': 'Overall Condition',
    'a_20_item_standardized_checklist_entranc': 'A 20-item standardized checklist (Entrance, Living Room, Kitchen, Bathroom, Bedroom, General) will be automatically created.',
    'cancel_11': 'Cancel',
    'creating': 'Creating…',
    'create_inspection': 'Create Inspection',
    'unit_9': '· Unit',
    'tenant_9': 'Tenant:',
    'inspector': 'Inspector:',
    'print_2': 'Print',
    'checklist_completion': 'Checklist Completion',
    'overall': 'Overall:',
    'click_a_condition_button_to_rate_each_it': 'Click a condition button to rate each item. Notes are saved automatically on blur.',
    'general_notes_1': 'General Notes',
    'close_1': 'Close',
    'completing': 'Completing…',
    'mark_as_completed': 'Mark as Completed',
    'close_2': 'Close',
    'signing': 'Signing…',
    'sign_inspection': 'Sign Inspection',
    'sign_inspection_message': 'Mark this inspection as signed? This action is final and cannot be undone.',
    'signing_is_final_and_cannot_be_undone': 'Signing is final and cannot be undone.',
    'delete_draft_inspection': 'Delete Draft Inspection',
    'delete_draft_confirm': 'Are you sure you want to delete this draft inspection?',
    'failed_load_inspections': 'Failed to load inspections',
    'inspection_created': 'Inspection created',
    'failed_create_inspection': 'Failed to create inspection',
    'failed_save_checklist': 'Failed to save checklist',
    'inspection_completed': 'Inspection marked as completed',
    'inspection_signed': 'Inspection signed',
    'failed_sign_inspection': 'Failed to sign inspection',
    'failed_update_condition': 'Failed to update condition',
    'inspection_deleted': 'Inspection deleted',
    'failed_delete_inspection': 'Only draft inspections can be deleted',
    'search_inspections_placeholder': 'Search by unit, building or tenant…',
    'search_apartment_placeholder': 'Search apartment...',
    'inspection_notes_placeholder': 'Any initial observations or notes…',
    'item_notes_placeholder': 'Add notes for this item…',
    'fair': 'Fair',
    'poor': 'Poor',
    'covered_entity': 'Covered Entity',
    'select': 'Select',
    'policy_details': 'Policy Details',
    'start_date_2': 'Start Date',
    'notes_6': 'Notes',
    'cancel_12': 'Cancel',
    'manage_tenant_owner_and_building_insuran': 'Manage tenant, owner, and building insurance policies',
    'empty_key_12': '✓',
    'new_lease_application': 'New Lease Application',
    'applicant_information': 'Applicant Information',
    'full_name_1': 'Full Name *',
    'email_3': 'Email',
    'phone_6': 'Phone',
    'date_of_birth': 'Date of Birth',
    'current_address': 'Current Address',
    'employment': 'Employment',
    'employment_status': 'Employment Status',
    'monthly_income': 'Monthly Income ($)',
    'employer_name': 'Employer Name',
    'employer_phone': 'Employer Phone',
    'unit_preferences': 'Unit Preferences',
    'building_6': 'Building',
    'unit_10': 'Unit',
    'desired_move_in': 'Desired Move-In',
    'desired_lease_months': 'Desired Lease (months)',
    'has_pets': 'Has Pets',
    'pet_details': 'Pet Details',
    'notes_7': 'Notes',
    'cancel_13': 'Cancel',
    'submit_application': 'Submit Application',
    'review_and_approve_prospective_tenant_ap': 'Review and approve prospective tenant applications',
    'all_buildings_4': 'All Buildings',
    'no_applications_found': 'No applications found',
    'showing_2': 'Showing',
    'of_4': 'of',
    'prev_1': 'Prev',
    'next_2': 'Next',
    'close_3': 'Close',
    'unit_11': '· Unit #',
    'monthly_rent_2': 'Monthly Rent *',
    'discount_1': 'Discount',
    'contract_start_1': 'Contract Start *',
    'contract_end_1': 'Contract End *',
    'payment_day_of_month': 'Payment Day of Month *',
    'application': 'Application',
    'rejection_reason': 'Rejection Reason',
    'cancel_14': 'Cancel',
    'app_search_placeholder': 'Search name, email, phone…',
    'app_status_submitted': 'Submitted',
    'app_status_under_review': 'Under Review',
    'app_status_approved': 'Approved',
    'app_status_rejected': 'Rejected',
    'app_status_waitlisted': 'Waitlisted',
    'app_status_withdrawn': 'Withdrawn',
    'app_status_converted': 'Converted',
    'sort_newest': 'Newest First',
    'sort_movein_asc': 'Move-in ↑ Earliest',
    'sort_movein_desc': 'Move-in ↓ Latest',
    'sort_income_asc': 'Income ↑ Lowest',
    'sort_income_desc': 'Income ↓ Highest',
    'all_employment': 'All Employment',
    'emp_other': 'Other',
    'move_in_from': 'Move-in From',
    'move_in_to': 'Move-in To',
    'application_results_count': '{{count}} application(s)',
    'failed_to_load_lease_applications': 'Failed to load lease applications',
    'status_updated_to': 'Status updated to {{status}}',
    'rent_dates_payment_required': 'Rent, start date, end date and payment day are required',
    'converted_to_tenant_success': 'Converted to tenant',
    'conversion_failed': 'Conversion failed',
    'lease_duration_months_label': 'Lease Duration',
    'lease_duration_months': '{{n}} months',
    'details_not_provided': 'details not provided',
    'reviewed_by': 'Reviewed By',
    'reviewed_at': 'Reviewed At',
    'converting': 'Converting…',
    'applicant_name_required': 'Applicant name is required',
    'failed_to_submit_application': 'Failed to submit application',
    'submitting': 'Submitting…',
    'update_failed': 'Update failed',
    'nightly_scan_flags_leases_expiring_in_90': 'Nightly scan flags leases expiring in 90 days — draft offers auto-created, you send with one click',
    'generate_drafts': 'Generate Drafts Now',
    'send_all_drafts': 'Send All Drafts',
    'expiring_within_90_days': 'expiring within 90 days',
    'without_an_offer_yet': 'without an offer yet',
    'd_2': 'd',
    'offer_sent': 'offer sent',
    'no_offer': 'no offer',
    'all_statuses_1': 'All Statuses',
    'no_renewals_found': 'No renewals found',
    'd_left': 'd left',
    'convert_lease': 'Convert Lease',
    'counter_offer': 'Counter Offer',
    'tenant_10': 'Tenant:',
    'counter_rent_amount': 'Counter Rent Amount *',
    'cancel_15': 'Cancel',
    'send_counter': 'Send Counter',
    'error_loading_renewals': 'Failed to load renewals',
    'offer_sent_2': 'Offer sent',
    'error_sending_offer': 'Failed to send offer',
    'renewal_accepted': 'Renewal accepted',
    'error_accepting_renewal': 'Failed to accept renewal',
    'decline_renewal_title': 'Decline Renewal',
    'decline_renewal_msg': 'Are you sure you want to decline this renewal offer?',
    'renewal_declined': 'Renewal declined',
    'error_declining_renewal': 'Failed to decline renewal',
    'lease_converted_msg': 'Lease converted — tenant record updated!',
    'error_converting_renewal': 'Failed to convert renewal',
    'drafts_created': '{{count}} draft offer(s) created!',
    'no_new_drafts_needed': 'No new drafts needed — all expiring leases already have offers.',
    'error_generating_drafts': 'Failed to generate drafts',
    'no_draft_renewals_to_send': 'No draft renewals to send',
    'send_all_draft_offers_title': 'Send All Draft Offers',
    'send_all_draft_offers_msg': 'Send renewal offers to all {{count}} draft tenants (email + WhatsApp)?',
    'offers_sent': '{{count}} offer(s) sent!{{failed}}',
    'error_sending_offers': 'Failed to send offers',
    'counter_offer_sent': 'Counter offer sent',
    'error_sending_counter': 'Failed to send counter offer',
    'search_tenant_unit_building': 'Search tenant, unit, building…',
    'all_risk': 'All Risk',
    'risk_low': 'Low Risk',
    'risk_medium': 'Medium Risk',
    'risk_high': 'High Risk',
    'renewals_count': '{{count}} renewal(s)',
    'leases_expiring_90d': '{{count}} lease(s) expiring within 90 days',
    'viewed_1': 'Viewed',
    'accepted_1': 'Accepted',
    'counter_offered': 'Counter Offered',
    'declined_1': 'Declined',
    'full_lease_lifecycle_create_renew_termin': 'Full lease lifecycle — create, renew, terminate, history',
    'new_lease': 'New Lease',
    'all_status_1': 'All Status',
    'active_1': 'Active',
    'expired_1': 'Expired',
    'renewed': 'Renewed',
    'all_buildings_5': 'All Buildings',
    'no_leases_found': 'No leases found',
    'expired_2': 'Expired',
    'd_left_1': 'd left',
    'd_left_2': 'd left',
    'd_3': 'd',
    'renew': 'Renew',
    'terminate': 'Terminate',
    'terminate_lease': 'Terminate Lease',
    'this_action_cannot_be_undone_the_lease_w': 'This action cannot be undone. The lease will be permanently terminated.',
    'cancel_16': 'Cancel',
    'empty_key_13': '— #',
    'new_start_date': 'New Start Date *',
    'monthly_rent_3': 'Monthly Rent ($) *',
    'lease_type_1': 'Lease Type',
    'fixed_term_1': 'Fixed Term',
    'month_to_month_1': 'Month-to-Month',
    'annual_1': 'Annual',
    'renew_lease_1': 'Renew Lease',
    'cancel_17': 'Cancel',
    'expiry_days': '{{days}}d',
    'leases_expiring_within_60d': '{{count}} lease(s) expiring within 60 days',
    'sort_default': 'Sort: Default',
    'sort_expiry_asc': 'Expiry ↑ Soonest',
    'sort_expiry_desc': 'Expiry ↓ Latest',
    'sort_rent_asc': 'Rent ↑ Lowest',
    'sort_rent_desc': 'Rent ↓ Highest',
    'sort_name_asc': 'Tenant A → Z',
    'expiring_within': 'Expiring Within',
    'any_expiry': 'Any Expiry',
    'days_lte': '≤ {{n}} days',
    'create_tenant_for_lease': 'Create a tenant to automatically generate a lease record.',
    'terminating': 'Terminating…',
    'enter_termination_reason': 'Enter termination reason…',
    'failed_to_load_leases': 'Failed to load leases',
    'renewal_failed': 'Renewal failed',
    'terminate_failed': 'Termination failed',
    'start_date_and_rent_required': 'Start date and monthly rent are required',
    'lease_results_count': '{{count}} lease(s)',
    'description_3': 'Description',
    'tenant_11': 'Tenant',
    'close_4': 'Close',
    'new_maintenance_schedule': 'New Maintenance Schedule',
    'schedule_details': 'Schedule Details',
    'building_7': 'Building',
    'all_buildings_6': 'All Buildings',
    'frequency': 'Frequency *',
    'first_due_date': 'First Due Date *',
    'description_4': 'Description',
    'cancel_18': 'Cancel',
    'create_schedule': 'Create Schedule',
    'maintenance_schedules': 'Maintenance Schedules',
    'preventive_maintenance_tracking': 'Preventive maintenance tracking',
    'new_schedule': 'New Schedule',
    'overdue_work_orders_will_be_auto_created': 'overdue — work orders will be auto-created tonight',
    'no_schedules_found': 'No schedules found',
    'history': 'History —',
    'no_history_yet': 'No history yet',
    'wo': 'WO #',
    'empty_key_14': '✓',
    'owner_ledger': 'Owner Ledger',
    'immutable_financial_history': '— immutable financial history',
    'refresh_1': 'Refresh',
    'add_entry': 'Add Entry',
    'payouts': 'Payouts',
    'add_manual_ledger_entry': 'Add Manual Ledger Entry',
    'amount_3': 'Amount *',
    'description_5': 'Description *',
    'cancel_19': 'Cancel',
    'showing_3': 'Showing',
    'of_5': 'of',
    'prev_2': 'Prev',
    'next_3': 'Next',
    'new_parking_space': 'New Parking Space',
    'creation_mode': 'Creation Mode',
    'single_space': 'Single Space',
    'bulk_generation': 'Bulk Generation',
    'building_8': 'Building *',
    'select_building_1': 'Select building…',
    'prefix': 'Prefix',
    'start_number': 'Start Number *',
    'end_number': 'End Number *',
    'pad_with_zeros_e_g_01_02': 'Pad with Zeros? (e.g. 01, 02)',
    'space_number': 'Space Number *',
    'level': 'Level',
    'type_1': 'Type',
    'monthly_fee_1': 'Monthly Fee ($)',
    'notes_8': 'Notes',
    'cancel_20': 'Cancel',
    'saving_2': 'Saving…',
    'create_space': 'Create Space',
    'tenant_screening': 'Tenant Screening',
    'identity_verification_background_checks': 'Identity verification & background checks',
    'unit_12': 'Unit',
    'select_a_tenant_to_view_or_start_their_s': 'Select a tenant to view or start their screening',
    'final_decision': 'Final Decision',
    'set_on': 'Set on',
    'identity_verification': 'Identity Verification',
    'document_2': 'Document:',
    'name_6': 'Name:',
    'start_identity_verification': 'Start Identity Verification',
    'link_was_shared_with_the_tenant_waiting': 'Link was shared with the tenant — waiting for them to complete it.',
    'background_check_checkr': 'Background Check (Checkr)',
    'adjudication': 'Adjudication:',
    'checks': 'Checks:',
    'start_background_check': 'Start Background Check',
    'united_states': 'United States',
    'canada': 'Canada',
    'fcra_consent_required': 'FCRA Consent Required',
    'under_the_fair_credit_reporting_act_fcra': 'Under the Fair Credit Reporting Act (FCRA), you must obtain the applicant\'s written consent before running a background check. The tenant will receive an email from Checkr to complete the process.',
    'i_confirm_the_applicant_has_provided_wri': 'I confirm the applicant has provided written consent for this background check',
    'cancel_21': 'Cancel',
    'invitation_sent_waiting_for_the_applican': 'Invitation sent — waiting for the applicant to complete. Checkr will update this automatically.',
    'set_final_decision': 'Set Final Decision',
    'final_screening_decision': 'Final Screening Decision',
    'manual_review': 'Manual Review',
    'cancel_22': 'Cancel',
    'no_screening_started_for_this_tenant_yet': 'No screening started for this tenant yet.',
    'empty_key_15': '($) *',
    'prospect_information': 'Prospect Information',
    'showing_details': 'Showing Details',
    'empty_key_16': '· #',
    'empty_key_17': '· #',
    'add_unit_amenity_1': 'Add Unit Amenity',
    'bulk_addition_mode': 'Bulk Addition Mode',
    'add_this_amenity_to_multiple_units_at_on': 'Add this amenity to multiple units at once',
    'amenity_details_1': 'Amenity Details',
    'clear_all': 'Clear All',
    'nothing_found_1': 'Nothing found.',
    'amenity_name': 'Amenity Name *',
    'category_4': 'Category',
    'condition': 'Condition',
    'notes_9': 'Notes',
    'cancel_23': 'Cancel',
    'saving_3': 'Saving…',
    'add_amenity_1': 'Add Amenity',
    'n_more': '+{{n}} more',
    'board_view': 'Board View',
    'main_level': 'Main Level',
    'unassigned_1': 'Unassigned',
    'unit_cat_appliance': 'Appliance',
    'unit_cat_climate': 'Climate',
    'unit_cat_view': 'View',
    'unit_cat_layout': 'Layout',
    'unit_cat_finish': 'Finish',
    'unit_cat_storage': 'Storage',
    'unit_cat_connectivity': 'Connectivity',
    'unit_cat_safety': 'Safety',
    'unit_cat_other': 'Other',
    'bld_cat_general': 'General',
    'bld_cat_fitness': 'Fitness',
    'bld_cat_pool': 'Pool',
    'bld_cat_common_area': 'Common Area',
    'bld_cat_outdoor': 'Outdoor',
    'bld_cat_security': 'Security',
    'bld_cat_business': 'Business',
    'bld_cat_parking': 'Parking',
    'bld_cat_pet': 'Pet',
    'bld_cat_laundry': 'Laundry',
    'bld_cat_storage': 'Storage',
    'all_fields_required': 'All fields are required',
    'booking_failed': 'Booking failed',
    'failed_to_load_amenity': 'Failed to load amenity',
    'name_required': 'Name is required',
    'amenity_updated': 'Amenity updated',
    'amenity_added': 'Amenity added',
    'open_time': 'Open',
    'close_time': 'Close',
    'max_occupancy': 'Max occupancy',
    'edit_building_amenity': 'Edit Building Amenity',
    'new_building_amenity': 'New Building Amenity',
    'unit_required': 'Unit is required',
    'at_least_one_unit_required': 'At least one unit is required',
    'unit_amenity_updated': 'Unit amenity updated',
    'amenity_bulk_added': 'Amenity added to {{count}} units',
    'selected_units_label': 'Selected Units *',
    'unit_searchable_label': 'Unit * (Searchable)',
    'search_add_multiple_units': 'Search & add multiple units...',
    'search_unit_by_num': 'Search unit by # or building...',
    'cond_new': 'New',
    'cond_excellent': 'Excellent',
    'cond_good': 'Good',
    'cond_fair': 'Fair',
    'cond_needs_repair': 'Needs Repair',
    'meter_accounts_rubs_billing_and_per_tena': 'Meter accounts, RUBS billing, and per-tenant utility charges',
    'option_a_metered': 'Option A — Metered:',
    'add_account_record_reading_generate_bill': 'Add account → record reading → generate bills → charge to ledger',
    'option_c_rubs': 'Option B — RUBS:',
    'building_level_meter_split_equally_acros': 'Building-level meter split equally across all active tenants',
    'no_utility_accounts_yet_add_one_to_start': 'No utility accounts yet — add one to start metered billing.',
    'no_bills_yet_generate_from_meter_readings': 'No bills yet — add meter accounts, record readings, then generate bills.',
    'no_readings': 'No readings',
    'shared': 'Shared',
    'all_statuses_2': 'All statuses',
    'accounts': 'Accounts',
    'bills': 'Bills',
    'benchmarking': 'Benchmarking',
    'total_bills': 'Total Bills',
    'total_billed': 'Total Billed',
    'charge': 'Charge',
    'unit_13': 'Unit',
    'notes_10': 'Notes',
    'cancel_24': 'Cancel',
    'loading_1': 'Loading…',
    'accounts_tracked': 'accounts tracked',
    'monthly_consumption_last_6_months': 'Monthly Consumption — last 6 months',
    'monthly_cost': 'Monthly Cost ($)',
    'no_readings_recorded_yet_for': 'No readings recorded yet for',
    'valuation_details': 'Valuation Details',
    'building_9': 'Building *',
    'market_value': 'Market Value ($) *',
    'valuation_method': 'Valuation Method',
    'notes_11': 'Notes',
    'cancel_25': 'Cancel',
    'portal': 'Portal ✓',
    'invite_as_system_user_full_portal_access': 'Invite as System User (Full Portal Access)',
    'this_will_create_a_staff_account_with_th': 'This will create a staff account with the \'vendor\' role. They will receive an email invitation to set their password.',
    'record_violation': 'Record Violation',
    'tenant_unit': 'Tenant & Unit',
    'tenant_12': 'Tenant *',
    'unit_14': '— Unit',
    'apartment_id': 'Apartment ID',
    'auto_filled': 'auto-filled',
    'violation_details': 'Violation Details',
    'title_1': 'Title *',
    'type_2': 'Type *',
    'severity': 'Severity *',
    'incident_date': 'Incident Date *',
    'fine_amount_optional': 'Fine Amount (optional)',
    'description_6': 'Description *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'If a fine amount is entered, it will be automatically charged to the tenant ledger.',
    'cancel_26': 'Cancel',
    'record_violation_1': 'Record Violation',
    'violations_notices': 'Violations & Notices',
    'track_lease_violations_and_issue_formal': 'Track lease violations and issue formal legal notices',
    'new_violation': 'New Violation',
    'how_it_works_1': 'How It Works',
    'all_statuses_3': 'All Statuses',
    'notice': 'Notice',
    'resolve': 'Resolve',
    'issue_legal_notice': 'Issue Legal Notice',
    'cancel_27': 'Cancel',
    'add_webhook_endpoint': 'Add Webhook Endpoint',
    'push_events_to_your_external_systems': 'Push events to your external systems',
    'successfully_created': 'Successfully Created!',
    'save_your_signing_secret_now_it_won_t_be': 'Save your signing secret now — it won\'t be shown again.',
    'copy_secret': 'Copy Secret',
    'done_return': 'Done & Return',
    'connection_details': 'Connection Details',
    'payload_url': 'Payload URL',
    'description_7': 'Description',
    'event_subscriptions': 'Event Subscriptions',
    'you_can_always_add_more_events_later': 'You can always add more events later.',
    'register_endpoint': 'Register Endpoint',
    'cancel_28': 'Cancel',
    'assign_a_new_task_to_a_maintenance_provi': 'Assign a new task to a maintenance provider',
    'work_order_details': 'Work Order Details',
    'work_order_title': 'Work Order Title',
    'task_description': 'Task Description',
    'scheduling_reference': 'Scheduling & Reference',
    'maintenance_request_id': 'Maintenance Request ID',
    'assignment': 'Assignment',
    'select_a_maintenance_provider': 'Select a maintenance provider',
    'priority_level_level': 'Priority Level Level',
    'dispatch_work_order': 'Dispatch Work Order',
    'discard_changes': 'Discard Changes',
    'pro_tip': 'Pro Tip',
    'dispatching_a_work_order_will_immediatel': 'Dispatching a work order will immediately notify the vendor via their portal and email if enabled.',
    'update_work_order': 'Update Work Order',
    'status_priority': 'Status & Priority',
    'status_4': 'Status',
    'completed_date': 'Completed Date',
    'invoice': 'Invoice',
    'invoice_amount': 'Invoice Amount',
    'invoice_status': 'Invoice Status',
    'cancel_29': 'Cancel',
    'vendor_work_order_management': 'Vendor work order management',
    'refresh_2': 'Refresh',
    'new_work_order': 'New Work Order',
    'all_statuses_4': 'All Statuses',
    'no_work_orders_found': 'No work orders found',
    'mr': 'MR:',
    'work_order': 'Work Order #',
    'priority_1': 'priority',
    'description_8': 'Description',
    'linked_maintenance_request': 'Linked Maintenance Request',
    'unit_15': 'Unit',
    'invoice_1': 'Invoice',
    'view_invoice_document': 'View invoice document',
    'review_approve_invoice': 'Review & Approve Invoice',
    'edit_work_order': 'Edit Work Order',
    'approve_invoice': 'Approve Invoice',
    'you_are_approving_a_vendor_invoice_of': 'You are approving a vendor invoice of',
    'for': 'for',
    'charge_to_tenant_ledger': 'Charge to Tenant Ledger',
    'the_cost_will_be_automatically_added_as': 'The cost will be automatically added as a debit on the tenant\'s ledger for them to pay.',
    'organization_absorbs_cost': 'Organization Absorbs Cost',
    'the_tenant_will_not_be_charged_this_crea': 'The tenant will not be charged. This creates an Accounts Payable entry for the organization.',
    'cancel_30': 'Cancel',
    'loading_2': 'Loading…',
    'page_not_found': 'Page Not Found',
    'the_page_you_re_looking_for_doesn_t_exis': 'The page you\'re looking for doesn\'t exist.',
    'go_to_dashboard': 'Go to Dashboard',
    'clear_signature': 'Clear Signature',
    'i_consent_to_use_electronic_signatures_a': 'I consent to use electronic signatures and agree that my electronic signature                                  is the legal equivalent of my manual signature on this contract. I understand                                  that I have the right to receive a paper copy of this document.',
    'cancel_31': 'Cancel',
    'sign_contract_1': 'Sign Contract',
    'by_signing_this_document_electronically': 'By signing this document electronically, you acknowledge that your electronic signature                          is legally binding and has the same effect as a handwritten signature. Your IP address                          and timestamp will be recorded for verification purposes.',
    'subscription_locked': 'Subscription Locked',
    'your_subscription_status_is': 'Your subscription status is',
    'please_renew_your_subscription_to_contin': '.                     Please renew your subscription to continue managing your properties.',
    'payment_options': 'Payment Options',
    'please_contact_the_administrator_to_proc': 'Please contact the administrator to process your payment and reactivate your subscription.',
    'contact_admin_to_renew': 'Contact Admin to Renew',
    'request_sent_pending_approval': 'Request Sent! Pending Approval.',
    'need_help_contact_support_at_support_qua': 'Need help? Contact support at support@quadcores.com',
    'requires_the': 'requires the',
    'is_a_pro_feature': 'is a Pro feature',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'Upgrade to Pro to unlock AI-powered intelligence across your entire portfolio.',
    'upgrade_to_pro_1': 'Upgrade to Pro',
    'starting_at_3_20_unit_month_no_minimum_u': 'Starting at $3.20 / unit / month · No minimum units required',
    'our_narrative': 'Our Narrative',
    'reimagined': 'reimagined.',
    'quadcores_properties_is_an_elite_operati': 'Quadcores Properties is an elite operational layer for the modern real estate portfolio.                              Built for scale, designed for precision, and engineered for those who mean business.',
    'core_capabilities': 'Core Capabilities',
    'our_approach_to': 'Our approach to',
    'operations': 'operations.',
    'we_believe_property_management_should_be': 'We believe property management should be efficient, transparent, and scalable.                                  That\'s why we built a platform that eliminates manual legacy processes,                                  replacing them with automated, real-time intelligence.',
    'whether_you_manage_10_units_or_10_000_qu': 'Whether you manage 10 units or 10,000, Quadcores Properties scales with your complexity.                                  Our mission is to provide the technical foundation so you can focus on building                                  value and relationships, not chasing paperwork.',
    'complete_platform': 'Complete Platform',
    'all_features': 'All Features',
    '35_powerful_features_organized_into_7_co': '35 powerful features organized into 7 comprehensive categories.',
    'link_unavailable': 'Link Unavailable',
    'application_submitted': 'Application Submitted!',
    'your_application_has_been_received_our_t': 'Your application has been received. Our team will review it and get back to you soon.',
    'your_application_id': 'Your Application ID',
    'successfully_registered': 'Successfully Registered',
    'track_application_status': 'Track Application Status',
    'rental_application': 'Rental Application',
    'unit_16': 'Unit',
    'applying_for': 'Applying for',
    'full_name_2': 'Full Name *',
    'email_address': 'Email Address *',
    'national_id_passport': 'National ID / Passport',
    'date_of_birth_1': 'Date of Birth',
    'current_address_1': 'Current Address',
    'employment_income': 'Employment & Income',
    'employment_status_1': 'Employment Status',
    'employed': 'Employed',
    'self_employed': 'Self Employed',
    'retired': 'Retired',
    'student': 'Student',
    'unemployed': 'Unemployed',
    'monthly_income_1': 'Monthly Income',
    'employer_name_1': 'Employer Name',
    'employer_phone_1': 'Employer Phone',
    'lease_preferences': 'Lease Preferences',
    'desired_move_in_date': 'Desired Move-In Date',
    'lease_duration_months': 'Lease Duration (months)',
    'months_2': 'months',
    'i_have_pets': 'I have pets',
    'emergency_contact': 'Emergency Contact',
    'name_7': 'Name',
    'phone_7': 'Phone',
    'relation': 'Relation',
    'additional_notes_1': 'Additional Notes',
    'your_information_is_kept_private_and_use': 'Your information is kept private and used only for rental evaluation.',
    'track_application': 'Track Application',
    'ref_id': 'Ref ID: #',
    'verification_email': 'Verification Email',
    'review': 'Review',
    'approval': 'Approval',
    'notice_from_the_team': 'Notice from the Team',
    'applicant': 'Applicant',
    'property_1': 'Property',
    'submitted_1': 'Submitted',
    'approved_for_lease': 'Approved for Lease',
    'next_steps_sign_lease': 'Next Steps: Sign Lease',
    'questions_contact': 'Questions? Contact',
    'support': 'Support',
    'or_call_our_leasing_office': 'or call our leasing office.',
    'verification_code': 'Verification Code',
    'verify_code': 'Verify Code',
    'resend_code': 'Resend Code',
    'back_to_login': 'Back to Login',
    'invalid_link': 'Invalid Link',
    'go_to_login': 'Go to Login',
    'welcome_aboard': 'Welcome Aboard!',
    'secure_onboarding': 'Secure Onboarding',
    'welcome_to_the_quadcores_property_manage': 'Welcome to the Quadcores Property Management portal. Let\'s finish setting up your internal account.',
    'account_role': 'Account Role',
    'email_address_1': 'Email Address',
    'set_your_password': 'Set Your Password',
    'please_choose_a_secure_password_for_your': 'Please choose a secure password for your account.',
    'show_password': 'Show Password',
    'complete_account_setup': 'Complete Account Setup',
    'password_requirement_minimum_8_character': 'Password requirement: Minimum 8 characters. We recommend using a mix of letters, numbers, and symbols for maximum security.',
    'thank_you_for_your_subscription_your_acc': 'Thank you for your subscription. Your account has been upgraded.',
    'go_to_dashboard_1': 'Go to Dashboard',
    'back_to_home': 'Back to Home',
    'pricing_plans': 'Pricing + Plans',
    'pay_for_what': 'Pay for what',
    'you_actually_use': 'you actually use.',
    'annual_2': 'Annual',
    '16_1': '−16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'Per-unit pricing. No minimum portfolio size. Cancel anytime.',
    'current_1': 'Current',
    'unit_17': '/ unit',
    'from_3': 'from',
    'mo_3': '/mo',
    'minimum': 'minimum',
    '2_months_free_annual_billing': '2 months free · Annual billing',
    'includes': 'Includes',
    'enterprise_custom_contract': 'Enterprise / Custom contract',
    '10_000_units_custom_sla_dedicated_suppor': '10,000+ units, custom SLA, dedicated support, on-premise option.',
    'talk_to_sales': 'Talk to sales →',
    'feature_matrix': 'Feature Matrix',
    'full_capability': 'Full capability',
    'breakdown': 'breakdown.',
    'starter': 'Starter',
    'growth': 'Growth',
    'pro_2': 'Pro',
    'no_minimum_units_no_setup_fees_enterpris': 'No minimum units. No setup fees. Enterprise-grade security on every plan.',
    'legal': 'Legal',
    'privacy': 'Privacy',
    'policy': 'Policy.',
    'we_are_committed_to_protecting_your_prof': 'We are committed to protecting your professional and personal data with the same rigor we apply to property operations.                             Transparency is our foundation.',
    'principles': 'Principles',
    'section_0': 'SECTION 0',
    'legal_and_compliance': 'Legal and compliance',
    'inquiries': 'inquiries.',
    'if_you_have_questions_about_how_we_handl': 'If you have questions about how we handle your data, or if you need to exercise your privacy rights, please contact our compliance team.                                 We are here to ensure your peace of mind.',
    'info_quadcores_com': 'info@quadcores.com',
    'please_review_the_full_contract_terms_be': 'Please review the full contract terms below.',
    'link_expired_or_invalid': 'Link Expired or Invalid',
    'we_couldn_t_find_the_contract_associated': 'We couldn\'t find the contract associated with this link. Please contact the property management office for a new signature link.',
    'your_signature_has_been_recorded_a_copy': 'Your signature has been recorded. A copy of the signed contract will be sent to your email shortly.',
    'setup_your_portal': 'Setup your Portal',
    'access_your_payments_installments_and_do': 'Access your payments, installments, and documents anytime by setting up your portal account.',
    'activate_my_account': 'Activate My Account',
    'go_to_dashboard_2': 'Go to Dashboard',
    'id_1': 'ID: #',
    'contract_signature_portal': 'Contract Signature Portal',
    'review_sign': 'Review & Sign',
    'hello': 'Hello',
    'please_review_your_contract_details_for': ', please review your contract details for the property below.',
    'property_2': 'Property',
    'contract_value': 'Contract Value',
    'timeline': 'Timeline',
    'to_3': 'to',
    'legal_terms': 'Legal Terms',
    'en_ar': 'EN/AR',
    'legal_disclaimer': 'Legal Disclaimer',
    'electronic_signatures_are_legally_equiva': 'Electronic signatures are legally equivalent to handwritten ones.',
    'your_ip_address_and_device_information_w': 'Your IP address and device information will be logged for security.',
    'you_can_download_the_pdf_anytime_after_c': 'You can download the PDF anytime after completion.',
    'ready_to_complete': 'Ready to complete?',
    'continue_to_plans': 'Continue to Plans',
    'next_step': 'Next Step...',
    'complete_registration': 'Complete Registration',
    'verify_phone_number': 'Verify Your Phone Number',
    'verification_code_sent_to_phone': 'Verification code sent to your phone. Please enter it below.',
    'popular': 'Popular',
    'mo_4': '/mo',
    'up_to': 'Up to',
    'units_2': 'units',
    'back_to_info': 'Back to Info',
    'verification_code_1': 'Verification Code',
    'please_enter_the_6_digit_code_sent_to': 'Please enter the 6-digit code sent to',
    'verify_phone': 'Verify Phone',
    'guidelines': 'Guidelines',
    'terms_of': 'Terms of',
    'use': 'Use.',
    'our_terms_are_designed_to_ensure_a_secur': 'Our terms are designed to ensure a secure, reliable, and fair environment for owners, tenants, and property managers alike.',
    'conditions': 'Conditions',
    'clause_0': 'CLAUSE 0',
    'agreement_to': 'Agreement to',
    'arbitration': 'arbitration.',
    'by_using_the_platform_you_agree_that_any': 'By using the platform, you agree that any disputes will be resolved through professional mediation or binding arbitration, ensuring efficient resolution of operational conflict.                                  We are committed to maintaining a collaborative relationship with all our users.',
    'last_updated_march_2026': 'Last updated: March 2026',
    'system_architecture': 'System Architecture',
    'refined': 'Refined',
    'operations_1': 'Operations.',
    'a_masterclass_in_property_management_we': 'A masterclass in property management. We stripped away the noise to leave only what is necessary, powerful, and impeccably designed.',
    'complete_platform_1': 'Complete Platform',
    'everything_you_need_to_manage': 'Everything you need to manage',
    'your_properties': 'your properties.',
    'a_comprehensive_property_management_syst': 'A comprehensive property management system built for efficiency, automation, and scale.',
    'view_all_24_features': 'View all 24 features',
    'get_started': 'Get started',
    'take_control_of': 'Take control of',
    'your_entire_portfolio': 'your entire portfolio.',
    'hundreds_of_property_managers_have_alrea': 'Hundreds of property managers have already moved their operations to QuadProperties.                             Start your free trial — no credit card needed.',
    'start_free_trial': 'Start free trial',
    'already_have_an_account': 'Already have an account?',
    'quadcores_properties': 'Quadcores Properties',
    'the_apartment_management_platform_built': 'The apartment management platform built for serious operations.',
    'quadcores': 'Quadcores',
    'quadcores_properties_1': 'Quadcores Properties',
    'every_property': 'Every property.',
    'under_control': 'Under control.',
    'one_platform_for_leases_rent_collection': 'One platform for leases, rent collection, maintenance, and tenants —                         built for property managers who mean business.',
    'start_free_trial_1': 'Start free trial',
    'view_dashboard': 'View dashboard',
    'scroll': 'Scroll',
    'quadcores_properties_2': 'Quadcores Properties',
    'tenant_login': 'Tenant Login',
    'owner_login': 'Owner Login',
    'sign_in': 'Sign in',
    'get_started_1': 'Get started →',
    'sign_in_1': 'Sign in',
    'menu': 'Menu',
    'get_started_2': 'Get Started',
    'tenant_13': 'Tenant',
    'owner_1': 'Owner',
    'nav_features': 'Features',
    'nav_pricing': 'Pricing',
    'nav_about': 'About',
    'our_tiers': 'Our Tiers',
    'choose_the_right': 'Choose the right',
    'plan_for_you': 'plan for you.',
    'monthly_1': 'Monthly',
    'annual_3': 'Annual',
    'mo_5': '/ mo',
    '20_off_annual_billing': '-20% off annual billing',
    'quadcores_properties_3': 'Quadcores Properties',
    'the_apartment_management_platform_built_1': 'The apartment management platform built for serious operations.',
    'quadcores_1': 'Quadcores',
    'solutions': 'Solutions',
    'built_for_every_property_professional': 'Built for every property professional.',
    'empty_key_18': '✦',
    'set_up_your_password': 'Set up your password',
    'create_a_strong_password_for': 'Create a strong password for',
    'email_address_2': 'Email Address',
    'new_password_1': 'New Password',
    'confirm_password_1': 'Confirm Password',
    'back_to_login_1': 'Back to Login',
    'view_all_announcements': 'View all announcements →',
    'session_expiring_soon': 'Session Expiring Soon',
    'you_will_be_logged_out_automatically': 'You will be logged out automatically',
    'log_out': 'Log Out',
    'stay_logged_in': 'Stay Logged In',
    'id_2': 'ID: #',
    'to_4': 'to',
    'ip_1': 'IP:',
    'ip_2': 'IP:',
    'contract_already_signed': 'Contract Already Signed',
    'you_have_already_signed_this_contract': 'You have already signed this contract.',
    'review_sign_contract': 'Review & Sign Contract',
    'awaiting_your_signature': 'Awaiting Your Signature',
    'contract_summary_1': 'Contract Summary',
    'property_3': 'Property',
    'start_date_3': 'Start Date',
    'end_date_1': 'End Date',
    'terms_and_conditions': 'Terms and Conditions',
    'important_information': 'Important Information',
    'by_signing_you_agree_to_all_terms_and_co': '• By signing, you agree to all terms and conditions stated above',
    'your_electronic_signature_is_legally_bin': '• Your electronic signature is legally binding',
    'you_will_receive_a_signed_copy_via_email': '• You will receive a signed copy via email',
    'you_can_download_the_signed_contract_any': '• You can download the signed contract anytime from your portal',
    'cancel_32': 'Cancel',
    'sign_contract_2': 'Sign Contract',
    'units_3': 'units',
    'unit_18': 'Unit',
    'tenant_14': 'Tenant:',
    'empty_key_19': '· $',
    'mo_6': '/mo',
    'no_properties_found_in_your_portfolio': 'No properties found in your portfolio.',
    'my_ledger': 'My Ledger',
    'complete_history_of_your_financial_trans': 'Complete history of your financial transactions',
    'current_balance_1': 'Current Balance',
    'no_ledger_entries_yet_1': 'No ledger entries yet',
    'transactions_will_appear_here_once_recor': 'Transactions will appear here once recorded.',
    'unit_19': 'Unit',
    'bal': 'Bal',
    'professional_access': 'Professional Access',
    'owner_2': 'Owner',
    'secure_identify_for_property_executives': 'Secure identify for property executives and management.',
    'email_or_phone_number': 'Email or Phone Number',
    'secure_password': 'Secure Password',
    'switch_to_resident_login': 'Switch to Resident Login',
    'institutional_oversight': 'Institutional oversight.',
    'portfolio_suite': 'Portfolio Suite',
    'full_control_over_your': 'Full control over your',
    'property_assets': 'property assets.',
    'audited_secure_compliant': 'Audited. Secure. Compliant.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'Per-unit P&L — last 12 months',
    'loading_report': 'Loading report…',
    'no_properties_found': 'No properties found',
    'unit_20': '· Unit #',
    'mo_lease_ends': '/mo · Lease ends',
    '12_mo_noi': '12-mo NOI',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'Monthly Collections (Last 6 Months)',
    'tax_documents': 'Tax Documents',
    'annual_payment_summary_for_tax_reporting': 'Annual payment summary for tax reporting (1099-NEC)',
    'total_paid_1': 'Total Paid',
    'this_is_your_personal_payment_summary_fo': 'This is your personal payment summary. For the official 1099-NEC form, please contact your property manager. Only payments of $600 or more in a calendar year are reportable to the IRS.',
    'unit_21': 'Unit',
    'no_payments_recorded_for': 'No payments recorded for',
    'select_a_different_year_to_view_your_pay': 'Select a different year to view your payment history.',
    'browse_facilities_and_book_time_slots': 'Browse facilities and book time slots',
    'no_amenities_available_in_your_building': 'No amenities available in your building',
    'mo_7': '/mo',
    'capacity_1': 'Capacity:',
    'book_time_slot': 'Book Time Slot',
    'book_an_amenity': 'Book an Amenity',
    'amenity_1': 'Amenity *',
    'select_amenity_1': 'Select amenity',
    'date_2': 'Date *',
    'start_time_1': 'Start Time *',
    'end_time_1': 'End Time *',
    'notes_optional_1': 'Notes (optional)',
    'cancel_33': 'Cancel',
    'no_upcoming_bookings': 'No upcoming bookings',
    'browse_amenities': 'Browse amenities',
    'cancel_34': 'Cancel',
    'history_1': 'History',
    'property_assistant': 'Property Assistant',
    'ask_about_your_account': 'Ask about your account',
    'lease_history': 'Lease History',
    'your_current_and_past_lease_agreements': 'Your current and past lease agreements',
    'active_lease': 'Active Lease',
    'unit_22': 'Unit',
    'building_10': 'Building',
    'monthly_rent_4': 'Monthly Rent',
    'expires_1': 'Expires',
    'open_ended': 'Open-ended',
    'start_date_4': 'Start Date',
    'security_deposit_1': 'Security Deposit',
    'type_3': 'Type',
    'no_active_lease_on_file': 'No active lease on file',
    'history_2': 'History',
    'mo_8': '/mo',
    'no_lease_records_found': 'No lease records found',
    'secure_access': 'Secure Access',
    'hello_1': 'Hello',
    'again': 'Again.',
    'enter_your_details_to_manage_your_home_a': 'Enter your details to manage your home and payments.',
    'your_email': 'Your Email',
    'your_password': 'Your Password',
    'switch_to_owner_login': 'Switch to Owner Login',
    'everything_in_one_place': 'Everything in one place.',
    'tools_for_you': 'Tools for You',
    'everything_you_need': 'Everything you need',
    'to_manage_your_home': 'to manage your home.',
    'safe_private_reliable': 'Safe. Private. Reliable.',
    'we_use_professional_grade_encryption_to': 'We use professional-grade encryption to ensure your data and payments are always protected.',
    'empty_key_22': ': #',
    'auto_pay_is_on': 'Auto-Pay is ON',
    'your_rent_is_charged_automatically_on_th': '· Your rent is charged automatically on the due date.',
    'enable_auto_pay': 'Enable Auto-Pay',
    'save_a_card_or_bank_account_and_never_mi': 'Save a card or bank account and never miss a rent payment again.',

    'autopay_enabled_toast': 'Auto-Pay enabled! Your rent will be charged automatically each month.',
    'autopay_setup_canceled': 'Auto-Pay setup was canceled.',
    'autopay_setup_failed': 'Could not start Auto-Pay setup.',
    'autopay_start_failed': 'Failed to start Auto-Pay setup.',
    'confirm_disable_autopay': 'Are you sure you want to disable Auto-Pay? Your saved payment method will be removed.',
    'autopay_disabled_success': 'Auto-Pay has been disabled.',
    'autopay_disable_failed': 'Failed to disable Auto-Pay.',
    'card_ending_label': '{{brand}} ending ••••{{last4}}',
    'payment_method_saved': 'Payment method saved',
    'disable_auto_pay': 'Disable Auto-Pay',
    'set_up_auto_pay': 'Set Up Auto-Pay',
    'due_colon': 'Due:',
    'disabling': 'Disabling…',
    'renewal_offers': 'Renewal Offers',
    'review_and_respond_to_lease_renewal_offe': 'Review and respond to lease renewal offers from your landlord',
    'no_renewal_offers_yet': 'No renewal offers yet',
    'your_property_manager_will_send_a_renewa': 'Your property manager will send a renewal offer here when your lease is approaching its end date.',
    'unit_23': 'Unit',
    'offer_sent_1': 'Offer sent',
    'per_month': 'per month',
    'offered_rent': 'Offered Rent',
    'per_month_1': 'per month',
    'new_term': 'New term:',
    'note_from_management': 'Note from management',
    'decline': 'Decline',
    'past_offers': 'Past Offers',
    'unit_24': 'Unit',
    'mo_9': '/mo',
    'responded': 'Responded',
    'share_feedback': 'Share Feedback',
    'your_opinion_helps_us_improve': 'Your opinion helps us improve',
    'thank_you': 'Thank you!',
    'your_feedback_has_been_submitted': 'Your feedback has been submitted.',
    'submit_another': 'Submit Another',
    'category_5': 'Category',
    'your_rating': 'Your Rating',
    'comment_optional': 'Comment (optional)',
    'your_past_feedback': 'Your Past Feedback',

    'general': 'General',
    'submit_feedback': 'Submit Feedback',
    'please_select_rating': 'Please select a star rating',
    'submission_failed': 'Submission failed',
    'tell_us_placeholder': 'Tell us what you think…',
    'rating_very_poor': 'Very Poor',
    'rating_poor': 'Poor',
    'rating_okay': 'Okay',
    'rating_good': 'Good',
    'rating_excellent': 'Excellent',
    'utility_bills_1': 'Utility Bills',
    'electricity_water_gas_and_other_utility': 'Electricity, water, gas, and other utility charges',
    'paid_on_time': 'Paid on time',
    'monthly_utility_spend': 'Monthly Utility Spend',
    'no_utility_bills_yet': 'No utility bills yet',
    'bills_will_appear_here_once_issued_by_ma': 'Bills will appear here once issued by management.',
    'due_now': 'Due Now (',
    'history_3': 'History (',
    'due_1': 'Due',
    'violations_notices_1': 'Violations & Notices',
    'view_violations_and_official_notices_iss': 'View violations and official notices issued to you',
    'no_violations_on_record': 'No violations on record',
    'you_have_a_clean_record_keep_it_up': 'You have a clean record — keep it up!',
    'fine': 'Fine:',
    'resolution': 'Resolution',
    'unit_25': 'Unit',
    'no_notices': 'No notices',
    'no_official_notices_have_been_issued_to': 'No official notices have been issued to you.',
    'here_s_an_overview_of_your_operations_to': 'Here\'s an overview of your operations today.',
    'system_live': 'System Live',
    'active_operations': 'Active Operations',
    'priority_task_queue': 'Priority Task Queue',
    'no_active_tasks_in_your_queue': 'No active tasks in your queue.',
    'compliance_alert': 'Compliance Alert',
    'insurance_expires_in_12_days_please_uplo': 'Insurance expires in 12 days. Please upload updated documents.',
    'upgrade_1': 'Upgrade',
    'service_score': 'Service Score',
    'detailed_analysis': 'Detailed Analysis',
    'system_activity': 'System Activity',
    'profile_load_error': 'Profile Load Error',
    'the_registry_could_not_verify_your_ident': 'The registry could not verify your identity. Contact system administrators.',
    'operator': 'Operator',
    'tier_platinum': 'Tier: Platinum',
    'identity_matrix': 'Identity Matrix',
    'logistical_data': 'Logistical Data',
    'verified_credentials': 'Verified Credentials',
    'profile_modifications_are_managed_by_ins': 'Profile modifications are managed by institutional security protocols. Request updates via the control desk for grid integrity.',
    'invalid_or_expired_link': 'Invalid Or Expired Link',
    'security_established': 'Security Established',
    'your_portal_access_key_has_been_successf': 'Your portal access key has been successfully created.',
    'proceed_to_login': 'Proceed to Login',
    'access_setup': 'Access Setup',
    'finalize_your_credentials_for': 'Finalize your credentials for',
    'new_access_key': 'New Access Key',
    'confirm_authorization': 'Confirm Authorization',
    'finalize_connection': 'Finalize Connection',
    'w_9_tax_form': 'W-9 Tax Form',
    'request_for_taxpayer_identification_numb': 'Request for Taxpayer Identification Number — required for 1099-NEC filing',
    'w_9_on_file': 'W-9 on file',
    'certified_on': 'Certified on',
    'you_can_update_and_re_certify_at_any_tim': '. You can update and re-certify at any time.',
    'this_form_is_required_by_the_irs_if_you': 'This form is required by the IRS. If you receive $600 or more in a calendar year, a 1099-NEC will be issued using this information. Your full SSN is never stored — only the last 4 digits if provided.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. Legal name (as shown on income tax return) *',
    '3_federal_tax_classification': '3. Federal tax classification *',
    'employer_id_number_ein': 'Employer ID Number (EIN)',
    'ssn_last_4_digits_only': 'SSN — last 4 digits only',
    'we_only_store_the_last_4_for_your_privac': 'We only store the last 4 for your privacy',
    '5_address': '5. Address',
    'city': 'City',
    'state': 'State',
    'certification': 'Certification',
    'under_penalties_of_perjury_i_certify_tha': 'Under penalties of perjury, I certify that: (1) the number shown is my correct taxpayer identification number; (2) I am not subject to backup withholding; (3) I am a U.S. citizen or other U.S. person; (4) I am exempt from FATCA reporting (if applicable).',
    'by_clicking': 'By clicking',
    'save_certify': 'Save & Certify',
    'you_are_electronically_signing_this_w_9': 'you are electronically signing this W-9. Your IP address and timestamp will be recorded.',
    'core_operations': 'Core Operations',
    'work_orders_1': 'Work Orders',
    'execute_your_assignments_with_efficiency': 'Execute your assignments with efficiency and precision.',
    'all_assignments': 'All Assignments',
    'assigned_tasks': 'Assigned Tasks',
    'currently_active': 'Currently Active',
    'completed_history': 'Completed History',
    'no_assignments_found': 'No assignments found',
    'your_current_view_filters_haven_t_matche': 'Your current view filters haven\'t matched any records.',
    'unit_26': 'Unit',
    'task_description_1': 'Task Description',
    'completion_evidence': 'Completion Evidence',
    'logistics_control': 'Logistics Control',
    'start_mission': 'Start Mission',
    'mark_finished': 'Mark Finished',
    'submit_invoice': 'Submit Invoice',
    'view_brief': 'View Brief',
    'notice_1': 'Notice',
    'safety_protocols_are_active_wear_authori': 'Safety protocols are active. Wear authorized PPE at all times.',
    'page_1': 'Page',
    'of_6': 'of',
    'next_4': 'Next',
    'submit_settlement': 'Submit Settlement',
    'claim_amount_for': 'Claim amount for',
    'cancel_35': 'Cancel',
    'live': 'Live',
    'sign_out_1': 'Sign Out',
    'sign_out_2': 'Sign Out',

    // Evictions
    'ev_initiated': 'Initiated',
    'ev_notice_served': 'Notice Served',
    'ev_court_filed': 'Court Filed',
    'ev_court_ruling': 'Court Ruling',
    'ev_completed': 'Completed',
    'ev_dismissed': 'Dismissed',
    'ev_notice_pay_or_quit': 'Pay or Quit',
    'ev_notice_cure_or_quit': 'Cure or Quit',
    'ev_notice_unconditional': 'Unconditional Quit',
    'ev_active_cases': 'Active Cases',
    'ev_total_owed': 'Total Owed',
    'ev_notice_type': 'Notice Type',
    'ev_amount_owed': 'Amount Owed',
    'ev_status_updated': 'Status updated',
    'ev_dismiss_case': 'Dismiss Case',
    'ev_dismiss_confirm': 'Are you sure you want to dismiss this eviction case? This cannot be undone.',
    'ev_case_dismissed': 'Eviction case dismissed',
    'ev_dismiss_failed': 'Failed to dismiss case',
    'ev_case_timeline': 'Case Timeline',
    'ev_notice_served_date': 'Notice Served',
    'ev_court_filing_date': 'Court Filing',
    'ev_court_date': 'Hearing Date',
    'ev_ruling': 'Ruling',
    'ev_ruling_date': 'Ruling Date',
    'ev_vacate_date': 'Vacate By',
    'ev_edit_notes': 'Edit Notes',
    'ev_save_notes': 'Save Notes',
    'ev_add_notes': 'Add Notes',
    'ev_notes_saved': 'Notes saved',
    'ev_save_failed': 'Failed to save',
    'filed': 'Filed',

    // Inspections
    'insp_move_in': 'Move-In',
    'insp_move_out': 'Move-Out',
    'insp_periodic': 'Periodic',
    'insp_maintenance': 'Maintenance',
    'total': 'Total',
    'draft': 'Draft',
    'completed': 'Completed',
    'signed': 'Signed',
    'all_types': 'All Types',
    'all_status': 'All Status',
    'unit_building': 'Unit / Building',
    'checklist_progress': 'Checklist Progress',
    'condition_1': 'Condition',
    'date': 'Date',

    // Violations
    'tenant_unit': 'Tenant / Unit',
    'title': 'Title',
    'severity': 'Severity',
    'fine': 'Fine',

    // Leases
    'start': 'Start',
    'end': 'End',
    'expiry': 'Expiry',
    'rent_mo': 'Rent/mo',
    'deposit': 'Deposit',
    'open_ended': 'Open-ended',

    // Renewals
    'current_rent': 'Current Rent',
    'offered_rent': 'Offered Rent',
    'risk': 'Risk',
    'offer_expires': 'Offer Expires',

    // Lease Applications
    'applicant': 'Applicant',
    'contact': 'Contact',
    'move_in': 'Move-In',
    'income': 'Income',
    'employment': 'Employment',

    // Application Links
    'total_links': 'Total Links',
    'active_links': 'Active Links',
    'total_uses': 'Total Uses',
    'generating': 'Generating...',
    'generate_link': 'Generate Link',
    'deactivate_link': 'Deactivate Link',
    'deactivate_link_confirm': 'Deactivate link "{{label}}"? It will no longer accept applications.',
    'deactivate': 'Deactivate',

    // Sales Wizard
    'back': 'Back',
    'sw_step_buyer': 'Buyer',
    'sw_step_terms': 'Terms',
    'sw_step_schedule': 'Schedule',
    'sw_step_confirm': 'Confirm',
    'creating': 'Creating...',
    'create_sale_contract': 'Create Sale Contract',
    'hash': '#',
    'due_date': 'Due Date',
    'payment': 'Payment',
    'principal': 'Principal',
    'interest': 'Interest',
    'balance': 'Balance',
    'monthly_payment': 'Monthly Payment',
    'total_interest': 'Total Interest',
    'total_cost': 'Total Cost',
    'down_payment': 'Down Payment',
    'sale_price': 'Sale Price',
    'financed_amount': 'Financed Amount',
    'interest_rate': 'Interest Rate',
    'term': 'Term',

    // Validation errors
    'val_first_name_min': 'First name must be at least 2 characters',
    'val_first_name_max': 'First name must be 50 characters or less',
    'val_last_name_min': 'Last name must be at least 2 characters',
    'val_last_name_max': 'Last name must be 50 characters or less',
    'val_username_min': 'Username must be at least 3 characters',
    'val_username_max': 'Username must be 30 characters or less',
    'val_username_no_spaces': 'Username cannot contain spaces',
    'val_email_invalid': 'Please enter a valid email address',
    'val_company_name_min': 'Company name must be at least 2 characters',
    'val_password_min': 'Password must be at least 8 characters',
    'val_password_max': 'Password must be 128 characters or less',
    'val_name_max_100': 'Name must be 100 characters or less',
    'val_close_time_required': 'Please set a closing time',
    'val_open_time_required': 'Please set an opening time',
    'val_close_after_open': 'Closing time must be after opening time',
    'val_title_max_200': 'Title must be 200 characters or less',
    'val_description_max_2000': 'Description must be 2000 characters or less',
    'val_fine_non_negative': 'Fine amount must be a non-negative number',
    'val_prospect_name_max': 'Prospect name must be 200 characters or less',
    'val_end_after_start': 'End time must be after start time',
    'val_notes_max_2000': 'Notes must be 2000 characters or less',
    'val_expiry_after_start': 'Expiry date must be after start date',
    'val_url_invalid': 'Document URL must start with http:// or https://',
    'val_notes_max_1000': 'Notes must be 1000 characters or less',
    'val_webhook_url_https': 'Webhook URL must start with https://',

    'error_loading_violations': 'Error loading violations',
    'marked_as_resolved': 'Marked as resolved',
    'error_updating_violation': 'Error updating violation',
    'title_and_notice_body_required': 'Title and notice content are required',
    'notice_issued': 'Notice issued',
    'error_issuing_notice': 'Error issuing notice',
    'search_violations': 'Search by tenant, title, or description...',
    'loading_violations': 'Loading violations...',
    'no_violations_recorded': 'No violations recorded',
    'no_status_violations': 'No {{status}} violations',
    'notice_type_required': 'Notice Type *',
    'delivery_method_required': 'Delivery Method *',
    'notice_title_required': 'Notice Title *',
    'notice_deadline_optional': 'Compliance Deadline (optional)',
    'notice_body_required': 'Notice Body *',
    'issuing': 'Issuing...',
    'issue_notice_btn': 'Issue Notice',
    'violations_count': '{{count}} violations',
    'open_tickets': 'open tickets',
    'has_balance': 'Has balance',
    'perfect_payments': 'Perfect payments',
    'risk_score': 'Risk Score',

    'failed_to_load_evictions': 'Failed to load evictions',
    'failed_to_update_status': 'Failed to update status',
    'please_select_a_tenant': 'Please select a tenant',
    'tenant_must_have_apartment': 'The selected tenant must have an assigned apartment and building to be evicted.',
    'reason_is_required': 'Reason is required',
    'eviction_case_opened': 'Eviction case opened',
    'failed_to_create_eviction': 'Failed to create eviction',

    // Work Orders page
    'wo_stat_total': 'Total',
    'wo_stat_assigned': 'Assigned',
    'wo_stat_in_progress': 'In Progress',
    'wo_stat_completed': 'Completed',
    'wo_col_title': 'Title',
    'wo_col_vendor': 'Vendor',
    'wo_col_priority': 'Priority',
    'wo_col_status': 'Status',
    'wo_col_scheduled': 'Scheduled',
    'wo_col_invoice': 'Invoice',
    'wo_col_assigned_by': 'Assigned By',
    'wo_detail_scheduled': 'Scheduled',
    'wo_detail_completed': 'Completed',
    'wo_detail_created': 'Created',
    'wo_failed_to_load': 'Failed to load work orders',
    'wo_invoice_approved': 'Invoice approved successfully!',
    'wo_confirm_approval': 'Confirm Approval',
    'wo_status_assigned': 'Assigned',
    'wo_status_in_progress': 'In Progress',
    'wo_status_on_hold': 'On Hold',
    'inv_status_received': 'Received',
    'view_detail': 'View Detail',
    'wo_failed_approve': 'Failed to approve invoice',
    'wo_failed_load_vendors': 'Failed to load vendors list',
    'wo_vendor_required': 'Vendor is required',
    'wo_title_required': 'Title is required',
    'wo_created': 'Work order created successfully',
    'wo_failed_to_create': 'Failed to create work order',
    'wo_title_placeholder': 'e.g. Repair leaked pipe in building A unit 302',
    'wo_description_placeholder': 'Provide detailed instructions for the vendor...',
    'wo_linked_id_placeholder': 'Optional linked ID',
    'wo_nothing_to_update': 'Nothing to update',
    'wo_updated': 'Work order updated',
    'wo_update_failed': 'Update failed',

    // Maintenance Schedules page
    'sch_col_title': 'Title',
    'sch_col_building': 'Building',
    'sch_col_frequency': 'Frequency',
    'sch_col_next_due': 'Next Due',
    'sch_col_est_cost': 'Est. Cost',
    'sch_col_status': 'Status',
    'sch_col_actions': 'Actions',
    'sch_error_loading': 'Error loading schedules',
    'sch_mark_complete_success': 'Marked complete, next date advanced',
    'sch_error_complete': 'Error completing schedule',
    'sch_confirm_remove': 'Remove this schedule?',
    'sch_removed': 'Schedule removed',
    'sch_error_remove': 'Error removing schedule',
    'sch_error_history': 'Error loading history',
    'sch_search_placeholder': 'Search schedules...',
    'sch_status_active': 'Active',
    'sch_status_inactive': 'Inactive',
    'sch_edit_success': 'Schedule updated',
    'sch_error_edit': 'Error updating schedule',
    'sch_edit_schedule': 'Edit Schedule',
    'sch_title_freq_due_required': 'Title, frequency, and first due date are required',
    'schedule_created': 'Schedule created',
    'sch_failed_to_create': 'Failed to create schedule',
    'sch_history_title': 'History',
    'sch_remove_title': 'Remove',
    'describe_task_placeholder': 'Describe the maintenance task...',
    'vendor_instructions_placeholder': 'Specific instructions for the vendor...',
    'freq_daily': 'Daily',
    'freq_weekly': 'Weekly',
    'freq_biweekly': 'Biweekly',
    'freq_monthly': 'Monthly',
    'freq_quarterly': 'Quarterly',
    'freq_semiannual': 'Semiannual',
    'freq_biannual': 'Biannual',
    'freq_annual': 'Annual',
    // Messages page
    'search_conversations': 'Search conversations...',
    'load_more': 'Load more',
    'no_results': 'No results found',
    'failed_to_update_document_status': 'Failed to update document status',
    // Violations Page Additions
    'hw_record_violation': '1. Record Violation',
    'hw_record_violation_desc': 'Log a violation with type, severity, and optional fine. Fine auto-charges to tenant ledger.',
    'hw_issue_notice': '2. Issue Formal Notice',
    'hw_issue_notice_desc': 'Attach a legal notice (pay-or-quit, cure-or-quit) and send via email or WhatsApp.',
    'hw_track_resolution': '3. Track Resolution',
    'hw_track_resolution_desc': 'Update status: acknowledged → escalated → resolved. Full audit trail is kept.',
    'hw_escalate': '4. Escalate if Needed',
    'hw_escalate_desc': 'Escalated violations can feed into eviction filing workflow.',
    'notice_title_placeholder': 'e.g. Pay or Quit Notice — Rent Due',
    'notice_body_placeholder': 'Enter the full text of the legal notice...',
    'failed_to_load_tenants': 'Failed to load tenants. Please check your connection.',
    'please_select_tenant': 'Please select a tenant first',
    'title_is_required': 'Title is required',
    'violation_recorded_notice_sent': 'Violation recorded — notice auto-sent to tenant',
    'violation_recorded': 'Violation recorded',
    'error_creating_violation': 'Error creating violation',
    'select_tenant_placeholder': 'Select tenant...',
    'violation_title_placeholder': 'e.g. Noise complaint — loud music after midnight',
    'violation_desc_placeholder': 'Describe the violation in detail...',
    'saving_ellipsis': 'Saving...'
,
    // Auto injected missing keys
    'violation_status_open': 'Open',
    'violation_status_acknowledged': 'Acknowledged',
    'violation_status_resolved': 'Resolved',
    'violation_status_escalated': 'Escalated',
    'violation_status_closed': 'Closed',
    'violation_type_noise': 'Noise',
    'violation_type_pets': 'Pets',
    'violation_type_damage': 'Damage',
    'violation_type_unauthorized_occupant': 'Unauthorized Occupant',
    'violation_type_parking': 'Parking',
    'violation_type_smoking': 'Smoking',
    'violation_type_cleanliness': 'Cleanliness',
    'violation_type_lease_breach': 'Lease Breach',
    'violation_type_late_payment': 'Late Payment',
    'violation_type_general': 'General',
    'violation_severity_warning': 'Warning',
    'violation_severity_minor': 'Minor',
    'violation_severity_major': 'Major',
    'violation_severity_critical': 'Critical',
    'notice_type_pay_or_quit': 'Pay or Quit',
    'notice_type_cure_or_quit': 'Cure or Quit',
    'notice_type_unconditional_quit': 'Unconditional Quit',
    'notice_type_entry_notice': 'Entry Notice',
    'notice_type_non_renewal': 'Non Renewal',
    'notice_type_eviction_filing': 'Eviction Filing',
    'notice_type_lease_termination': 'Lease Termination',
    'notice_type_rent_increase': 'Rent Increase',
    'notice_type_general': 'General',
    'delivery_method_email': 'Email',
    'delivery_method_whatsapp': 'WhatsApp',
    'delivery_method_hand_delivered': 'Hand Delivered',
    'delivery_method_certified_mail': 'Certified Mail',
    'delivery_method_posted_on_door': 'Posted on Door',
    'delivery_method_sms': 'SMS',

    // Auto injected missing keys
    'ev_reason_placeholder': 'Non-payment of rent, lease violation, etc.',
    'select_placeholder': 'Select...',
    'opening_ellipsis': 'Opening...',

    // Auto injected missing keys
    'err_loading_tenants': 'Error loading tenants',
    'identity_link_opened': 'Identity verification link opened — share it with the tenant',
    'failed_identity_verification': 'Failed to start identity verification',
    'fcra_consent_required_toast': 'You must confirm FCRA consent before running a background check',
    'bg_invitation_sent': 'Background check invitation sent to tenant\'s email',
    'failed_bg_check': 'Failed to start background check',
    'screening_decision_set': 'Screening decision set to: ',
    'failed_to_save_decision': 'Failed to save decision',
    'search_tenants_placeholder': 'Search tenants...',
    'loading_ellipsis': 'Loading...',
    'loading_screening_data': 'Loading screening data...',
    'dob_optional': 'Date of Birth (optional)',
    'zipcode_optional': 'ZIP Code (optional)',
    'state_optional': 'State (optional)',
    'country_label': 'Country',
    'sending_ellipsis': 'Sending...',
    'send_to_tenant': 'Send to Tenant',
    'decision_label': 'Decision',
    'add_notes_decision_placeholder': 'Add any notes about this decision...',
    'save_decision': 'Save Decision',
    'badge_not_started': 'Not Started',
    'badge_verified': 'Verified',
    'badge_action_needed': 'Action Needed',
    'badge_canceled': 'Canceled',
    'badge_clear': 'Clear',
    'badge_consider': 'Consider',
    'badge_dispute': 'Dispute',
    'badge_suspended': 'Suspended',
    'badge_approved': 'Approved',
    'badge_rejected': 'Rejected',
    'badge_manual_review': 'Manual Review',
}
};
